import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
};

export type NexoyaAccuracyBucket = {
  __typename?: 'AccuracyBucket';
  contentCount: Scalars['Int']['output'];
  threshold: Scalars['Int']['output'];
};

export type NexoyaAdAccountMetricTotal = {
  __typename?: 'AdAccountMetricTotal';
  adAccount: NexoyaContentV2;
  comparisonChangePercent?: Maybe<NexoyaPerformanceMetric>;
  comparisonTotal?: Maybe<NexoyaPerformanceMetric>;
  contents: Array<NexoyaContentMetricTotal>;
  total: NexoyaPerformanceMetric;
};

export type NexoyaAdSpendRange = {
  __typename?: 'AdSpendRange';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

export type NexoyaAdSpendRangeInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type NexoyaAggregateMetricTotal = {
  __typename?: 'AggregateMetricTotal';
  comparisonChangePercent?: Maybe<NexoyaPerformanceMetric>;
  comparisonTotal?: Maybe<NexoyaPerformanceMetric>;
  contents: Array<NexoyaContentMetricTotal>;
  total: NexoyaPerformanceMetric;
};

export type NexoyaAnalyticsSearchDimension = {
  __typename?: 'AnalyticsSearchDimension';
  dimensionName: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type NexoyaAnalyticsSearchDimensionInput = {
  dimensionName: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type NexoyaApplicableAttributionRule = {
  __typename?: 'ApplicableAttributionRule';
  attributionRule: NexoyaAttributionRule;
  isApplied: Scalars['Boolean']['output'];
};

export type NexoyaApplicableContentRule = {
  __typename?: 'ApplicableContentRule';
  contentRule: NexoyaContentRule;
  isApplied: Scalars['Boolean']['output'];
};

export type NexoyaApplicableImpactGroupRule = {
  __typename?: 'ApplicableImpactGroupRule';
  impactGroupRule: NexoyaImpactGroupRule;
  isApplied: Scalars['Boolean']['output'];
};

export type NexoyaAppliedOptimizationDailyBudget = {
  __typename?: 'AppliedOptimizationDailyBudget';
  budgetAmount: Scalars['Float']['output'];
  date: Scalars['Date']['output'];
};

export type NexoyaApplyRulesToDiscoveredContentsMutationResponse = {
  __typename?: 'ApplyRulesToDiscoveredContentsMutationResponse';
  appliedAttributionRules: Scalars['Int']['output'];
  appliedContentRules: Scalars['Int']['output'];
  appliedImpactGroupRules: Scalars['Int']['output'];
};

export type NexoyaApplyRulesToDiscoveredContentsRulesMapInput = {
  attributionRuleId?: InputMaybe<Scalars['Float']['input']>;
  contentRuleId?: InputMaybe<Scalars['Float']['input']>;
  discoveredContentId: Scalars['Float']['input'];
  impactGroupRuleId?: InputMaybe<Scalars['Float']['input']>;
};

export enum NexoyaArgumentAuthorizationRules {
  AttributionModelIsPartOfTeam = 'AttributionModelIsPartOfTeam',
  AttributionRuleIsPartOfTeam = 'AttributionRuleIsPartOfTeam',
  BudgetItemIsPartOfTeam = 'BudgetItemIsPartOfTeam',
  CalculatedMetricParameterIsPartOfTeam = 'CalculatedMetricParameterIsPartOfTeam',
  CollectionIsPartOfTeam = 'CollectionIsPartOfTeam',
  ContentLabelCategoryIsPartOfTeam = 'ContentLabelCategoryIsPartOfTeam',
  ContentRuleIsPartOfTeam = 'ContentRuleIsPartOfTeam',
  CurrencyExchangeTimeframeIsPartOfTeam = 'CurrencyExchangeTimeframeIsPartOfTeam',
  FileIsPartOfAttributionModel = 'FileIsPartOfAttributionModel',
  FunnelStepIsPartOfTeam = 'FunnelStepIsPartOfTeam',
  FunnelStepMappingPresetIsPartOfTeam = 'FunnelStepMappingPresetIsPartOfTeam',
  ImpactGroupIsPartOfTeam = 'ImpactGroupIsPartOfTeam',
  ImpactGroupRuleIsPartOfTeam = 'ImpactGroupRuleIsPartOfTeam',
  IsUserThemselves = 'IsUserThemselves',
  KpisCollectionsBelongToTeam = 'KpisCollectionsBelongToTeam',
  LabelIsPartOfTeam = 'LabelIsPartOfTeam',
  ManyAttributionRulesArePartOfTeam = 'ManyAttributionRulesArePartOfTeam',
  ManyContentRulesArePartOfTeam = 'ManyContentRulesArePartOfTeam',
  ManyImpactGroupRulesArePartOfTeam = 'ManyImpactGroupRulesArePartOfTeam',
  OptimizationIsPartOfTeam = 'OptimizationIsPartOfTeam',
  PerformanceViewBookmarkIsPartOfTeam = 'PerformanceViewBookmarkIsPartOfTeam',
  PerformanceViewLayoutIsPartOfTeam = 'PerformanceViewLayoutIsPartOfTeam',
  PortfolioContentIsPartOfTeam = 'PortfolioContentIsPartOfTeam',
  PortfolioEventIsPartOfTeam = 'PortfolioEventIsPartOfTeam',
  PortfolioEventsArePartOfTeam = 'PortfolioEventsArePartOfTeam',
  PortfolioIsPartOfTeam = 'PortfolioIsPartOfTeam',
  PortfolioTargetItemIsPartOfTeam = 'PortfolioTargetItemIsPartOfTeam',
  ScenarioIsPartOfTeam = 'ScenarioIsPartOfTeam',
  SimulationIsPartOfTeam = 'SimulationIsPartOfTeam'
}

export type NexoyaAssignContentsAndRulesToPortfolioEventsResponse = {
  __typename?: 'AssignContentsAndRulesToPortfolioEventsResponse';
  portfolioEvents: Array<NexoyaPortfolioEvent>;
};

export type NexoyaAttributionMetricTotal = {
  __typename?: 'AttributionMetricTotal';
  attributed: Scalars['Float']['output'];
  changePercent: Scalars['Float']['output'];
  measured: Scalars['Float']['output'];
};

export type NexoyaAttributionModel = {
  __typename?: 'AttributionModel';
  attributionModelId: Scalars['String']['output'];
  channelFilters: Array<NexoyaAttributionModelChannelFilter>;
  createdAt: Scalars['DateTime']['output'];
  customization: NexoyaAttributionModelCustomization;
  exportEnd?: Maybe<Scalars['Date']['output']>;
  exportStart: Scalars['Date']['output'];
  files: Array<NexoyaAttributionModelFile>;
  ga4Filters: NexoyaAttributionModelGa4Filters;
  name: Scalars['String']['output'];
  status: NexoyaAttributionModelStatus;
  targetMetric: Scalars['String']['output'];
  targetMetricType: NexoyaAttributionModelTargetMetricType;
  teamId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type NexoyaAttributionModelChannelFilter = {
  __typename?: 'AttributionModelChannelFilter';
  adAccountIds: Array<Scalars['Float']['output']>;
  contentFilters: Array<NexoyaContentFilter>;
  conversions: Array<NexoyaAttributionModelConversion>;
  providerId: Scalars['Int']['output'];
};

export type NexoyaAttributionModelChannelFilterInput = {
  adAccountIds: Array<Scalars['Float']['input']>;
  contentFilters: Array<NexoyaContentFilterInput>;
  conversions: Array<NexoyaAttributionModelConversionInput>;
  providerId: Scalars['Int']['input'];
};

export type NexoyaAttributionModelConnection = {
  __typename?: 'AttributionModelConnection';
  edges: Array<NexoyaAttributionModelEdge>;
  pageInfo: NexoyaPageInfo;
  totalPages: Scalars['Int']['output'];
};

export type NexoyaAttributionModelConversion = {
  __typename?: 'AttributionModelConversion';
  accountConversionIds: Array<Scalars['String']['output']>;
  conversionMetricId?: Maybe<Scalars['Int']['output']>;
  conversionValueMetricId?: Maybe<Scalars['Int']['output']>;
  metricAlias: Scalars['String']['output'];
};

export type NexoyaAttributionModelConversionInput = {
  accountConversionIds: Array<Scalars['String']['input']>;
  conversionMetricId?: InputMaybe<Scalars['Int']['input']>;
  conversionValueMetricId?: InputMaybe<Scalars['Int']['input']>;
  metricAlias: Scalars['String']['input'];
};

export type NexoyaAttributionModelCustomization = {
  __typename?: 'AttributionModelCustomization';
  ignoredPortfolioIds: Array<Scalars['Float']['output']>;
  labelColumnAlias?: Maybe<Scalars['String']['output']>;
  portfolioColumnAlias?: Maybe<Scalars['String']['output']>;
};

export type NexoyaAttributionModelCustomizationInput = {
  ignoredPortfolioIds: Array<Scalars['Float']['input']>;
  labelColumnAlias?: InputMaybe<Scalars['String']['input']>;
  portfolioColumnAlias?: InputMaybe<Scalars['String']['input']>;
};

export type NexoyaAttributionModelEdge = {
  __typename?: 'AttributionModelEdge';
  cursor: Scalars['String']['output'];
  node: NexoyaAttributionModel;
};

export type NexoyaAttributionModelFile = {
  __typename?: 'AttributionModelFile';
  attributionModelFileId: Scalars['Float']['output'];
  attributionModelId: Scalars['String']['output'];
  fileBlob: NexoyaFile;
  owner: NexoyaAttributionModelFileOwnerType;
  scope: NexoyaAttributionModelFileScope;
};

export enum NexoyaAttributionModelFileOwnerType {
  System = 'SYSTEM',
  User = 'USER'
}

export enum NexoyaAttributionModelFileScope {
  Export = 'EXPORT',
  Mmm = 'MMM',
  Mta = 'MTA',
  Results = 'RESULTS',
  Sales = 'SALES'
}

export type NexoyaAttributionModelGa4Filters = {
  __typename?: 'AttributionModelGa4Filters';
  dimensions: Array<Scalars['String']['output']>;
  metricIds: Array<Scalars['Int']['output']>;
};

export type NexoyaAttributionModelGa4FiltersInput = {
  dimensions: Array<Scalars['String']['input']>;
  metricIds: Array<Scalars['Int']['input']>;
};

export enum NexoyaAttributionModelStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  Exporting = 'EXPORTING',
  ExportReady = 'EXPORT_READY',
  InReview = 'IN_REVIEW',
  Publishing = 'PUBLISHING',
  Rejected = 'REJECTED',
  Running = 'RUNNING',
  Synced = 'SYNCED',
  Syncing = 'SYNCING'
}

export enum NexoyaAttributionModelTargetMetricType {
  Monetary = 'MONETARY',
  Volume = 'VOLUME'
}

export type NexoyaAttributionOptimizedMetric = {
  __typename?: 'AttributionOptimizedMetric';
  attributed?: Maybe<Scalars['Float']['output']>;
  changePercent?: Maybe<Scalars['Float']['output']>;
  measured?: Maybe<Scalars['Float']['output']>;
};

export type NexoyaAttributionRule = {
  __typename?: 'AttributionRule';
  appliedDiscoveredContents: Array<NexoyaDiscoveredContent>;
  attributionRuleId: Scalars['Float']['output'];
  factors: Array<NexoyaAttributionRuleFactor>;
  filters: NexoyaAttributionRuleFilters;
  matchingDiscoveredContentsCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  portfolioId: Scalars['Float']['output'];
  teamId: Scalars['Float']['output'];
};

export type NexoyaAttributionRuleFactor = {
  __typename?: 'AttributionRuleFactor';
  attributionRuleFactorId: Scalars['Float']['output'];
  source: NexoyaAttributionRuleFactorSource;
  start: Scalars['Date']['output'];
  value: Scalars['Float']['output'];
};

export type NexoyaAttributionRuleFactorInput = {
  source: NexoyaAttributionRuleFactorSourceInput;
  start: Scalars['Date']['input'];
  value: Scalars['Float']['input'];
};

export type NexoyaAttributionRuleFactorSource = {
  __typename?: 'AttributionRuleFactorSource';
  accountConversionIds?: Maybe<Array<Scalars['String']['output']>>;
  conversionMetricId?: Maybe<Scalars['Int']['output']>;
  conversionName?: Maybe<Scalars['String']['output']>;
  metricId?: Maybe<Scalars['Int']['output']>;
  type: NexoyaAttributionRuleFactorSourceType;
};

export type NexoyaAttributionRuleFactorSourceInput = {
  accountConversionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  conversionMetricId?: InputMaybe<Scalars['Int']['input']>;
  conversionName?: InputMaybe<Scalars['String']['input']>;
  metricId?: InputMaybe<Scalars['Int']['input']>;
  type: NexoyaAttributionRuleFactorSourceType;
};

export enum NexoyaAttributionRuleFactorSourceType {
  CustomConversion = 'CUSTOM_CONVERSION',
  Metric = 'METRIC'
}

export type NexoyaAttributionRuleFilters = {
  __typename?: 'AttributionRuleFilters';
  adAccountIds: Array<Scalars['Float']['output']>;
  contentFilters: Array<NexoyaContentFilter>;
  providerId: Scalars['Int']['output'];
};

export type NexoyaAttributionRuleFiltersInput = {
  adAccountIds: Array<Scalars['Float']['input']>;
  contentFilters: Array<NexoyaContentFilterInput>;
  providerId: Scalars['Int']['input'];
};

export type NexoyaAttributionRuleMetricTotal = {
  __typename?: 'AttributionRuleMetricTotal';
  attributionRule: NexoyaAttributionRule;
  comparisonChangePercent?: Maybe<NexoyaPerformanceMetric>;
  comparisonTotal?: Maybe<NexoyaPerformanceMetric>;
  contents: Array<NexoyaContentMetricTotal>;
  total: NexoyaPerformanceMetric;
};

export type NexoyaAttributionRulePerformanceTotal = {
  __typename?: 'AttributionRulePerformanceTotal';
  attributionRule: NexoyaAttributionRule;
  value: NexoyaAttributionMetricTotal;
};

export type NexoyaAttributionRuleUpdateFiltersPreviewQueryResponse = {
  __typename?: 'AttributionRuleUpdateFiltersPreviewQueryResponse';
  newMatchingDiscoveredContents: Array<Maybe<NexoyaDiscoveredContent>>;
  noLongerMatchingDiscoveredContents: Array<Maybe<NexoyaDiscoveredContent>>;
};

export type NexoyaAuthZDirectiveCompositeRulesInput = {
  and?: InputMaybe<Array<InputMaybe<NexoyaAuthZRules>>>;
  not?: InputMaybe<NexoyaAuthZRules>;
  or?: InputMaybe<Array<InputMaybe<NexoyaAuthZRules>>>;
};

export type NexoyaAuthZDirectiveDeepCompositeRulesInput = {
  and?: InputMaybe<Array<InputMaybe<NexoyaAuthZDirectiveDeepCompositeRulesInput>>>;
  id?: InputMaybe<NexoyaAuthZRules>;
  not?: InputMaybe<NexoyaAuthZDirectiveDeepCompositeRulesInput>;
  or?: InputMaybe<Array<InputMaybe<NexoyaAuthZDirectiveDeepCompositeRulesInput>>>;
};

export enum NexoyaAuthZRules {
  CanUseAdminRole = 'CanUseAdminRole',
  HasCollectionAccessToKpis = 'HasCollectionAccessToKpis',
  HasSupportRole = 'HasSupportRole',
  HasUserId = 'HasUserId',
  IsActiveUser = 'IsActiveUser',
  IsAdmin = 'IsAdmin',
  IsM2MUser = 'IsM2MUser',
  IsMemberOfCollectionTeam = 'IsMemberOfCollectionTeam',
  IsMemberOfOrg = 'IsMemberOfOrg',
  IsMemberOfTeam = 'IsMemberOfTeam',
  IsOwnUserId = 'IsOwnUserId',
  IsPartOfTeamOptional = 'IsPartOfTeamOptional',
  ShareUserHasWriteAccess = 'ShareUserHasWriteAccess',
  ShareUserHasWriteAccessNoTeamIdCollection = 'ShareUserHasWriteAccessNoTeamIdCollection',
  ShareUserHasWriteAccessNoTeamIdCollectionFromInput = 'ShareUserHasWriteAccessNoTeamIdCollectionFromInput',
  ShareUserHasWriteAccessNoTeamIdCustomKpi = 'ShareUserHasWriteAccessNoTeamIdCustomKPI',
  ShareUserHasWriteAccessNoTeamIdReport = 'ShareUserHasWriteAccessNoTeamIdReport',
  TeamHasReportAccess = 'TeamHasReportAccess',
  UserHasCustomKpiAccess = 'UserHasCustomKpiAccess',
  UserHasReportAccess = 'UserHasReportAccess'
}

export type NexoyaBiddingStrategy = {
  __typename?: 'BiddingStrategy';
  applicationDelta?: Maybe<Scalars['Float']['output']>;
  currentTcpa?: Maybe<Scalars['Float']['output']>;
  currentTroas?: Maybe<Scalars['Float']['output']>;
  dailyBudgetChange?: Maybe<Scalars['Float']['output']>;
  type: NexoyaBiddingStrategyType;
  value?: Maybe<Scalars['Float']['output']>;
};

/**
 * Realized performance of a content before the optimization, to compare against its bidding strategy target.
 * Based on the channel's cost, conversions and conversion value metrics.
 */
export type NexoyaBiddingStrategyPerformance = {
  __typename?: 'BiddingStrategyPerformance';
  /** Cost per acquisition, null if there were no conversions */
  cpa?: Maybe<Scalars['Float']['output']>;
  dateFrom: Scalars['Date']['output'];
  dateTo: Scalars['Date']['output'];
  /** Return on ad spend in whole %, null if there was no cost */
  roas?: Maybe<Scalars['Float']['output']>;
};

export enum NexoyaBiddingStrategyType {
  BidCap = 'BID_CAP',
  CostCap = 'COST_CAP',
  MaximizeConversions = 'MAXIMIZE_CONVERSIONS',
  MaximizeConversionValue = 'MAXIMIZE_CONVERSION_VALUE',
  Other = 'OTHER',
  TargetCpa = 'TARGET_CPA',
  TargetRoas = 'TARGET_ROAS'
}

export type NexoyaBudgetDailyItem = {
  __typename?: 'BudgetDailyItem';
  budgetAmount: Scalars['Float']['output'];
  date: Scalars['Date']['output'];
};

export enum NexoyaBudgetDeltaHandlingPolicy {
  BudgetApplication = 'BUDGET_APPLICATION',
  EndOfMonth = 'END_OF_MONTH',
  Ignore = 'IGNORE',
  PortfolioLifetime = 'PORTFOLIO_LIFETIME',
  WithinCurrentMonth = 'WITHIN_CURRENT_MONTH'
}

export type NexoyaBudgetItem = {
  __typename?: 'BudgetItem';
  budgetAmount: Scalars['Float']['output'];
  budgetDailyItems: Array<NexoyaBudgetDailyItem>;
  budgetItemId: Scalars['Float']['output'];
  endDate: Scalars['Date']['output'];
  name: Scalars['String']['output'];
  pacing: NexoyaPacingType;
  spendSoFar?: Maybe<Scalars['Float']['output']>;
  startDate: Scalars['Date']['output'];
  status: NexoyaBudgetItemStatus;
  suspendedDate?: Maybe<Scalars['Date']['output']>;
};

export enum NexoyaBudgetItemStatus {
  Active = 'ACTIVE',
  ActiveNoOptimization = 'ACTIVE_NO_OPTIMIZATION',
  Past = 'PAST',
  Planned = 'PLANNED'
}

export type NexoyaBudgetProposal = {
  __typename?: 'BudgetProposal';
  budgetProposalData: Array<NexoyaBudgetProposalData>;
  optimizationId: Scalars['Int']['output'];
  portfolio: NexoyaPortfolioSummary;
  status: NexoyaBudgetProposalStatus;
  timestampApplied?: Maybe<Scalars['DateTime']['output']>;
  timestampCreated: Scalars['DateTime']['output'];
};


export type NexoyaBudgetProposalBudgetProposalDataArgs = {
  applicationType?: InputMaybe<NexoyaBudgetProposalDataApplicationType>;
};

export type NexoyaBudgetProposalConnection = {
  __typename?: 'BudgetProposalConnection';
  edges: Array<NexoyaBudgetProposalEdge>;
  pageInfo: NexoyaPageInfo;
};

export type NexoyaBudgetProposalData = {
  __typename?: 'BudgetProposalData';
  applicationType: NexoyaBudgetProposalDataApplicationType;
  /** @deprecated Use currency fields instead */
  biddingStrategyChangePercent: Scalars['Float']['output'];
  biddingStrategyWillBeApplied: Scalars['Boolean']['output'];
  /** @deprecated Use currency fields instead */
  budgetType?: Maybe<NexoyaBudgetType>;
  budgetWillBeApplied: Scalars['Boolean']['output'];
  channelCurrency: NexoyaBudgetProposalDataChannelCurrency;
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use currency fields instead */
  initialBiddingStrategy?: Maybe<NexoyaBiddingStrategy>;
  /** @deprecated Use currency fields instead */
  initialBudget?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use currency fields instead */
  initialBudgetDaily?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use currency fields instead */
  lifetimeBudget?: Maybe<NexoyaLifetimeBudget>;
  portfolioContentId: Scalars['Float']['output'];
  /** @deprecated Use currency fields instead */
  proposedBiddingStrategy: NexoyaProposedBiddingStrategy;
  /** @deprecated Use currency fields instead */
  proposedBudget: Scalars['Float']['output'];
  teamCurrency: NexoyaBudgetProposalDataTeamCurrency;
  timestampApplied?: Maybe<Scalars['DateTime']['output']>;
};

export enum NexoyaBudgetProposalDataApplicationType {
  Auto = 'AUTO',
  Manual = 'MANUAL',
  SkipFromProposal = 'SKIP_FROM_PROPOSAL'
}

export type NexoyaBudgetProposalDataChannelCurrency = {
  __typename?: 'BudgetProposalDataChannelCurrency';
  biddingStrategyChangePercent: Scalars['Float']['output'];
  budgetType?: Maybe<NexoyaBudgetType>;
  initialBiddingStrategy?: Maybe<NexoyaBiddingStrategy>;
  initialBudget?: Maybe<Scalars['Float']['output']>;
  initialBudgetDaily?: Maybe<Scalars['Float']['output']>;
  lifetimeBudget?: Maybe<NexoyaLifetimeBudget>;
  proposedBiddingStrategy: NexoyaProposedBiddingStrategy;
  proposedBudget: Scalars['Float']['output'];
};

export type NexoyaBudgetProposalDataTeamCurrency = {
  __typename?: 'BudgetProposalDataTeamCurrency';
  biddingStrategyChangePercent: Scalars['Float']['output'];
  budgetChangePercent?: Maybe<Scalars['Float']['output']>;
  budgetType?: Maybe<NexoyaBudgetType>;
  initialBiddingStrategy?: Maybe<NexoyaBiddingStrategy>;
  /** Realized performance over the last 28 days before the optimization start, null if there is no initial bidding strategy or the channel is not supported */
  initialBiddingStrategyPerformance?: Maybe<NexoyaBiddingStrategyPerformance>;
  initialBudget?: Maybe<Scalars['Float']['output']>;
  initialBudgetDaily?: Maybe<Scalars['Float']['output']>;
  lifetimeBudget?: Maybe<NexoyaLifetimeBudget>;
  proposedBiddingStrategy: NexoyaProposedBiddingStrategy;
  proposedBudget: Scalars['Float']['output'];
};

export type NexoyaBudgetProposalEdge = {
  __typename?: 'BudgetProposalEdge';
  cursor: Scalars['String']['output'];
  node: NexoyaBudgetProposal;
};

export enum NexoyaBudgetProposalStatus {
  Cancelled = 'CANCELLED',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type NexoyaBudgetReallocation = {
  __typename?: 'BudgetReallocation';
  dates: Array<Maybe<NexoyaBudgetReallocationDate>>;
  pastBudget: Scalars['Float']['output'];
  pastSpend: Scalars['Float']['output'];
};

export type NexoyaBudgetReallocationDate = {
  __typename?: 'BudgetReallocationDate';
  budgetAmount: Scalars['Float']['output'];
  date: Scalars['Date']['output'];
};

export enum NexoyaBudgetType {
  Daily = 'DAILY',
  Lifetime = 'LIFETIME'
}

export type NexoyaBulkCreatePortfolioEventInput = {
  category: NexoyaEventCategory;
  description?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['Date']['input'];
  impact: NexoyaEventImpact;
  name: Scalars['String']['input'];
  start: Scalars['Date']['input'];
};

export type NexoyaBulkCreatePortfolioEventsMutationResponse = {
  __typename?: 'BulkCreatePortfolioEventsMutationResponse';
  portfolioEvents: Array<NexoyaPortfolioEvent>;
};

export type NexoyaBulkUpdatePortfolioEventInput = {
  category: NexoyaEventCategory;
  description?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['Date']['input'];
  impact: NexoyaEventImpact;
  name: Scalars['String']['input'];
  start: Scalars['Date']['input'];
};

export type NexoyaBulkUpdatePortfolioEventsMutationResponse = {
  __typename?: 'BulkUpdatePortfolioEventsMutationResponse';
  portfolioEvents: Array<NexoyaPortfolioEvent>;
};

export type NexoyaCkSearch = {
  __typename?: 'CKSearch';
  measurement_id?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  provider_id?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  query?: Maybe<Scalars['String']['output']>;
  sumOnly?: Maybe<Scalars['Boolean']['output']>;
};

export type NexoyaCkSearchInput = {
  measurement_id?: InputMaybe<Array<Scalars['Int']['input']>>;
  provider_id?: InputMaybe<Array<Scalars['Int']['input']>>;
  query: Scalars['String']['input'];
  sumOnly: Scalars['Boolean']['input'];
};

export enum NexoyaCalcType {
  Avg = 'avg',
  Div = 'div',
  Max = 'max',
  Min = 'min',
  Mul = 'mul',
  Sum = 'sum'
}

export type NexoyaCalculatedMetricFormulaElement = {
  __typename?: 'CalculatedMetricFormulaElement';
  name: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type NexoyaCalculatedMetricFormulaPreviewResponse = {
  __typename?: 'CalculatedMetricFormulaPreviewResponse';
  elements: Array<NexoyaCalculatedMetricFormulaElement>;
  result: Scalars['Float']['output'];
};

export type NexoyaCalculatedMetricOperandTimeSeries = {
  __typename?: 'CalculatedMetricOperandTimeSeries';
  calculatedMetricFormulaElementIndex: Scalars['Int']['output'];
  contentId: Scalars['Float']['output'];
  funnelStepId: Scalars['Float']['output'];
  values: Array<NexoyaDailyTimeSeriesDataPoint>;
};

export type NexoyaCalculatedMetricParameter = {
  __typename?: 'CalculatedMetricParameter';
  calculatedMetricParameterId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rulesUsing: Array<NexoyaContentRule>;
  staticValue?: Maybe<Scalars['Float']['output']>;
  teamId: Scalars['Int']['output'];
  timeVaryingValues?: Maybe<Array<NexoyaCalculatedMetricTimeVaryingParameterValue>>;
  type: NexoyaCalculatedMetricParameterType;
  unit: NexoyaCalculatedMetricParameterUnit;
};

export enum NexoyaCalculatedMetricParameterType {
  Static = 'STATIC',
  TimeVarying = 'TIME_VARYING'
}

export enum NexoyaCalculatedMetricParameterUnit {
  Currency = 'CURRENCY',
  Percentage = 'PERCENTAGE',
  Unit = 'UNIT'
}

export type NexoyaCalculatedMetricTimeVaryingParameterValue = {
  __typename?: 'CalculatedMetricTimeVaryingParameterValue';
  start: Scalars['Date']['output'];
  value: Scalars['Float']['output'];
};

export type NexoyaCalculatedMetricTimeVaryingParameterValueInput = {
  start: Scalars['Date']['input'];
  value: Scalars['Float']['input'];
};

export type NexoyaChannelReportContent = {
  __typename?: 'ChannelReportContent';
  kpis?: Maybe<Array<NexoyaMeasurement>>;
  provider?: Maybe<NexoyaProvider>;
};

export type NexoyaCkBulkCreateInput = {
  calc_type: NexoyaCalcType;
  description?: InputMaybe<Scalars['String']['input']>;
  kpis?: InputMaybe<Array<NexoyaCkKpiInput>>;
  name: Scalars['String']['input'];
  search?: InputMaybe<NexoyaCkSearchInput>;
};

export type NexoyaCkKpiInput = {
  collection_id?: InputMaybe<Scalars['Float']['input']>;
  default_value?: InputMaybe<Scalars['Float']['input']>;
  measurement_id?: InputMaybe<Scalars['Int']['input']>;
};

export type NexoyaCollection = {
  __typename?: 'Collection';
  admin_url?: Maybe<Scalars['String']['output']>;
  child_collections?: Maybe<Array<Maybe<NexoyaCollection>>>;
  collectionType: NexoyaCollectionType;
  collection_id: Scalars['Float']['output'];
  creation_date?: Maybe<Scalars['DateTime']['output']>;
  detection_date?: Maybe<Scalars['DateTime']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  measurements?: Maybe<Array<Maybe<NexoyaMeasurement>>>;
  metadata?: Maybe<Array<Maybe<NexoyaMetadata>>>;
  parent_collection?: Maybe<NexoyaCollection>;
  parent_collection_id?: Maybe<Scalars['Float']['output']>;
  platform_identifier?: Maybe<Scalars['JSON']['output']>;
  provider?: Maybe<NexoyaProvider>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};


export type NexoyaCollectionChild_CollectionsArgs = {
  first?: InputMaybe<Scalars['Float']['input']>;
};


export type NexoyaCollectionMeasurementsArgs = {
  dateFrom: Scalars['DateTime']['input'];
  dateTo: Scalars['DateTime']['input'];
  metric_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type NexoyaCollectionMetadataArgs = {
  metadataTypes?: InputMaybe<Array<InputMaybe<NexoyaMetadataType>>>;
};

export type NexoyaCollectionConnection = {
  __typename?: 'CollectionConnection';
  edges: Array<NexoyaCollectionEdges>;
  pageInfo: NexoyaPageInfo;
};

export type NexoyaCollectionEdges = {
  __typename?: 'CollectionEdges';
  cursor: Scalars['String']['output'];
  node: NexoyaCollection;
};

export type NexoyaCollectionInput = {
  active: Scalars['Boolean']['input'];
  admin_url?: InputMaybe<Scalars['String']['input']>;
  collection_id?: InputMaybe<Scalars['Float']['input']>;
  creation_date?: InputMaybe<Scalars['DateTime']['input']>;
  detection_date: Scalars['DateTime']['input'];
  identifier?: InputMaybe<Scalars['String']['input']>;
  parent_collection_id?: InputMaybe<Scalars['Float']['input']>;
  provider_id?: InputMaybe<Scalars['Int']['input']>;
  team_id: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type NexoyaCollectionType = {
  __typename?: 'CollectionType';
  collection_type_id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type NexoyaComputeBudgetProposalBudgetsReturnType = {
  __typename?: 'ComputeBudgetProposalBudgetsReturnType';
  failedEntryIdsWithError?: Maybe<Array<NexoyaFailedEntryError>>;
};

export type NexoyaContent = {
  __typename?: 'Content';
  admin_url?: Maybe<Scalars['String']['output']>;
  content_id: Scalars['Float']['output'];
  content_type: NexoyaContentType;
  creation_date?: Maybe<Scalars['DateTime']['output']>;
  detection_date?: Maybe<Scalars['DateTime']['output']>;
  metadata?: Maybe<Array<Maybe<NexoyaMetadata>>>;
  metrics?: Maybe<Array<Maybe<NexoyaMetric>>>;
  platform_identifier?: Maybe<Scalars['JSON']['output']>;
  provider?: Maybe<NexoyaProvider>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};


export type NexoyaContentMetadataArgs = {
  metadataTypes?: InputMaybe<Array<InputMaybe<NexoyaMetadataType>>>;
};


export type NexoyaContentMetricsArgs = {
  dateFrom: Scalars['DateTime']['input'];
  dateTo: Scalars['DateTime']['input'];
  metric_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type NexoyaContentBiddingStrategy = {
  __typename?: 'ContentBiddingStrategy';
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type NexoyaContentBiddingStrategyValueHistory = {
  __typename?: 'ContentBiddingStrategyValueHistory';
  biddingStrategyType: Scalars['String']['output'];
  biddingStrategyValueHistory: Array<NexoyaDailyTimeSeriesDataPointOptional>;
  contentId: Scalars['Float']['output'];
};

export type NexoyaContentBudget = {
  __typename?: 'ContentBudget';
  shared?: Maybe<Scalars['Boolean']['output']>;
  type: NexoyaBudgetType;
  value: Scalars['Float']['output'];
};

export type NexoyaContentConnection = {
  __typename?: 'ContentConnection';
  edges: Array<NexoyaContentEdges>;
  pageInfo: NexoyaPageInfo;
};

export type NexoyaContentEdges = {
  __typename?: 'ContentEdges';
  cursor: Scalars['String']['output'];
  node: NexoyaContent;
};

export type NexoyaContentFilter = {
  __typename?: 'ContentFilter';
  fieldName: NexoyaContentFilterFieldName;
  operator: NexoyaContentFilterOperator;
  value?: Maybe<NexoyaContentFilterValue>;
};

export enum NexoyaContentFilterFieldName {
  BidStrategy = 'bidStrategy',
  BudgetType = 'budgetType',
  CampaignObjective = 'campaignObjective',
  ContentId = 'contentId',
  ContentType = 'contentType',
  DisplayProviderId = 'displayProviderId',
  EarliestMeasurementDataDaysAgo = 'earliestMeasurementDataDaysAgo',
  EndDate = 'endDate',
  LatestMeasurementDataDate = 'latestMeasurementDataDate',
  Objective = 'objective',
  ParentContentId = 'parentContentId',
  ParentTitle = 'parentTitle',
  SourceProviderId = 'sourceProviderId',
  StartDate = 'startDate',
  Status = 'status',
  TeamId = 'teamId',
  Title = 'title'
}

export type NexoyaContentFilterInput = {
  fieldName: NexoyaContentFilterFieldName;
  operator: NexoyaContentFilterOperator;
  value: NexoyaContentFilterValueInput;
};

export enum NexoyaContentFilterOperator {
  Contains = 'contains',
  Eq = 'eq',
  Gte = 'gte',
  Lte = 'lte',
  Ne = 'ne',
  NotContains = 'notContains'
}

export type NexoyaContentFilterValue = {
  __typename?: 'ContentFilterValue';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
  numberArr?: Maybe<Array<Scalars['Float']['output']>>;
  string?: Maybe<Scalars['String']['output']>;
  stringArr?: Maybe<Array<Scalars['String']['output']>>;
};

export type NexoyaContentFilterValueInput = {
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  number?: InputMaybe<Scalars['Float']['input']>;
  numberArr?: InputMaybe<Array<Scalars['Float']['input']>>;
  string?: InputMaybe<Scalars['String']['input']>;
  stringArr?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NexoyaContentLabelAssignment = {
  __typename?: 'ContentLabelAssignment';
  assignment?: Maybe<NexoyaContentLabelCategoryValue>;
  content: NexoyaContentV2;
  contentLabelCategory: NexoyaContentLabelCategory;
  labelStatus: NexoyaContentLabelStatus;
  matches: Array<NexoyaContentLabelCategoryValue>;
};

export type NexoyaContentLabelAssignmentConnection = {
  __typename?: 'ContentLabelAssignmentConnection';
  edges: Array<NexoyaContentLabelAssignmentEdge>;
  pageInfo: NexoyaPageInfo;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type NexoyaContentLabelAssignmentEdge = {
  __typename?: 'ContentLabelAssignmentEdge';
  cursor: Scalars['String']['output'];
  node: NexoyaContentLabelAssignment;
};

export type NexoyaContentLabelCategory = {
  __typename?: 'ContentLabelCategory';
  color: Scalars['String']['output'];
  contentLabelCategoryId: Scalars['String']['output'];
  contentsByAssignmentStage: NexoyaContentsByAssignmentStage;
  name: Scalars['String']['output'];
  teamId: Scalars['Int']['output'];
  unlabeledContentCount: Scalars['Int']['output'];
  values: Array<NexoyaContentLabelCategoryValue>;
};


export type NexoyaContentLabelCategoryContentsByAssignmentStageArgs = {
  portfolioId?: InputMaybe<Scalars['Float']['input']>;
};


export type NexoyaContentLabelCategoryUnlabeledContentCountArgs = {
  portfolioId: Scalars['Float']['input'];
};

export type NexoyaContentLabelCategoryCreateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type NexoyaContentLabelCategoryDeleteInput = {
  contentLabelCategoryId: Scalars['String']['input'];
};

export type NexoyaContentLabelCategoryUpdateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  contentLabelCategoryId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type NexoyaContentLabelCategoryValue = {
  __typename?: 'ContentLabelCategoryValue';
  contentCount: Scalars['Int']['output'];
  contentLabelCategoryId: Scalars['String']['output'];
  contentLabelCategoryValueId: Scalars['String']['output'];
  filters?: Maybe<Array<NexoyaContentFilter>>;
  name: Scalars['String']['output'];
};


export type NexoyaContentLabelCategoryValueContentCountArgs = {
  portfolioId: Scalars['Float']['input'];
};

export type NexoyaContentLabelCategoryValueCreateInput = {
  contentLabelCategoryId: Scalars['String']['input'];
  filters?: InputMaybe<Array<NexoyaContentFilterInput>>;
  name: Scalars['String']['input'];
};

export type NexoyaContentLabelCategoryValueDeleteInput = {
  contentLabelCategoryId: Scalars['String']['input'];
  contentLabelCategoryValueId: Scalars['String']['input'];
};

export type NexoyaContentLabelCategoryValueUpdateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  contentLabelCategoryId: Scalars['String']['input'];
  contentLabelCategoryValueId: Scalars['String']['input'];
  filters?: InputMaybe<Array<NexoyaContentFilterInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type NexoyaContentLabelFilter = {
  __typename?: 'ContentLabelFilter';
  contentLabelCategoryId: Scalars['String']['output'];
  contentLabelCategoryValueIds: Array<Scalars['String']['output']>;
  includeUnlabeled: Scalars['Boolean']['output'];
};

export type NexoyaContentLabelFilterInput = {
  contentLabelCategoryId: Scalars['String']['input'];
  contentLabelCategoryValueIds: Array<Scalars['String']['input']>;
  includeUnlabeled: Scalars['Boolean']['input'];
};

export type NexoyaContentLabelMetricTotal = {
  __typename?: 'ContentLabelMetricTotal';
  comparisonChangePercent?: Maybe<NexoyaPerformanceMetric>;
  comparisonTotal?: Maybe<NexoyaPerformanceMetric>;
  /** Null for the contents without an assigned value in this category (unlabeled or still needing a decision). */
  contentLabelCategoryValue?: Maybe<NexoyaContentLabelCategoryValue>;
  contents: Array<NexoyaContentMetricTotal>;
  total: NexoyaPerformanceMetric;
};

export type NexoyaContentLabelStageCounts = {
  __typename?: 'ContentLabelStageCounts';
  labeled: Scalars['Int']['output'];
  manual: Scalars['Int']['output'];
  needsDecision: Scalars['Int']['output'];
  unlabeled: Scalars['Int']['output'];
};

export enum NexoyaContentLabelStatus {
  Labeled = 'LABELED',
  Manual = 'MANUAL',
  NeedsDecision = 'NEEDS_DECISION',
  Unlabeled = 'UNLABELED'
}

export type NexoyaContentMetricTotal = {
  __typename?: 'ContentMetricTotal';
  adAccount?: Maybe<NexoyaContentV2>;
  comparisonChangePercent?: Maybe<NexoyaPerformanceMetric>;
  comparisonTotal?: Maybe<NexoyaPerformanceMetric>;
  content: NexoyaContentV2;
  /** @deprecated Use content field instead */
  contentId: Scalars['Float']['output'];
  impactGroup?: Maybe<NexoyaImpactGroup>;
  label?: Maybe<NexoyaPortfolioLabel>;
  /** @deprecated Use content field instead */
  title: Scalars['String']['output'];
  total: NexoyaPerformanceMetric;
};

export type NexoyaContentRule = {
  __typename?: 'ContentRule';
  appliedDiscoveredContents: Array<NexoyaDiscoveredContent>;
  contentRuleId: Scalars['Float']['output'];
  filters: NexoyaContentRuleFilters;
  funnelStepMappings: Array<Maybe<NexoyaContentRuleFunnelStepMapping>>;
  matchingDiscoveredContentsCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  portfolioId: Scalars['Float']['output'];
  teamId: Scalars['Float']['output'];
};

export type NexoyaContentRuleFilters = {
  __typename?: 'ContentRuleFilters';
  adAccountIds: Array<Scalars['Float']['output']>;
  contentFilters: Array<NexoyaContentFilter>;
  providerId: Scalars['Float']['output'];
};

export type NexoyaContentRuleFiltersInput = {
  adAccountIds: Array<Scalars['Float']['input']>;
  contentFilters: Array<NexoyaContentFilterInput>;
  providerId: Scalars['Float']['input'];
};

export type NexoyaContentRuleFunnelStepMapping = {
  __typename?: 'ContentRuleFunnelStepMapping';
  funnelStepId: Scalars['Int']['output'];
  mapping: NexoyaFunnelStepMapping;
};

export type NexoyaContentRuleFunnelStepMappingInput = {
  funnelStepId: Scalars['Int']['input'];
  mapping: NexoyaFunnelStepMappingInput;
};

export type NexoyaContentRuleUpdateFiltersPreviewMutationResponse = {
  __typename?: 'ContentRuleUpdateFiltersPreviewMutationResponse';
  newMatchingDiscoveredContents: Array<Maybe<NexoyaDiscoveredContent>>;
  noLongerMatchingDiscoveredContents: Array<Maybe<NexoyaDiscoveredContent>>;
};

export enum NexoyaContentStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  InternalDeletion = 'INTERNAL_DELETION',
  Paused = 'PAUSED',
  Unknown = 'UNKNOWN',
  WithIssues = 'WITH_ISSUES'
}

export type NexoyaContentStatusMetadataValueDate = {
  __typename?: 'ContentStatusMetadataValueDate';
  date: Scalars['Date']['output'];
  value?: Maybe<NexoyaContentStatus>;
};

export type NexoyaContentStatusValueHistory = {
  __typename?: 'ContentStatusValueHistory';
  contentId: Scalars['Float']['output'];
  contentStatusValueHistory: Array<NexoyaContentStatusMetadataValueDate>;
};

export type NexoyaContentTitleFilter = {
  __typename?: 'ContentTitleFilter';
  operator: NexoyaContentTitleFilterOperator;
  values: Array<Scalars['String']['output']>;
};

export type NexoyaContentTitleFilterInput = {
  operator: NexoyaContentTitleFilterOperator;
  values: Array<Scalars['String']['input']>;
};

export enum NexoyaContentTitleFilterOperator {
  Contains = 'CONTAINS',
  Equals = 'EQUALS',
  NotContains = 'NOT_CONTAINS',
  NotEquals = 'NOT_EQUALS'
}

export type NexoyaContentType = {
  __typename?: 'ContentType';
  content_type_id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type NexoyaContentV2 = {
  __typename?: 'ContentV2';
  adAccount?: Maybe<NexoyaContentV2>;
  avgSpendLast7Days?: Maybe<Scalars['Float']['output']>;
  biddingStrategy?: Maybe<NexoyaContentBiddingStrategy>;
  budget?: Maybe<NexoyaContentBudget>;
  contentId: Scalars['Float']['output'];
  contentType: NexoyaCollectionType;
  currency?: Maybe<Scalars['String']['output']>;
  endDatetime?: Maybe<Scalars['DateTime']['output']>;
  labelAssignments: Array<NexoyaContentLabelAssignment>;
  latestMeasurementDataDate?: Maybe<Scalars['Date']['output']>;
  metadataHistory: Array<NexoyaHistoricalMetadata>;
  objective?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<NexoyaContentV2>;
  portfolioContentId?: Maybe<Scalars['Float']['output']>;
  provider: NexoyaProvider;
  sourceProvider: NexoyaProvider;
  startDatetime?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  teamId: Scalars['Float']['output'];
  title?: Maybe<Scalars['String']['output']>;
};


export type NexoyaContentV2MetadataHistoryArgs = {
  from: Scalars['Date']['input'];
  metadataTypes: Array<Scalars['String']['input']>;
  to: Scalars['Date']['input'];
};


export type NexoyaContentV2PortfolioContentIdArgs = {
  portfolioId: Scalars['Float']['input'];
};

export type NexoyaContentsByAssignmentStage = {
  __typename?: 'ContentsByAssignmentStage';
  /** The number of contents in each stage. Cheaper than a stage's totalCount, as it reads no page of contents. */
  counts: NexoyaContentLabelStageCounts;
  labeled: NexoyaContentLabelAssignmentConnection;
  manual: NexoyaContentLabelAssignmentConnection;
  needsDecision: NexoyaContentLabelAssignmentConnection;
  unlabeled: NexoyaContentLabelAssignmentConnection;
};


export type NexoyaContentsByAssignmentStageLabeledArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type NexoyaContentsByAssignmentStageManualArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type NexoyaContentsByAssignmentStageNeedsDecisionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type NexoyaContentsByAssignmentStageUnlabeledArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NexoyaConversion = {
  __typename?: 'Conversion';
  accountConversionIds: Array<Scalars['String']['output']>;
  conversionName: Scalars['String']['output'];
};

export type NexoyaCoreFunnelValues = {
  __typename?: 'CoreFunnelValues';
  costPer?: Maybe<Array<Maybe<NexoyaCostPerData>>>;
  realizedMetricByContent?: Maybe<Array<NexoyaRealizedMetricDataPast>>;
  realizedMetricDataPast?: Maybe<Array<NexoyaRealizedMetricDataPast>>;
  valueTotal?: Maybe<Scalars['Float']['output']>;
};

export type NexoyaCoreMetricValues = {
  __typename?: 'CoreMetricValues';
  costPer?: Maybe<Scalars['Float']['output']>;
  helpcenterLink?: Maybe<Scalars['String']['output']>;
  metricTypeId?: Maybe<Scalars['Float']['output']>;
  metricTypeName?: Maybe<Scalars['String']['output']>;
  valueTotal?: Maybe<Scalars['Float']['output']>;
};

export type NexoyaCoreOptMetricValues = {
  __typename?: 'CoreOptMetricValues';
  helpcenter_link?: Maybe<Scalars['String']['output']>;
  metric_type_id?: Maybe<Scalars['Int']['output']>;
  metric_type_name?: Maybe<Scalars['String']['output']>;
};

export type NexoyaCostPerData = {
  __typename?: 'CostPerData';
  timestamp: Scalars['DateTime']['output'];
  valueCumulative?: Maybe<Scalars['Float']['output']>;
  valueRelative?: Maybe<Scalars['Float']['output']>;
};

export type NexoyaCreateAttributionRuleAndDiscoverContentsMutationResponse = {
  __typename?: 'CreateAttributionRuleAndDiscoverContentsMutationResponse';
  attributionRule: NexoyaAttributionRule;
  clashingDiscoveredContents: Array<NexoyaDiscoveredContent>;
  mappedContentsCount: Scalars['Int']['output'];
};

export enum NexoyaCreateBudgetItemError {
  BudgetItemOverlap = 'BUDGET_ITEM_OVERLAP'
}

export type NexoyaCreateBudgetItemPrecheckResult = {
  __typename?: 'CreateBudgetItemPrecheckResult';
  errors?: Maybe<Array<Maybe<NexoyaCreateBudgetItemError>>>;
};

export type NexoyaCreateContentRuleMutationResponse = {
  __typename?: 'CreateContentRuleMutationResponse';
  contentRule: NexoyaContentRule;
  discoveredContents: Array<NexoyaDiscoveredContent>;
};

export type NexoyaCreateImpactGroupRuleMutationResponse = {
  __typename?: 'CreateImpactGroupRuleMutationResponse';
  clashingDiscoveredContents: Array<NexoyaDiscoveredContent>;
  impactGroupRule: NexoyaImpactGroupRule;
  mappedContentsCount: Scalars['Int']['output'];
};

export type NexoyaCreatePortfolioEventMutationResponse = {
  __typename?: 'CreatePortfolioEventMutationResponse';
  portfolioEvent: NexoyaPortfolioEvent;
};

export type NexoyaCurrencyData = {
  __typename?: 'CurrencyData';
  currencies?: Maybe<Array<Scalars['String']['output']>>;
  numberFormats?: Maybe<Array<Scalars['String']['output']>>;
};

export type NexoyaCurrencyExchangeRate = {
  __typename?: 'CurrencyExchangeRate';
  currencyExchangeRateId: Scalars['Int']['output'];
  currencyExchangeTimeframeId: Scalars['Int']['output'];
  fromCurrency: Scalars['String']['output'];
  toCurrency: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type NexoyaCurrencyExchangeRateInput = {
  currencyExchangeRateId?: InputMaybe<Scalars['Int']['input']>;
  currencyExchangeTimeframeId?: InputMaybe<Scalars['Int']['input']>;
  fromCurrency: Scalars['String']['input'];
  toCurrency: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export type NexoyaCurrencyExchangeTimeframe = {
  __typename?: 'CurrencyExchangeTimeframe';
  currencyExchangeTimeframeId: Scalars['Int']['output'];
  end?: Maybe<Scalars['Date']['output']>;
  rates?: Maybe<Array<NexoyaCurrencyExchangeRate>>;
  start?: Maybe<Scalars['Date']['output']>;
  teamId: Scalars['Int']['output'];
};

export type NexoyaCurrencyExchangeTimeframeInput = {
  currencyExchangeTimeframeId?: InputMaybe<Scalars['Int']['input']>;
  rates?: InputMaybe<Array<NexoyaCurrencyExchangeRateInput>>;
  start?: InputMaybe<Scalars['Date']['input']>;
};

export type NexoyaCustomKpi = {
  __typename?: 'CustomKPI';
  calc_type: Scalars['String']['output'];
  configType?: Maybe<NexoyaCustomKpiConfigType>;
  custom_kpi_id: Scalars['Int']['output'];
  defaultValue?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  kpis?: Maybe<Array<NexoyaMeasurement>>;
  kpisAll?: Maybe<Array<NexoyaMeasurement>>;
  kpisFromPairs?: Maybe<Array<NexoyaMeasurement>>;
  name: Scalars['String']['output'];
  search?: Maybe<NexoyaCkSearch>;
  team_id: Scalars['Int']['output'];
  updatedBy?: Maybe<NexoyaUser>;
  updated_at: Scalars['DateTime']['output'];
};


export type NexoyaCustomKpiKpisArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
};


export type NexoyaCustomKpiKpisAllArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
};


export type NexoyaCustomKpiKpisFromPairsArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  measurementCollectionPairs: Array<InputMaybe<NexoyaKpiInputOptCollection>>;
};

export enum NexoyaCustomKpiConfigType {
  Analytics = 'ANALYTICS',
  Conversion = 'CONVERSION',
  Placeholder = 'PLACEHOLDER',
  PreselectedContents = 'PRESELECTED_CONTENTS',
  Search = 'SEARCH'
}

export type NexoyaCustomTrendSignalCreateInput = {
  name: Scalars['String']['input'];
};

export type NexoyaDailyContentLabelMetric = {
  __typename?: 'DailyContentLabelMetric';
  comparisonChangePercent?: Maybe<NexoyaPerformanceMetric>;
  comparisonValue?: Maybe<NexoyaPerformanceMetric>;
  /** Null for the contents without an assigned value in this category (unlabeled or still needing a decision). */
  contentLabelCategoryValue?: Maybe<NexoyaContentLabelCategoryValue>;
  value?: Maybe<NexoyaPerformanceMetric>;
};

export type NexoyaDailyContentMetric = {
  __typename?: 'DailyContentMetric';
  comparisonChangePercent?: Maybe<NexoyaPerformanceMetric>;
  comparisonValue?: Maybe<NexoyaPerformanceMetric>;
  contentId: Scalars['Float']['output'];
  impactGroup?: Maybe<NexoyaImpactGroup>;
  isIncludedInOptimization: Scalars['Boolean']['output'];
  label?: Maybe<NexoyaPortfolioLabel>;
  providerId: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  value?: Maybe<NexoyaPerformanceMetric>;
};

export type NexoyaDailyImpactGroupMetric = {
  __typename?: 'DailyImpactGroupMetric';
  comparisonChangePercent?: Maybe<NexoyaPerformanceMetric>;
  comparisonValue?: Maybe<NexoyaPerformanceMetric>;
  impactGroup: NexoyaImpactGroup;
  value?: Maybe<NexoyaPerformanceMetric>;
};

export type NexoyaDailyLabelMetric = {
  __typename?: 'DailyLabelMetric';
  comparisonChangePercent?: Maybe<NexoyaPerformanceMetric>;
  comparisonValue?: Maybe<NexoyaPerformanceMetric>;
  labelId: Scalars['Int']['output'];
  value?: Maybe<NexoyaPerformanceMetric>;
};

export type NexoyaDailyMetric = {
  __typename?: 'DailyMetric';
  comparisonDay?: Maybe<Scalars['Date']['output']>;
  contentLabels: Array<NexoyaDailyContentLabelMetric>;
  contents: Array<NexoyaDailyContentMetric>;
  day?: Maybe<Scalars['Date']['output']>;
  impactGroups: Array<NexoyaDailyImpactGroupMetric>;
  labels: Array<NexoyaDailyLabelMetric>;
  providers: Array<NexoyaDailyProviderMetric>;
};


export type NexoyaDailyMetricContentLabelsArgs = {
  contentLabelCategoryId: Scalars['String']['input'];
};

export type NexoyaDailyOptimizationImpactGroupMetric = {
  __typename?: 'DailyOptimizationImpactGroupMetric';
  cumulativeBaseline: Scalars['Float']['output'];
  cumulativeExpected: Scalars['Float']['output'];
  impactGroup: NexoyaImpactGroup;
  relativeBaseline: Scalars['Float']['output'];
  relativeExpected: Scalars['Float']['output'];
};

export type NexoyaDailyOptimizationLabelMetric = {
  __typename?: 'DailyOptimizationLabelMetric';
  cumulativeBaseline: Scalars['Float']['output'];
  cumulativeExpected: Scalars['Float']['output'];
  labelId: Scalars['Int']['output'];
  relativeBaseline: Scalars['Float']['output'];
  relativeExpected: Scalars['Float']['output'];
};

export type NexoyaDailyOptimizationMetric = {
  __typename?: 'DailyOptimizationMetric';
  day: Scalars['Date']['output'];
  impactGroups: Array<NexoyaDailyOptimizationImpactGroupMetric>;
  labels: Array<Maybe<NexoyaDailyOptimizationLabelMetric>>;
  providers: Array<NexoyaDailyOptimizationProviderMetric>;
};

export type NexoyaDailyOptimizationProviderMetric = {
  __typename?: 'DailyOptimizationProviderMetric';
  cumulativeBaseline: Scalars['Float']['output'];
  cumulativeExpected: Scalars['Float']['output'];
  providerId: Scalars['Int']['output'];
  relativeBaseline: Scalars['Float']['output'];
  relativeExpected: Scalars['Float']['output'];
};

export type NexoyaDailyPrediction = {
  __typename?: 'DailyPrediction';
  achieved: Scalars['Float']['output'];
  day: Scalars['Date']['output'];
  predicted: Scalars['Float']['output'];
  predictedRaw?: Maybe<Scalars['Float']['output']>;
  score: Scalars['Float']['output'];
};

export type NexoyaDailyPredictionTotal = {
  __typename?: 'DailyPredictionTotal';
  day: Scalars['Date']['output'];
  score: Scalars['Float']['output'];
};

export type NexoyaDailyProviderMetric = {
  __typename?: 'DailyProviderMetric';
  comparisonChangePercent?: Maybe<NexoyaPerformanceMetric>;
  comparisonValue?: Maybe<NexoyaPerformanceMetric>;
  providerId: Scalars['Int']['output'];
  value?: Maybe<NexoyaPerformanceMetric>;
};

export type NexoyaDailyTimeSeriesDataPoint = {
  __typename?: 'DailyTimeSeriesDataPoint';
  date: Scalars['Date']['output'];
  value: Scalars['Float']['output'];
};

export type NexoyaDailyTimeSeriesDataPointOptional = {
  __typename?: 'DailyTimeSeriesDataPointOptional';
  date: Scalars['Date']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type NexoyaDashboardUrl = {
  __typename?: 'DashboardUrl';
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type NexoyaDashboardUrlInput = {
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type NexoyaDataType = {
  __typename?: 'DataType';
  description?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['Boolean']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
};

export type NexoyaDateRange = {
  __typename?: 'DateRange';
  dateFrom?: Maybe<Scalars['DateTime']['output']>;
  dateTo?: Maybe<Scalars['DateTime']['output']>;
};

export type NexoyaDateRangeInput = {
  end: Scalars['Date']['input'];
  start: Scalars['Date']['input'];
};

export type NexoyaDateRangeRequiredInput = {
  dateFrom: Scalars['DateTime']['input'];
  dateTo: Scalars['DateTime']['input'];
};

export type NexoyaDeleteAttributionRuleContentActionInput = {
  applyAttributionRuleId?: InputMaybe<Scalars['Float']['input']>;
  discoveredContentId: Scalars['Float']['input'];
};

export type NexoyaDeleteContentRuleContentActionInput = {
  applyContentRuleId?: InputMaybe<Scalars['Float']['input']>;
  discoveredContentId: Scalars['Float']['input'];
  removeFromPortfolio: Scalars['Boolean']['input'];
};

export type NexoyaDeleteImpactGroupRuleContentActionInput = {
  applyImpactGroupRuleId?: InputMaybe<Scalars['Float']['input']>;
  discoveredContentId: Scalars['Float']['input'];
  removeImpactGroupAssignment: Scalars['Boolean']['input'];
};

export enum NexoyaDimensionColumn {
  AdAccount = 'AD_ACCOUNT',
  Channel = 'CHANNEL',
  ImpactGroup = 'IMPACT_GROUP',
  Label = 'LABEL'
}

export type NexoyaDiscoveredContent = {
  __typename?: 'DiscoveredContent';
  attributionRules: Array<NexoyaApplicableAttributionRule>;
  content: NexoyaContentV2;
  contentRules: Array<NexoyaApplicableContentRule>;
  discoveredContentId: Scalars['Float']['output'];
  impactGroupRules: Array<NexoyaApplicableImpactGroupRule>;
  status: NexoyaDiscoveredContentStatus;
};

export enum NexoyaDiscoveredContentStatus {
  Accepted = 'ACCEPTED',
  AcceptedButHasUnappliedRules = 'ACCEPTED_BUT_HAS_UNAPPLIED_RULES',
  Manual = 'MANUAL',
  New = 'NEW',
  Rejected = 'REJECTED',
  Removed = 'REMOVED'
}

export type NexoyaDiscoveredContentsCount = {
  __typename?: 'DiscoveredContentsCount';
  ACCEPTED: Scalars['Int']['output'];
  ACCEPTED_BUT_HAS_UNAPPLIED_RULES: Scalars['Int']['output'];
  MANUAL: Scalars['Int']['output'];
  NEW: Scalars['Int']['output'];
  REJECTED: Scalars['Int']['output'];
  REMOVED: Scalars['Int']['output'];
};

export enum NexoyaEventCategory {
  BrandAwareness = 'BRAND_AWARENESS',
  NegativeExternalEffects = 'NEGATIVE_EXTERNAL_EFFECTS',
  PositiveExternalEffects = 'POSITIVE_EXTERNAL_EFFECTS',
  PriceIncrease = 'PRICE_INCREASE',
  ProductLaunch = 'PRODUCT_LAUNCH',
  PromotionAndDiscounts = 'PROMOTION_AND_DISCOUNTS',
  TrackingIssue = 'TRACKING_ISSUE'
}

export enum NexoyaEventImpact {
  Large = 'LARGE',
  Small = 'SMALL'
}

export type NexoyaExternalLinkInput = {
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type NexoyaFailedEntryError = {
  __typename?: 'FailedEntryError';
  errorReason?: Maybe<Scalars['String']['output']>;
  failedEntryId?: Maybe<Scalars['Int']['output']>;
};

export type NexoyaFeatureFlag = {
  __typename?: 'FeatureFlag';
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type NexoyaFeatureFlagInput = {
  name: Scalars['String']['input'];
  status: Scalars['Boolean']['input'];
};

export type NexoyaFieldAllowedValues = {
  __typename?: 'FieldAllowedValues';
  enumOptionsNumber?: Maybe<Array<Scalars['Float']['output']>>;
  enumOptionsString?: Maybe<Array<Scalars['String']['output']>>;
  fieldType: NexoyaFieldType;
};

export type NexoyaFieldOperation = {
  __typename?: 'FieldOperation';
  allowed: NexoyaFieldAllowedValues;
  fieldName: NexoyaContentFilterFieldName;
  operators: Array<NexoyaContentFilterOperator>;
};

export enum NexoyaFieldType {
  Boolean = 'boolean',
  Date = 'date',
  Number = 'number',
  NumberArr = 'numberArr',
  String = 'string',
  StringArr = 'stringArr'
}

export type NexoyaFile = {
  __typename?: 'File';
  createdAt: Scalars['DateTime']['output'];
  downloadUrl: Scalars['String']['output'];
  extension: Scalars['String']['output'];
  fileBlobId: Scalars['Int']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sizeInBytes: Scalars['Float']['output'];
};

export type NexoyaFilter = {
  collectionTypes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  includeChildren?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  measurementIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NexoyaFreeFormBiddingStrategyChangeInput = {
  biddingStrategyType: NexoyaBiddingStrategyType;
  biddingStrategyValue?: InputMaybe<Scalars['Float']['input']>;
  campaignId: Scalars['Float']['input'];
};

export type NexoyaFreeFormBiddingStrategyChangesResult = {
  __typename?: 'FreeFormBiddingStrategyChangesResult';
  campaignId: Scalars['Float']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  newBiddingStrategy?: Maybe<NexoyaBiddingStrategy>;
  oldBiddingStrategy?: Maybe<NexoyaBiddingStrategy>;
  status: Scalars['String']['output'];
};

export type NexoyaFreeFormDailyBudgetChangeInput = {
  campaignId: Scalars['Float']['input'];
  dailyBudget: Scalars['Float']['input'];
};

export type NexoyaFreeFormDailyBudgetChangesResult = {
  __typename?: 'FreeFormDailyBudgetChangesResult';
  campaignId: Scalars['Float']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  newBudget?: Maybe<Scalars['Float']['output']>;
  oldBudget?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
};

export type NexoyaFreeFormLifetimeBudgetChangeInput = {
  budgetSegments: Array<NexoyaFreeFormLifetimeBudgetSegmentInput>;
  campaignId: Scalars['Float']['input'];
};

export type NexoyaFreeFormLifetimeBudgetChangesResult = {
  __typename?: 'FreeFormLifetimeBudgetChangesResult';
  campaignId: Scalars['Float']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  newBudget?: Maybe<Array<NexoyaFreeFormLifetimeBudgetSegment>>;
  oldBudget?: Maybe<Array<NexoyaFreeFormLifetimeBudgetSegment>>;
  status: Scalars['String']['output'];
};

export type NexoyaFreeFormLifetimeBudgetSegment = {
  __typename?: 'FreeFormLifetimeBudgetSegment';
  endDate: Scalars['Date']['output'];
  segmentBudget: Scalars['Float']['output'];
  startDate: Scalars['Date']['output'];
};

export type NexoyaFreeFormLifetimeBudgetSegmentInput = {
  endDate: Scalars['Date']['input'];
  segmentBudget: Scalars['Float']['input'];
  startDate: Scalars['Date']['input'];
};

export type NexoyaFunnelStep = {
  __typename?: 'FunnelStep';
  coreFunnelValues?: Maybe<NexoyaCoreFunnelValues>;
  dateFrom: Scalars['DateTime']['output'];
  dateTo: Scalars['DateTime']['output'];
  funnel_step_id: Scalars['Int']['output'];
  input_funnel_step_id?: Maybe<Scalars['Int']['output']>;
  optimizationTargetType?: Maybe<NexoyaFunnelStepType>;
  realizedMetricDataPast?: Maybe<Array<NexoyaRealizedMetricData>>;
  team_id: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type NexoyaFunnelStepAnalyticsSearchDimension = {
  __typename?: 'FunnelStepAnalyticsSearchDimension';
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type NexoyaFunnelStepDefaultMapping = {
  __typename?: 'FunnelStepDefaultMapping';
  funnelStepId: Scalars['Float']['output'];
  metricId?: Maybe<Scalars['Int']['output']>;
};

export type NexoyaFunnelStepMapping = {
  __typename?: 'FunnelStepMapping';
  accountContentId?: Maybe<Scalars['Float']['output']>;
  calculatedMetricFormula?: Maybe<Scalars['JSON']['output']>;
  conversions?: Maybe<Array<NexoyaFunnelStepMappingConversion>>;
  metricId?: Maybe<Scalars['Int']['output']>;
  providerId?: Maybe<Scalars['Float']['output']>;
  searchDimensions?: Maybe<Array<NexoyaAnalyticsSearchDimension>>;
  searchTitle?: Maybe<Scalars['String']['output']>;
  type: NexoyaFunnelStepMappingType;
};

export type NexoyaFunnelStepMappingConversion = {
  __typename?: 'FunnelStepMappingConversion';
  accountConversionIds: Array<Scalars['String']['output']>;
  conversionName: Scalars['String']['output'];
  metricId: Scalars['Int']['output'];
};

export type NexoyaFunnelStepMappingConversionInput = {
  accountConversionIds: Array<Scalars['String']['input']>;
  conversionName: Scalars['String']['input'];
  metricId: Scalars['Int']['input'];
};

export type NexoyaFunnelStepMappingInput = {
  accountContentId?: InputMaybe<Scalars['Float']['input']>;
  calculatedMetricFormula?: InputMaybe<Scalars['JSON']['input']>;
  conversions?: InputMaybe<Array<NexoyaFunnelStepMappingConversionInput>>;
  metricId?: InputMaybe<Scalars['Int']['input']>;
  providerId?: InputMaybe<Scalars['Float']['input']>;
  searchDimensions?: InputMaybe<Array<NexoyaAnalyticsSearchDimensionInput>>;
  searchTitle?: InputMaybe<Scalars['String']['input']>;
  type: NexoyaFunnelStepMappingType;
};

export type NexoyaFunnelStepMappingPreset = {
  __typename?: 'FunnelStepMappingPreset';
  funnelStepMappingPresetId: Scalars['Float']['output'];
  mapping: NexoyaFunnelStepMapping;
  name: Scalars['String']['output'];
  teamId: Scalars['Float']['output'];
};

export enum NexoyaFunnelStepMappingType {
  Analytics = 'ANALYTICS',
  CalculatedMetric = 'CALCULATED_METRIC',
  Conversion = 'CONVERSION',
  CustomImport = 'CUSTOM_IMPORT',
  CustomMetric = 'CUSTOM_METRIC',
  Ignore = 'IGNORE',
  Metric = 'METRIC'
}

export type NexoyaFunnelStepPerformance = {
  __typename?: 'FunnelStepPerformance';
  dailyMetrics: Array<NexoyaDailyMetric>;
  dailyOptimizationMetrics: Array<NexoyaDailyOptimizationMetric>;
  funnelStep: NexoyaFunnelStepV2;
  groupedByAdAccount: Array<NexoyaAdAccountMetricTotal>;
  groupedByAttributionRule: Array<NexoyaAttributionRuleMetricTotal>;
  groupedByChannel: Array<NexoyaProviderMetricTotal>;
  groupedByContentLabel: Array<NexoyaContentLabelMetricTotal>;
  groupedByImpactGroup: Array<NexoyaImpactGroupMetricTotal>;
  groupedByLabel: Array<NexoyaLabelMetricTotal>;
  /** @deprecated Use groupedByX fields. metricTotals computes every grouping eagerly. */
  metricTotals: NexoyaMetricTotal;
  optimizationMetricTotals?: Maybe<NexoyaOptimizationMetricTotal>;
  total: NexoyaAggregateMetricTotal;
};


export type NexoyaFunnelStepPerformanceGroupedByContentLabelArgs = {
  contentLabelCategoryId: Scalars['String']['input'];
};

export type NexoyaFunnelStepPredictionScore = {
  __typename?: 'FunnelStepPredictionScore';
  accuracyBuckets: Array<NexoyaAccuracyBucket>;
  dailyPredictions: Array<NexoyaDailyPrediction>;
  funnelStepId: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  type: NexoyaFunnelStepType;
};

export enum NexoyaFunnelStepType {
  Awareness = 'AWARENESS',
  Consideration = 'CONSIDERATION',
  Conversion = 'CONVERSION',
  ConversionValue = 'CONVERSION_VALUE',
  Cost = 'COST',
  Other = 'OTHER'
}

export type NexoyaFunnelStepV2 = {
  __typename?: 'FunnelStepV2';
  funnelStepId: Scalars['Int']['output'];
  isAttributed: Scalars['Boolean']['output'];
  isMeasured: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: NexoyaFunnelStepType;
};

export type NexoyaGoogleTrendsKeywordOptions = {
  __typename?: 'GoogleTrendsKeywordOptions';
  regions: Array<NexoyaTrendSignalOption>;
  sources: Array<NexoyaTrendSignalOption>;
  timePeriods: Array<NexoyaTrendSignalOption>;
};

/** The codes must be among googleTrendsKeywordOptions */
export type NexoyaGoogleTrendsKeywordTrendSignalCreateInput = {
  keyword: Scalars['String']['input'];
  region: Scalars['String']['input'];
  source: Scalars['String']['input'];
  timePeriod: Scalars['String']['input'];
};

export enum NexoyaGroupingDimension {
  AdAccount = 'AD_ACCOUNT',
  AttributionRule = 'ATTRIBUTION_RULE',
  Channel = 'CHANNEL',
  ImpactGroup = 'IMPACT_GROUP',
  Label = 'LABEL',
  None = 'NONE'
}

export type NexoyaHistoricalMetadata = {
  __typename?: 'HistoricalMetadata';
  date: Scalars['Date']['output'];
  metadataType: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type NexoyaImpactGroup = {
  __typename?: 'ImpactGroup';
  funnelSteps: Array<NexoyaFunnelStep>;
  impactGroupId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  portfolioId: Scalars['Int']['output'];
};

export type NexoyaImpactGroupMetricTotal = {
  __typename?: 'ImpactGroupMetricTotal';
  comparisonChangePercent?: Maybe<NexoyaPerformanceMetric>;
  comparisonTotal?: Maybe<NexoyaPerformanceMetric>;
  impactGroup: NexoyaImpactGroup;
  total: NexoyaPerformanceMetric;
};

export type NexoyaImpactGroupRule = {
  __typename?: 'ImpactGroupRule';
  appliedDiscoveredContents: Array<NexoyaDiscoveredContent>;
  filters: NexoyaImpactGroupRuleFilters;
  impactGroupId: Scalars['Float']['output'];
  impactGroupRuleId: Scalars['Float']['output'];
  matchingDiscoveredContentsCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  portfolioId: Scalars['Float']['output'];
  teamId: Scalars['Float']['output'];
};

export type NexoyaImpactGroupRuleEditInput = {
  filters?: InputMaybe<NexoyaImpactGroupRuleFiltersInput>;
  impactGroupId?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type NexoyaImpactGroupRuleFilters = {
  __typename?: 'ImpactGroupRuleFilters';
  contentFilters: Array<NexoyaContentFilter>;
  providers: Array<NexoyaImpactGroupRuleProvider>;
};

export type NexoyaImpactGroupRuleFiltersInput = {
  contentFilters: Array<NexoyaContentFilterInput>;
  providers: Array<NexoyaImpactGroupRuleProviderInput>;
};

export type NexoyaImpactGroupRuleProvider = {
  __typename?: 'ImpactGroupRuleProvider';
  adAccountIds: Array<Scalars['Float']['output']>;
  providerId: Scalars['Float']['output'];
};

export type NexoyaImpactGroupRuleProviderInput = {
  adAccountIds: Array<Scalars['Float']['input']>;
  providerId: Scalars['Float']['input'];
};

export type NexoyaImpactGroupRuleUpdatePreviewMutationResponse = {
  __typename?: 'ImpactGroupRuleUpdatePreviewMutationResponse';
  newMatchingDiscoveredContents: Array<Maybe<NexoyaDiscoveredContent>>;
  noLongerMatchingDiscoveredContents: Array<Maybe<NexoyaDiscoveredContent>>;
};

export type NexoyaIntegration = {
  __typename?: 'Integration';
  connected: Scalars['Boolean']['output'];
  connectionUrl?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Scalars['String']['output']>;
  filterOptions?: Maybe<Array<Maybe<NexoyaProviderFilter>>>;
  hasFilter?: Maybe<Scalars['Boolean']['output']>;
  integration_id: Scalars['Int']['output'];
  lastSyncAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  provider?: Maybe<NexoyaProvider>;
  provider_id: Scalars['Int']['output'];
  status?: Maybe<NexoyaIntegrationStatus>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  user?: Maybe<NexoyaUser>;
};

export type NexoyaIntegrationFilter = {
  connected?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum NexoyaIntegrationStatus {
  Error = 'ERROR',
  Synced = 'SYNCED',
  Syncing = 'SYNCING'
}

export type NexoyaKpi = {
  __typename?: 'KPI';
  datatype?: Maybe<NexoyaDataType>;
  description?: Maybe<Scalars['String']['output']>;
  kpi_id: Scalars['Int']['output'];
  measurements?: Maybe<Array<Maybe<NexoyaMeasurement>>>;
  name?: Maybe<Scalars['String']['output']>;
  providers?: Maybe<Array<Maybe<NexoyaProvider>>>;
};


export type NexoyaKpiMeasurementsArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  team_id: Scalars['Int']['input'];
};

export type NexoyaKpiSummary = {
  __typename?: 'KPISummary';
  averageType?: Maybe<Scalars['Boolean']['output']>;
  datatype?: Maybe<NexoyaDataType>;
  group?: Maybe<NexoyaKpiSummaryGroup>;
};

export type NexoyaKpiSummaryGroup = {
  __typename?: 'KPISummaryGroup';
  goal?: Maybe<Scalars['Float']['output']>;
  lowerIsBetter?: Maybe<Scalars['Boolean']['output']>;
  measurement_id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  provider_id?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type NexoyaKpiSummaryType = {
  __typename?: 'KPISummaryType';
  summary?: Maybe<Array<Maybe<NexoyaKpiSummary>>>;
};

export type NexoyaKpiInput = {
  collection_id: Scalars['Float']['input'];
  measurement_id: Scalars['Int']['input'];
};

export type NexoyaKpiInputOptCollection = {
  collection_id?: InputMaybe<Scalars['Float']['input']>;
  measurement_id: Scalars['Int']['input'];
};

export type NexoyaKpiInputOptMetric = {
  collection_id: Scalars['Float']['input'];
  measurement_id?: InputMaybe<Scalars['Int']['input']>;
};

export type NexoyaLabelMetricTotal = {
  __typename?: 'LabelMetricTotal';
  comparisonChangePercent?: Maybe<NexoyaPerformanceMetric>;
  comparisonTotal?: Maybe<NexoyaPerformanceMetric>;
  labelId: Scalars['Int']['output'];
  total: NexoyaPerformanceMetric;
};

export type NexoyaLifetimeBudget = {
  __typename?: 'LifetimeBudget';
  lifetimeBudgetSegments: Array<Maybe<NexoyaLifetimeBudgetSegment>>;
  providerBudgetMissingDays: Array<Maybe<Scalars['Date']['output']>>;
};

export type NexoyaLifetimeBudgetSegment = {
  __typename?: 'LifetimeBudgetSegment';
  endDate: Scalars['Date']['output'];
  initialBudget: Scalars['Float']['output'];
  proposedBudget: Scalars['Float']['output'];
  spend?: Maybe<Scalars['Float']['output']>;
  spendUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  startDate: Scalars['Date']['output'];
};

export type NexoyaListAttributionModelsFilters = {
  status?: InputMaybe<Array<NexoyaAttributionModelStatus>>;
};

export type NexoyaManualContentFunnelStepMappingInput = {
  funnelStepId: Scalars['Int']['input'];
  metricId?: InputMaybe<Scalars['Int']['input']>;
};

export type NexoyaManuallyAssignContentLabelInput = {
  contentIds: Array<Scalars['Float']['input']>;
  contentLabelCategoryId: Scalars['String']['input'];
  contentLabelCategoryValueId: Scalars['String']['input'];
};

export type NexoyaMeasurement = {
  __typename?: 'Measurement';
  aggregate_up_to?: Maybe<Scalars['Int']['output']>;
  api_path?: Maybe<Scalars['String']['output']>;
  calculation_type?: Maybe<Scalars['String']['output']>;
  collection?: Maybe<NexoyaCollection>;
  collections?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  customKpiConfig?: Maybe<NexoyaCustomKpi>;
  datatype?: Maybe<NexoyaDataType>;
  datatype_id?: Maybe<Scalars['Int']['output']>;
  deprecated?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<NexoyaMeasurementDetail>;
  dimensions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  goal?: Maybe<Scalars['Float']['output']>;
  helpcenter_link?: Maybe<Scalars['String']['output']>;
  import_sum_type?: Maybe<Scalars['String']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  kpi?: Maybe<NexoyaKpi>;
  lowerIsBetter?: Maybe<Scalars['Boolean']['output']>;
  measurement_id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  optimization_target_type?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  provider?: Maybe<NexoyaProvider>;
  provider_id?: Maybe<Scalars['Int']['output']>;
  showAsTotal?: Maybe<Scalars['Boolean']['output']>;
};


export type NexoyaMeasurementDatatypeArgs = {
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

export type NexoyaMeasurementAggregate = {
  __typename?: 'MeasurementAggregate';
  aggregatedValue: Scalars['Float']['output'];
  dailyValues?: Maybe<Array<Maybe<NexoyaMeasurementData>>>;
};

export type NexoyaMeasurementCollectionInput = {
  collection_id: Scalars['Float']['input'];
  goal?: InputMaybe<Scalars['Float']['input']>;
  measurement_id: Scalars['Int']['input'];
};

export type NexoyaMeasurementCollectionPairInput = {
  collection_id: Scalars['Float']['input'];
  measurement_id: Scalars['Int']['input'];
};

export type NexoyaMeasurementConnection = {
  __typename?: 'MeasurementConnection';
  edges: Array<NexoyaMeasurementEdges>;
  pageInfo: NexoyaPageInfo;
};

export type NexoyaMeasurementData = {
  __typename?: 'MeasurementData';
  dimensions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  valueSumUp?: Maybe<Scalars['Float']['output']>;
};

export type NexoyaMeasurementDetail = {
  __typename?: 'MeasurementDetail';
  data?: Maybe<Array<Maybe<NexoyaMeasurementData>>>;
  value?: Maybe<Scalars['Float']['output']>;
  valueChangePercentage?: Maybe<Scalars['Float']['output']>;
  valueSum?: Maybe<Scalars['Float']['output']>;
  valueSumUptoEndDate?: Maybe<Scalars['Float']['output']>;
};

export type NexoyaMeasurementEdges = {
  __typename?: 'MeasurementEdges';
  cursor: Scalars['String']['output'];
  node: NexoyaMeasurement;
};

export type NexoyaMeasurementGroup = {
  __typename?: 'MeasurementGroup';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export type NexoyaMetadata = {
  __typename?: 'Metadata';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  metadata_key: Scalars['String']['output'];
  metadata_type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  value_lookup?: Maybe<Scalars['String']['output']>;
};

export enum NexoyaMetadataType {
  BiddingStrategy = 'BIDDING_STRATEGY',
  DailyBudgetMicros = 'DAILY_BUDGET_MICROS',
  EndDatetime = 'END_DATETIME',
  SharedBudget = 'SHARED_BUDGET',
  StartDatetime = 'START_DATETIME',
  Status = 'STATUS',
  TargetCpaMicros = 'TARGET_CPA_MICROS'
}

export type NexoyaMetric = {
  __typename?: 'Metric';
  aggregate_up_to?: Maybe<Scalars['Int']['output']>;
  api_path?: Maybe<Scalars['String']['output']>;
  calculation_type?: Maybe<Scalars['String']['output']>;
  collection?: Maybe<NexoyaCollection>;
  collections?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  content?: Maybe<NexoyaContent>;
  customKpiConfig?: Maybe<NexoyaCustomKpi>;
  datatype?: Maybe<NexoyaDataType>;
  description?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<NexoyaMetricDetail>;
  dimensions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  goal?: Maybe<Scalars['Float']['output']>;
  helpcenter_link?: Maybe<Scalars['String']['output']>;
  import_sum_type?: Maybe<Scalars['String']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  kpi?: Maybe<NexoyaKpi>;
  lowerIsBetter?: Maybe<Scalars['Boolean']['output']>;
  metric_id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<NexoyaProvider>;
  provider_id?: Maybe<Scalars['Int']['output']>;
  showAsTotal?: Maybe<Scalars['Boolean']['output']>;
};


export type NexoyaMetricDatatypeArgs = {
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

export type NexoyaMetricData = {
  timestamp: Scalars['DateTime']['output'];
  valueCumulative: Scalars['Float']['output'];
  valueRelative: Scalars['Float']['output'];
};

export type NexoyaMetricDataCore = {
  __typename?: 'MetricDataCore';
  dimensions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  valueSumUp?: Maybe<Scalars['Float']['output']>;
};

export type NexoyaMetricDefinitionV2 = {
  __typename?: 'MetricDefinitionV2';
  apiPath?: Maybe<Scalars['String']['output']>;
  calculationType: Scalars['String']['output'];
  dataTypeId: Scalars['String']['output'];
  defaultForFunnelStepType?: Maybe<NexoyaFunnelStepType>;
  metricTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  optimizationTargetTypes: Array<NexoyaFunnelStepType>;
  providerId: Scalars['Int']['output'];
};

export type NexoyaMetricDetail = {
  __typename?: 'MetricDetail';
  data?: Maybe<Array<Maybe<NexoyaMetricDataCore>>>;
  value?: Maybe<Scalars['Float']['output']>;
  valueChangePercentage?: Maybe<Scalars['Float']['output']>;
  valueSum?: Maybe<Scalars['Float']['output']>;
  valueSumUptoEndDate?: Maybe<Scalars['Float']['output']>;
};

export type NexoyaMetricMeta = {
  __typename?: 'MetricMeta';
  helpcenter_link?: Maybe<Scalars['String']['output']>;
  metric_type_id?: Maybe<Scalars['Int']['output']>;
  metric_type_name?: Maybe<Scalars['String']['output']>;
};

export type NexoyaMetricTotal = {
  __typename?: 'MetricTotal';
  attributionRules: Array<NexoyaAttributionRuleMetricTotal>;
  impactGroups: Array<NexoyaImpactGroupMetricTotal>;
  labels: Array<NexoyaLabelMetricTotal>;
  providers?: Maybe<Array<NexoyaProviderMetricTotal>>;
};

export type NexoyaMissingCurrencyCoverage = {
  __typename?: 'MissingCurrencyCoverage';
  contentCurrency: Scalars['String']['output'];
  /** @deprecated Should not happen anymore with the new business logic */
  missingRanges: Array<NexoyaRequiredDateRange>;
  teamCurrency: Scalars['String']['output'];
};

export type NexoyaMutation = {
  __typename?: 'Mutation';
  acceptAttributionModelResults: Scalars['Boolean']['output'];
  acceptDiscoveredContents: Array<NexoyaDiscoveredContent>;
  activateAttribution: NexoyaPortfolioV2;
  addManualContentsToPorfolio: Array<NexoyaPortfolioParentContent>;
  addManualIntegration?: Maybe<Scalars['Boolean']['output']>;
  addManyContentRelations: Scalars['Boolean']['output'];
  addPortfolioContent: Array<Scalars['Int']['output']>;
  addReportKpis?: Maybe<Scalars['Boolean']['output']>;
  addSelectedMeasurement?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  applyRulesToDiscoveredContents: NexoyaApplyRulesToDiscoveredContentsMutationResponse;
  applySimulation: NexoyaSimulation;
  assignContentsAndRulesToPortfolioEvents: NexoyaAssignContentsAndRulesToPortfolioEventsResponse;
  assignFunnelStepMetricsToPortfolioContents: Array<NexoyaPortfolioParentContent>;
  assignImpactGroupToPortfolioContents: Array<NexoyaPortfolioParentContent>;
  assignTrendSignalToPortfolio: NexoyaTrendSignal;
  bulkAssignFunnelStepMetrics: Scalars['Boolean']['output'];
  bulkAssignLabels: Scalars['Boolean']['output'];
  bulkCreateCustomKpis: Array<NexoyaCustomKpi>;
  bulkCreatePortfolioEvents?: Maybe<NexoyaBulkCreatePortfolioEventsMutationResponse>;
  bulkUpdatePortfolioEvents?: Maybe<NexoyaBulkUpdatePortfolioEventsMutationResponse>;
  cancelAttributionModelRun: Scalars['Boolean']['output'];
  cancelOptimization: Scalars['Boolean']['output'];
  cancelSimulation: Scalars['Boolean']['output'];
  changeBaseScenario: Scalars['Boolean']['output'];
  changeCurrency?: Maybe<NexoyaTeam>;
  changeProposalDataApplicationType?: Maybe<NexoyaBudgetProposal>;
  checkForStuckOptimizations?: Maybe<Scalars['Boolean']['output']>;
  computeBudgetProposalBiddingStrategies?: Maybe<NexoyaBudgetProposal>;
  computeBudgetProposalBudgets?: Maybe<NexoyaComputeBudgetProposalBudgetsReturnType>;
  concludeOptimizationBudgetProposal: NexoyaOptimizationV2;
  copyPortfolio?: Maybe<NexoyaPortfolio>;
  copyReport?: Maybe<NexoyaReport>;
  createAttributionModel: NexoyaAttributionModel;
  createAttributionRule: NexoyaCreateAttributionRuleAndDiscoverContentsMutationResponse;
  createBudgetItem?: Maybe<NexoyaBudgetItem>;
  createBudgetProposal?: Maybe<NexoyaBudgetProposal>;
  createCalculatedMetricParameter: NexoyaCalculatedMetricParameter;
  createCollection?: Maybe<NexoyaCollection>;
  createContentLabelCategory: NexoyaContentLabelCategory;
  createContentLabelCategoryValue: NexoyaContentLabelCategoryValue;
  createContentRule: NexoyaCreateContentRuleMutationResponse;
  createCustomKpi?: Maybe<NexoyaCustomKpi>;
  createCustomTrendSignal: NexoyaTrendSignal;
  createFunnelStepMappingPreset: NexoyaFunnelStepMappingPreset;
  createGoogleTrendsKeywordTrendSignal: NexoyaTrendSignal;
  createImpactGroupRule: NexoyaCreateImpactGroupRuleMutationResponse;
  createOnboardingData?: Maybe<Scalars['Boolean']['output']>;
  createOptimization: NexoyaOptimizationV2;
  createOptimizationPreflight: NexoyaOptimizationPreflight;
  createOrUpdateLabel: NexoyaPortfolioLabel;
  createOrUpdatePortfolioImpactGroup: NexoyaImpactGroup;
  createParentCollection?: Maybe<NexoyaCollection>;
  createPerformanceViewBookmark: NexoyaPerformanceViewBookmark;
  createPerformanceViewLayout: NexoyaPerformanceViewLayout;
  createPortfolio?: Maybe<NexoyaPortfolio>;
  createPortfolioEvent: NexoyaCreatePortfolioEventMutationResponse;
  createPortfolioTargetItem?: Maybe<NexoyaPortfolioTargetItem>;
  createReport?: Maybe<NexoyaReport>;
  createSimulation: NexoyaSimulation;
  createWeatherTrendSignal: NexoyaTrendSignal;
  deactivatePortfolio?: Maybe<Scalars['Boolean']['output']>;
  deleteAttributionModel: Scalars['Boolean']['output'];
  deleteAttributionModelFile: Scalars['Boolean']['output'];
  deleteAttributionRule: Scalars['Boolean']['output'];
  deleteBudgetItem?: Maybe<Scalars['Boolean']['output']>;
  deleteCalculatedMetricParameter: Scalars['Boolean']['output'];
  deleteContentLabelCategory: Scalars['Boolean']['output'];
  deleteContentLabelCategoryValue: Scalars['Boolean']['output'];
  deleteContentRule: Scalars['Boolean']['output'];
  deleteCustomImportData: Scalars['Int']['output'];
  deleteCustomKpi?: Maybe<Scalars['Boolean']['output']>;
  deleteFunnelStep?: Maybe<Scalars['Boolean']['output']>;
  deleteFunnelStepMappingPreset: Scalars['Boolean']['output'];
  deleteImpactGroupRule: Scalars['Boolean']['output'];
  deleteIntegration?: Maybe<Scalars['Boolean']['output']>;
  deleteLabel: Scalars['Boolean']['output'];
  deleteManyContentsById: Scalars['Boolean']['output'];
  deleteOptimization?: Maybe<Scalars['Boolean']['output']>;
  deleteParentCollection?: Maybe<Scalars['Boolean']['output']>;
  deletePerformanceViewBookmark: Scalars['Boolean']['output'];
  deletePerformanceViewLayout: Scalars['Boolean']['output'];
  deletePortfolioEvent: Scalars['Boolean']['output'];
  deletePortfolioEventAsset: Scalars['Boolean']['output'];
  deletePortfolioImpactGroup?: Maybe<Scalars['Boolean']['output']>;
  deleteReport?: Maybe<Scalars['Boolean']['output']>;
  deleteSimulation: Scalars['Boolean']['output'];
  deleteTrendSignal: Scalars['Boolean']['output'];
  duplicateAttributionModel: NexoyaAttributionModel;
  editBudgetItem?: Maybe<NexoyaBudgetItem>;
  editPortfolioTargetItem?: Maybe<NexoyaPortfolioTargetItem>;
  editSimulation: NexoyaSimulation;
  endBudgetItem?: Maybe<NexoyaBudgetItem>;
  endPortfolioTargetItem?: Maybe<NexoyaPortfolioTargetItem>;
  executeAutomaticFreeFormBiddingStrategyChanges: Array<NexoyaFreeFormBiddingStrategyChangesResult>;
  executeAutomaticFreeFormDailyBudgetChanges: Array<NexoyaFreeFormDailyBudgetChangesResult>;
  executeAutomaticFreeFormLifetimeBudgetChanges: Array<NexoyaFreeFormLifetimeBudgetChangesResult>;
  executeBudgetProposal?: Maybe<NexoyaBudgetProposal>;
  exportAttributionModel: Scalars['Boolean']['output'];
  fixPortfolioContentMetrics: Scalars['Boolean']['output'];
  flushCache?: Maybe<Scalars['Boolean']['output']>;
  inviteShareUser?: Maybe<Scalars['Int']['output']>;
  inviteUser?: Maybe<Scalars['Int']['output']>;
  makeOptimizationVisibleToAllUsers: NexoyaOptimizationV2;
  makeSimulationVisibleToAllUsers: NexoyaSimulation;
  manuallyAssignContentLabel: Scalars['Boolean']['output'];
  markOptimizationAsManuallyApplied: NexoyaOptimizationV2;
  markProposalDataAsApplied?: Maybe<Scalars['Boolean']['output']>;
  publishAttributionModel: Scalars['Boolean']['output'];
  reapplyContentRulesMappings: Scalars['Boolean']['output'];
  refreshPortfolioContentMeasurements?: Maybe<Scalars['Boolean']['output']>;
  rejectAttributionModelResults: Scalars['Boolean']['output'];
  rejectDiscoveredContents: Array<NexoyaDiscoveredContent>;
  removeContentLabelManualAssignments: Scalars['Boolean']['output'];
  removeContentRelation: Scalars['Boolean']['output'];
  removePortfolioContent: Array<NexoyaPortfolioParentContent>;
  removePortfolioContentWithCollectionId: Scalars['Boolean']['output'];
  removePortfolioTargetItem?: Maybe<Scalars['Boolean']['output']>;
  removeReportKpis?: Maybe<Scalars['Boolean']['output']>;
  removeSelectedMeasurement?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  removeUser?: Maybe<Scalars['Boolean']['output']>;
  replaceCurrencyExchangeTimeframes: Array<NexoyaCurrencyExchangeTimeframe>;
  requestAttributionModelResultsRevision: Scalars['Boolean']['output'];
  restoreRemovedDiscoveredContents: Scalars['Boolean']['output'];
  retryContentAutomaticApplication?: Maybe<NexoyaBudgetProposal>;
  retryOptimizationTask?: Maybe<Scalars['Boolean']['output']>;
  revertBudgetProposal?: Maybe<NexoyaBudgetProposal>;
  runSimulation: NexoyaSimulation;
  setMyDefaultPerformanceViewBookmark: Scalars['Boolean']['output'];
  setMyDefaultPerformanceViewLayout: Scalars['Boolean']['output'];
  setSimulationIsArchived: NexoyaSimulation;
  setSimulationMonitoringUrl: NexoyaSimulation;
  setUserInfo?: Maybe<Scalars['Boolean']['output']>;
  setUserState?: Maybe<Scalars['Boolean']['output']>;
  setWhitelistFilter?: Maybe<Scalars['Boolean']['output']>;
  submitOptimizationFeedback: NexoyaSubmitOptimizationFeedbackPayload;
  switchManualContentsToRuleBased: NexoyaApplyRulesToDiscoveredContentsMutationResponse;
  syncTeamChannel: Scalars['Boolean']['output'];
  unassignTrendSignalFromPortfolio: NexoyaTrendSignal;
  updateAttributionModel: NexoyaAttributionModel;
  updateAttributionRuleFactors: NexoyaAttributionRule;
  updateAttributionRuleFilters: NexoyaUpdateAttributionRuleFiltersMutationResponse;
  updateAttributionRuleName: NexoyaAttributionRule;
  updateCalculatedMetricParameter: NexoyaCalculatedMetricParameter;
  updateContentLabelCategory: NexoyaContentLabelCategory;
  updateContentLabelCategoryValue: NexoyaContentLabelCategoryValue;
  updateContentRuleFilters?: Maybe<NexoyaUpdateContentRuleAndContentsMutationResponse>;
  updateContentRuleFunnelStepMappings: NexoyaUpdateContentRuleFunnelStepMappingsMutationResponse;
  updateContentRuleName: NexoyaContentRule;
  updateContentTargetMetric?: Maybe<Scalars['Boolean']['output']>;
  updateCustomKpi?: Maybe<NexoyaCustomKpi>;
  updateDefaultOptimizationTarget?: Maybe<Scalars['Boolean']['output']>;
  updateFeatureFlag: Scalars['Boolean']['output'];
  updateFunnelStepMappingPreset?: Maybe<NexoyaFunnelStepMappingPreset>;
  updateImpactGroupRule?: Maybe<NexoyaUpdateImpactGroupRuleAndContentsMutationResponse>;
  updateOptimization?: Maybe<Scalars['Boolean']['output']>;
  updateOptimizationBudget: NexoyaOptimizationV2;
  updateOptimizationTarget: NexoyaOptimizationV2;
  updatePerformanceViewBookmark: NexoyaPerformanceViewBookmark;
  updatePerformanceViewLayout: NexoyaPerformanceViewLayout;
  updatePortfolio?: Maybe<NexoyaPortfolio>;
  updatePortfolioContentBudgetBoundaries: Scalars['Boolean']['output'];
  updatePortfolioContentTargetBoundaries: Scalars['Boolean']['output'];
  updatePortfolioContentsIncludedInOptimization: Array<NexoyaPortfolioParentContent>;
  updatePortfolioEvent: NexoyaUpdatePortfolioEventMutationResponse;
  updateReport?: Maybe<NexoyaReport>;
  updateRuleBasedPorfolioContentsToManual: Array<NexoyaPortfolioParentContent>;
  /** @deprecated Use `updateCampaignMeasurements`. */
  updateSelectedKPIs?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** @deprecated Use `addSelectedMeasurement` and `removeSelectedMeasurement`. */
  updateSelectedMeasurements?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  updateTeam?: Maybe<NexoyaTeam>;
  updateTeamFeatureFlag?: Maybe<NexoyaTeam>;
  updateTeamMemberRole?: Maybe<Scalars['Boolean']['output']>;
  upsertPortfolioFunnelSteps: Array<NexoyaFunnelStepV2>;
  upsertPortfolioImpactGroups: Array<NexoyaImpactGroup>;
  upsertProviderKey?: Maybe<NexoyaProviderKey>;
  upsertTeam?: Maybe<NexoyaTeam>;
  upsertTeamRole?: Maybe<Scalars['Boolean']['output']>;
  whitelistViews?: Maybe<Scalars['Boolean']['output']>;
};


export type NexoyaMutationAcceptAttributionModelResultsArgs = {
  attributionModelId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationAcceptDiscoveredContentsArgs = {
  discoveredContentIds: Array<Scalars['Float']['input']>;
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationActivateAttributionArgs = {
  attributedFunnelStepTitle: Scalars['String']['input'];
  createCopy: Scalars['Boolean']['input'];
  measuredFunnelStepId?: InputMaybe<Scalars['Int']['input']>;
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationAddManualContentsToPorfolioArgs = {
  collectionIds: Array<Scalars['Float']['input']>;
  funnelStepMappings?: InputMaybe<Array<NexoyaManualContentFunnelStepMappingInput>>;
  impactGroupId?: InputMaybe<Scalars['Int']['input']>;
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationAddManualIntegrationArgs = {
  data: Scalars['String']['input'];
  provider_id: Scalars['Int']['input'];
  team_id: Scalars['Int']['input'];
};


export type NexoyaMutationAddManyContentRelationsArgs = {
  contentRelations: Array<NexoyaPortfolioContentRelationInput>;
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationAddPortfolioContentArgs = {
  collectionIds: Array<Scalars['Float']['input']>;
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationAddReportKpisArgs = {
  kpis: Array<NexoyaKpiInputOptMetric>;
  report_id: Scalars['Int']['input'];
};


export type NexoyaMutationAddSelectedMeasurementArgs = {
  collection_id: Scalars['Float']['input'];
  measurement_id: Scalars['Int']['input'];
  team_id: Scalars['Int']['input'];
};


export type NexoyaMutationApplyRulesToDiscoveredContentsArgs = {
  discoveredContentsWithRulesToApply: Array<NexoyaApplyRulesToDiscoveredContentsRulesMapInput>;
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationApplySimulationArgs = {
  portfolioId: Scalars['Float']['input'];
  scenarioId: Scalars['Float']['input'];
  simulationId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationAssignContentsAndRulesToPortfolioEventsArgs = {
  assignedContentIds: Array<InputMaybe<Scalars['Float']['input']>>;
  contentRuleIds: Array<InputMaybe<Scalars['Float']['input']>>;
  includesAllContents: Scalars['Boolean']['input'];
  portfolioEventIds: Array<Scalars['Float']['input']>;
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationAssignFunnelStepMetricsToPortfolioContentsArgs = {
  contentIds: Array<Scalars['Float']['input']>;
  funnelStepMappings: Array<NexoyaManualContentFunnelStepMappingInput>;
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationAssignImpactGroupToPortfolioContentsArgs = {
  contentIds: Array<Scalars['Float']['input']>;
  impactGroupId?: InputMaybe<Scalars['Int']['input']>;
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationAssignTrendSignalToPortfolioArgs = {
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
  trendSignalId: Scalars['String']['input'];
};


export type NexoyaMutationBulkAssignFunnelStepMetricsArgs = {
  childrenProviderId?: InputMaybe<Scalars['Int']['input']>;
  excludedContentIds: Array<Scalars['Float']['input']>;
  funnelStepId: Scalars['Int']['input'];
  metricId?: InputMaybe<Scalars['Int']['input']>;
  portfolioId: Scalars['Int']['input'];
  providerId?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type NexoyaMutationBulkAssignLabelsArgs = {
  contentIds: Array<Scalars['Float']['input']>;
  labelId?: InputMaybe<Scalars['Int']['input']>;
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationBulkCreateCustomKpisArgs = {
  customKpiNamesToBeUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customKpis: Array<NexoyaCkBulkCreateInput>;
  team_id: Scalars['Int']['input'];
};


export type NexoyaMutationBulkCreatePortfolioEventsArgs = {
  portfolioEvents: Array<NexoyaBulkCreatePortfolioEventInput>;
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationBulkUpdatePortfolioEventsArgs = {
  portfolioEvents: Array<NexoyaBulkUpdatePortfolioEventInput>;
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationCancelAttributionModelRunArgs = {
  attributionModelId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationCancelOptimizationArgs = {
  optimizationId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationCancelSimulationArgs = {
  portfolioId: Scalars['Float']['input'];
  simulationId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationChangeBaseScenarioArgs = {
  newBaseScenarioId: Scalars['Float']['input'];
  portfolioId: Scalars['Float']['input'];
  simulationId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationChangeCurrencyArgs = {
  currency: Scalars['String']['input'];
  number_format: Scalars['String']['input'];
  team_id: Scalars['Int']['input'];
};


export type NexoyaMutationChangeProposalDataApplicationTypeArgs = {
  newApplicationType: NexoyaBudgetProposalDataApplicationType;
  optimizationId: Scalars['Int']['input'];
  portfolioContentId: Scalars['Float']['input'];
  portfolioId?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationComputeBudgetProposalBiddingStrategiesArgs = {
  A_ImpactReducer_ProposedBudgetChange?: InputMaybe<Scalars['Float']['input']>;
  B_ImpactReducer_BidStrategyTargetDelta?: InputMaybe<Scalars['Float']['input']>;
  C_ImpactReducer_BudgetApplicationDelta?: InputMaybe<Scalars['Float']['input']>;
  boundaryPercent?: InputMaybe<Scalars['Float']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  optimizationId: Scalars['Int']['input'];
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type NexoyaMutationComputeBudgetProposalBudgetsArgs = {
  optimizationId: Scalars['Int']['input'];
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationConcludeOptimizationBudgetProposalArgs = {
  accept: Scalars['Boolean']['input'];
  optimizationId: Scalars['Int']['input'];
  skipContentIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationCopyPortfolioArgs = {
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
  type?: InputMaybe<NexoyaPortfolioType>;
};


export type NexoyaMutationCopyReportArgs = {
  report_id: Scalars['Int']['input'];
};


export type NexoyaMutationCreateAttributionModelArgs = {
  channelFilters: Array<NexoyaAttributionModelChannelFilterInput>;
  customization: NexoyaAttributionModelCustomizationInput;
  exportStart: Scalars['Date']['input'];
  ga4Filters: NexoyaAttributionModelGa4FiltersInput;
  name: Scalars['String']['input'];
  targetMetric: Scalars['String']['input'];
  targetMetricType: NexoyaAttributionModelTargetMetricType;
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationCreateAttributionRuleArgs = {
  filters: NexoyaAttributionRuleFiltersInput;
  name: Scalars['String']['input'];
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationCreateBudgetItemArgs = {
  budgetAmount: Scalars['Float']['input'];
  endDate: Scalars['Date']['input'];
  name: Scalars['String']['input'];
  pacing: NexoyaPacingType;
  portfolioId: Scalars['Int']['input'];
  startDate: Scalars['Date']['input'];
  suspendedDate?: InputMaybe<Scalars['Date']['input']>;
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationCreateBudgetProposalArgs = {
  optimizationId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationCreateCalculatedMetricParameterArgs = {
  name: Scalars['String']['input'];
  staticValue?: InputMaybe<Scalars['Float']['input']>;
  teamId: Scalars['Int']['input'];
  timeVaryingValues?: InputMaybe<Array<NexoyaCalculatedMetricTimeVaryingParameterValueInput>>;
  type: NexoyaCalculatedMetricParameterType;
  unit: NexoyaCalculatedMetricParameterUnit;
};


export type NexoyaMutationCreateCollectionArgs = {
  collection?: InputMaybe<NexoyaCollectionInput>;
};


export type NexoyaMutationCreateContentLabelCategoryArgs = {
  create: NexoyaContentLabelCategoryCreateInput;
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationCreateContentLabelCategoryValueArgs = {
  create: NexoyaContentLabelCategoryValueCreateInput;
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationCreateContentRuleArgs = {
  contentIdsToAccept: Array<Scalars['Float']['input']>;
  filters: NexoyaContentRuleFiltersInput;
  name: Scalars['String']['input'];
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationCreateCustomKpiArgs = {
  calc_type: NexoyaCalcType;
  description?: InputMaybe<Scalars['String']['input']>;
  kpis?: InputMaybe<Array<NexoyaCkKpiInput>>;
  name: Scalars['String']['input'];
  noDataFetch?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<NexoyaCkSearchInput>;
  team_id: Scalars['Int']['input'];
};


export type NexoyaMutationCreateCustomTrendSignalArgs = {
  create: NexoyaCustomTrendSignalCreateInput;
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationCreateFunnelStepMappingPresetArgs = {
  mapping: NexoyaFunnelStepMappingInput;
  name: Scalars['String']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationCreateGoogleTrendsKeywordTrendSignalArgs = {
  create: NexoyaGoogleTrendsKeywordTrendSignalCreateInput;
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationCreateImpactGroupRuleArgs = {
  filters: NexoyaImpactGroupRuleFiltersInput;
  impactGroupId: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationCreateOnboardingDataArgs = {
  team_id: Scalars['Int']['input'];
};


export type NexoyaMutationCreateOptimizationArgs = {
  end: Scalars['Date']['input'];
  ignoreWeekdays?: InputMaybe<Array<NexoyaWeekday>>;
  optimizationPreflightId: Scalars['String']['input'];
  portfolioId: Scalars['Int']['input'];
  skipCustomImportCheck?: InputMaybe<Scalars['Boolean']['input']>;
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationCreateOptimizationPreflightArgs = {
  ignoreWeekdays: Array<NexoyaWeekday>;
  optimizationEnd: Scalars['Date']['input'];
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationCreateOrUpdateLabelArgs = {
  labelId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationCreateOrUpdatePortfolioImpactGroupArgs = {
  funnelStepIds: Array<Scalars['Int']['input']>;
  impactGroupId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationCreateParentCollectionArgs = {
  children?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  collection?: InputMaybe<NexoyaCollectionInput>;
};


export type NexoyaMutationCreatePerformanceViewBookmarkArgs = {
  create: NexoyaPerformanceViewBookmarkCreateInput;
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationCreatePerformanceViewLayoutArgs = {
  create: NexoyaPerformanceViewLayoutCreateInput;
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationCreatePortfolioArgs = {
  budgetDeltaHandlingPolicy?: InputMaybe<NexoyaBudgetDeltaHandlingPolicy>;
  contents?: InputMaybe<Array<Scalars['Float']['input']>>;
  createdByUserId: Scalars['Int']['input'];
  defaultOptimizationTarget: NexoyaFunnelStepType;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['DateTime']['input'];
  isAttributed?: InputMaybe<Scalars['Boolean']['input']>;
  optimizationRiskLevel: Scalars['Int']['input'];
  optimizationType: NexoyaOptimizationType;
  skipTrainingDays?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['DateTime']['input'];
  teamId: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  type: NexoyaPortfolioType;
};


export type NexoyaMutationCreatePortfolioEventArgs = {
  category: NexoyaEventCategory;
  description?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['Date']['input'];
  impact: NexoyaEventImpact;
  name: Scalars['String']['input'];
  portfolioId: Scalars['Float']['input'];
  start: Scalars['Date']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationCreatePortfolioTargetItemArgs = {
  end: Scalars['Date']['input'];
  maxBudget: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  portfolioId: Scalars['Int']['input'];
  start: Scalars['Date']['input'];
  teamId: Scalars['Int']['input'];
  value: Scalars['Float']['input'];
};


export type NexoyaMutationCreateReportArgs = {
  config?: InputMaybe<Scalars['String']['input']>;
  dateRange: NexoyaReportDateRangeInput;
  description?: InputMaybe<Scalars['String']['input']>;
  kpis?: InputMaybe<Array<InputMaybe<NexoyaKpiInputOptMetric>>>;
  name: Scalars['String']['input'];
  report_type?: InputMaybe<Scalars['String']['input']>;
  team_id: Scalars['Int']['input'];
};


export type NexoyaMutationCreateSimulationArgs = {
  budgetStepSize: Scalars['Int']['input'];
  budgetSteps: Array<NexoyaSimulationBudgetStepInput>;
  end: Scalars['Date']['input'];
  ignoreContentBudgetLimits: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  portfolioId: Scalars['Int']['input'];
  skipNonOptimizedContentBudgets: Scalars['Boolean']['input'];
  start: Scalars['Date']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationCreateWeatherTrendSignalArgs = {
  create: NexoyaWeatherTrendSignalCreateInput;
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationDeactivatePortfolioArgs = {
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationDeleteAttributionModelArgs = {
  attributionModelId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationDeleteAttributionModelFileArgs = {
  attributionModelFileId: Scalars['Int']['input'];
  attributionModelId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationDeleteAttributionRuleArgs = {
  attributionRuleId: Scalars['Float']['input'];
  contentActions: Array<NexoyaDeleteAttributionRuleContentActionInput>;
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationDeleteBudgetItemArgs = {
  budgetItemId: Scalars['Int']['input'];
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationDeleteCalculatedMetricParameterArgs = {
  calculatedMetricParameterId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationDeleteContentLabelCategoryArgs = {
  delete: NexoyaContentLabelCategoryDeleteInput;
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationDeleteContentLabelCategoryValueArgs = {
  delete: NexoyaContentLabelCategoryValueDeleteInput;
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationDeleteContentRuleArgs = {
  contentActions: Array<NexoyaDeleteContentRuleContentActionInput>;
  contentRuleId: Scalars['Float']['input'];
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationDeleteCustomImportDataArgs = {
  collectionIds?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  nOfKpisToDeleteConfirm: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationDeleteCustomKpiArgs = {
  custom_kpi_id: Scalars['Int']['input'];
};


export type NexoyaMutationDeleteFunnelStepArgs = {
  funnelStepId: Scalars['Int']['input'];
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationDeleteFunnelStepMappingPresetArgs = {
  funnelStepMappingPresetId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationDeleteImpactGroupRuleArgs = {
  contentActions: Array<NexoyaDeleteImpactGroupRuleContentActionInput>;
  impactGroupRuleId: Scalars['Float']['input'];
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationDeleteIntegrationArgs = {
  provider_id: Scalars['Int']['input'];
  provider_key_id?: InputMaybe<Scalars['Int']['input']>;
  team_id: Scalars['Int']['input'];
};


export type NexoyaMutationDeleteLabelArgs = {
  labelId: Scalars['Int']['input'];
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationDeleteManyContentsByIdArgs = {
  contentIds: Array<Scalars['Float']['input']>;
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationDeleteOptimizationArgs = {
  optimizationId: Scalars['Int']['input'];
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationDeleteParentCollectionArgs = {
  id: Scalars['Int']['input'];
};


export type NexoyaMutationDeletePerformanceViewBookmarkArgs = {
  performanceViewBookmarkId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationDeletePerformanceViewLayoutArgs = {
  performanceViewLayoutId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationDeletePortfolioEventArgs = {
  portfolioEventId: Scalars['Float']['input'];
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationDeletePortfolioEventAssetArgs = {
  portfolioEventId: Scalars['Float']['input'];
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationDeletePortfolioImpactGroupArgs = {
  impactGroupId: Scalars['Int']['input'];
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationDeleteReportArgs = {
  report_id: Scalars['Int']['input'];
  team_id: Scalars['Int']['input'];
};


export type NexoyaMutationDeleteSimulationArgs = {
  portfolioId: Scalars['Float']['input'];
  simulationId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationDeleteTrendSignalArgs = {
  teamId: Scalars['Int']['input'];
  trendSignalId: Scalars['String']['input'];
};


export type NexoyaMutationDuplicateAttributionModelArgs = {
  attributionModelId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationEditBudgetItemArgs = {
  budgetAmount?: InputMaybe<Scalars['Float']['input']>;
  budgetItemId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  portfolioId: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationEditPortfolioTargetItemArgs = {
  end?: InputMaybe<Scalars['Date']['input']>;
  maxBudget?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  portfolioId: Scalars['Int']['input'];
  start?: InputMaybe<Scalars['Date']['input']>;
  targetItemId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
};


export type NexoyaMutationEditSimulationArgs = {
  budgetStepSize?: InputMaybe<Scalars['Int']['input']>;
  budgetSteps?: InputMaybe<Array<NexoyaSimulationBudgetStepInput>>;
  end?: InputMaybe<Scalars['Date']['input']>;
  ignoreContentBudgetLimits?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  portfolioId: Scalars['Float']['input'];
  simulationId: Scalars['Float']['input'];
  skipNonOptimizedContentBudgets?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationEndBudgetItemArgs = {
  budgetItemId: Scalars['Int']['input'];
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationEndPortfolioTargetItemArgs = {
  portfolioId: Scalars['Int']['input'];
  targetItemId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationExecuteAutomaticFreeFormBiddingStrategyChangesArgs = {
  changes: Array<NexoyaFreeFormBiddingStrategyChangeInput>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationExecuteAutomaticFreeFormDailyBudgetChangesArgs = {
  changes: Array<NexoyaFreeFormDailyBudgetChangeInput>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationExecuteAutomaticFreeFormLifetimeBudgetChangesArgs = {
  changes: Array<NexoyaFreeFormLifetimeBudgetChangeInput>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationExecuteBudgetProposalArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  optimizationId: Scalars['Int']['input'];
  portfolioContentIdsToApplyManually?: InputMaybe<Array<Scalars['Float']['input']>>;
  targetBiddingApplyMode: NexoyaTargetBiddingApplyMode;
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationExportAttributionModelArgs = {
  attributionModelId: Scalars['String']['input'];
  skippedProviderIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationFixPortfolioContentMetricsArgs = {
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationFlushCacheArgs = {
  portfolioId?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationInviteShareUserArgs = {
  shareType: NexoyaShareType;
  sharingObjectName?: InputMaybe<NexoyaSharingObjectName>;
  team_id: Scalars['Int']['input'];
  to_email: Scalars['String']['input'];
  to_name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};


export type NexoyaMutationInviteUserArgs = {
  role: NexoyaTeamRoleType;
  team_id: Scalars['Int']['input'];
  to_email: Scalars['String']['input'];
  to_name: Scalars['String']['input'];
};


export type NexoyaMutationMakeOptimizationVisibleToAllUsersArgs = {
  optimizationId: Scalars['Int']['input'];
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationMakeSimulationVisibleToAllUsersArgs = {
  portfolioId: Scalars['Float']['input'];
  simulationId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationManuallyAssignContentLabelArgs = {
  assign: NexoyaManuallyAssignContentLabelInput;
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationMarkOptimizationAsManuallyAppliedArgs = {
  appliedByUserId?: InputMaybe<Scalars['Int']['input']>;
  optimizationId: Scalars['Int']['input'];
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationMarkProposalDataAsAppliedArgs = {
  optimizationId: Scalars['Int']['input'];
  portfolioContentIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationPublishAttributionModelArgs = {
  attributionModelId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationReapplyContentRulesMappingsArgs = {
  contentRuleIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationRefreshPortfolioContentMeasurementsArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  portfolioId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationRejectAttributionModelResultsArgs = {
  attributionModelId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationRejectDiscoveredContentsArgs = {
  discoveredContentIds: Array<Scalars['Float']['input']>;
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationRemoveContentLabelManualAssignmentsArgs = {
  remove: NexoyaRemoveContentLabelManualAssignmentsInput;
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationRemoveContentRelationArgs = {
  contentId: Scalars['Float']['input'];
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationRemovePortfolioContentArgs = {
  portfolioContentIds: Array<Scalars['Int']['input']>;
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationRemovePortfolioContentWithCollectionIdArgs = {
  collectionIds: Array<Scalars['Float']['input']>;
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationRemovePortfolioTargetItemArgs = {
  portfolioId: Scalars['Int']['input'];
  targetItemId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationRemoveReportKpisArgs = {
  kpis: Array<NexoyaKpiInputOptMetric>;
  report_id: Scalars['Int']['input'];
};


export type NexoyaMutationRemoveSelectedMeasurementArgs = {
  collection_id: Scalars['Float']['input'];
  measurement_id: Scalars['Int']['input'];
  team_id: Scalars['Int']['input'];
};


export type NexoyaMutationRemoveUserArgs = {
  team_id: Scalars['Int']['input'];
  user_to_remove_id: Scalars['Int']['input'];
};


export type NexoyaMutationReplaceCurrencyExchangeTimeframesArgs = {
  teamId: Scalars['Int']['input'];
  timeframes: Array<NexoyaCurrencyExchangeTimeframeInput>;
};


export type NexoyaMutationRequestAttributionModelResultsRevisionArgs = {
  attributionModelId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationRestoreRemovedDiscoveredContentsArgs = {
  contentIds: Array<Scalars['Float']['input']>;
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationRetryContentAutomaticApplicationArgs = {
  contentId: Scalars['Float']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  optimizationId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationRetryOptimizationTaskArgs = {
  optimizationId: Scalars['Int']['input'];
  portfolioId: Scalars['Int']['input'];
  taskToRetry: NexoyaOptimizationTaskType;
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationRevertBudgetProposalArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  optimizationId: Scalars['Int']['input'];
  targetBiddingApplyMode: NexoyaTargetBiddingApplyMode;
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationRunSimulationArgs = {
  portfolioId: Scalars['Float']['input'];
  simulationId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationSetMyDefaultPerformanceViewBookmarkArgs = {
  performanceViewBookmarkId?: InputMaybe<Scalars['Int']['input']>;
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationSetMyDefaultPerformanceViewLayoutArgs = {
  performanceViewLayoutId?: InputMaybe<Scalars['Int']['input']>;
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationSetSimulationIsArchivedArgs = {
  isArchived: Scalars['Boolean']['input'];
  portfolioId: Scalars['Float']['input'];
  simulationId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationSetSimulationMonitoringUrlArgs = {
  monitoringUrl?: InputMaybe<Scalars['String']['input']>;
  portfolioId: Scalars['Float']['input'];
  simulationId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationSetUserInfoArgs = {
  userInfo: NexoyaUserInfo;
};


export type NexoyaMutationSetUserStateArgs = {
  state: NexoyaUserStateEnum;
};


export type NexoyaMutationSetWhitelistFilterArgs = {
  addList?: InputMaybe<Array<Scalars['String']['input']>>;
  filterList?: InputMaybe<Array<Scalars['String']['input']>>;
  filterName: Scalars['String']['input'];
  lastFilter?: InputMaybe<Scalars['Boolean']['input']>;
  provider_id: Scalars['Int']['input'];
  removeList?: InputMaybe<Array<Scalars['String']['input']>>;
  team_id: Scalars['Int']['input'];
};


export type NexoyaMutationSubmitOptimizationFeedbackArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  optimizationId: Scalars['Int']['input'];
  portfolioId: Scalars['Int']['input'];
  ratings: NexoyaOptimizationFeedbackRatingsInput;
  teamId: Scalars['Int']['input'];
  triggerAction: NexoyaOptimizationFeedbackTriggerAction;
};


export type NexoyaMutationSwitchManualContentsToRuleBasedArgs = {
  discoveredContentsWithRulesToApply: Array<NexoyaApplyRulesToDiscoveredContentsRulesMapInput>;
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationSyncTeamChannelArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  providerId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type NexoyaMutationUnassignTrendSignalFromPortfolioArgs = {
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
  trendSignalId: Scalars['String']['input'];
};


export type NexoyaMutationUpdateAttributionModelArgs = {
  attributionModelId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
  updates: NexoyaUpdateAttributionModelInput;
};


export type NexoyaMutationUpdateAttributionRuleFactorsArgs = {
  attributionRuleId: Scalars['Float']['input'];
  factors: Array<NexoyaAttributionRuleFactorInput>;
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationUpdateAttributionRuleFiltersArgs = {
  attributionRuleId: Scalars['Float']['input'];
  contentActions: Array<NexoyaUpdateAttributionRuleFiltersContentActionInput>;
  filters: NexoyaAttributionRuleFiltersInput;
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationUpdateAttributionRuleNameArgs = {
  attributionRuleId: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationUpdateCalculatedMetricParameterArgs = {
  calculatedMetricParameterId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  staticValue?: InputMaybe<Scalars['Float']['input']>;
  teamId: Scalars['Int']['input'];
  timeVaryingValues?: InputMaybe<Array<NexoyaCalculatedMetricTimeVaryingParameterValueInput>>;
  type?: InputMaybe<NexoyaCalculatedMetricParameterType>;
  unit?: InputMaybe<NexoyaCalculatedMetricParameterUnit>;
};


export type NexoyaMutationUpdateContentLabelCategoryArgs = {
  teamId: Scalars['Int']['input'];
  update: NexoyaContentLabelCategoryUpdateInput;
};


export type NexoyaMutationUpdateContentLabelCategoryValueArgs = {
  teamId: Scalars['Int']['input'];
  update: NexoyaContentLabelCategoryValueUpdateInput;
};


export type NexoyaMutationUpdateContentRuleFiltersArgs = {
  contentActions: Array<NexoyaUpdateContentRuleFiltersContentActionInput>;
  contentRuleId: Scalars['Float']['input'];
  filters: NexoyaContentRuleFiltersInput;
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationUpdateContentRuleFunnelStepMappingsArgs = {
  contentRuleId: Scalars['Float']['input'];
  funnelStepMappings: Array<NexoyaContentRuleFunnelStepMappingInput>;
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationUpdateContentRuleNameArgs = {
  contentRuleId: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationUpdateContentTargetMetricArgs = {
  contentFunnelStepMetric: NexoyaPortfolioContentFunnelStepMetricInput;
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationUpdateCustomKpiArgs = {
  calc_type?: InputMaybe<NexoyaCalcType>;
  custom_kpi_id: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  kpis?: InputMaybe<Array<NexoyaCkKpiInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<NexoyaCkSearchInput>;
};


export type NexoyaMutationUpdateDefaultOptimizationTargetArgs = {
  funnelStepId: Scalars['Int']['input'];
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationUpdateFeatureFlagArgs = {
  name: NexoyaPortfolioFeatureFlag;
  portfolioId: Scalars['Int']['input'];
  status: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationUpdateFunnelStepMappingPresetArgs = {
  funnelStepMappingPresetId: Scalars['Float']['input'];
  mapping?: InputMaybe<NexoyaFunnelStepMappingInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationUpdateImpactGroupRuleArgs = {
  contentActions?: InputMaybe<Array<InputMaybe<NexoyaUpdateImpactGroupRuleFiltersContentActionInput>>>;
  impactGroupRuleEdit: NexoyaImpactGroupRuleEditInput;
  impactGroupRuleId: Scalars['Float']['input'];
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationUpdateOptimizationArgs = {
  attachment?: InputMaybe<Scalars['String']['input']>;
  dateApplied?: InputMaybe<Scalars['DateTime']['input']>;
  dateArchived?: InputMaybe<Scalars['DateTime']['input']>;
  dateCreated?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  optimizationId: Scalars['Int']['input'];
  portfolioId: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  teamId: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type NexoyaMutationUpdateOptimizationBudgetArgs = {
  budget: Scalars['Float']['input'];
  optimizationId: Scalars['Int']['input'];
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationUpdateOptimizationTargetArgs = {
  maxSpend: Scalars['Float']['input'];
  optimizationId: Scalars['Int']['input'];
  portfolioId: Scalars['Int']['input'];
  target: Scalars['Float']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationUpdatePerformanceViewBookmarkArgs = {
  performanceViewBookmarkId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
  update: NexoyaPerformanceViewBookmarkUpdateInput;
};


export type NexoyaMutationUpdatePerformanceViewLayoutArgs = {
  performanceViewLayoutId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
  update: NexoyaPerformanceViewLayoutUpdateInput;
};


export type NexoyaMutationUpdatePortfolioArgs = {
  budgetDeltaHandlingPolicy?: InputMaybe<NexoyaBudgetDeltaHandlingPolicy>;
  budgetProposalTargetBiddingApplyMode?: InputMaybe<NexoyaTargetBiddingApplyMode>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  optimizationRiskLevel?: InputMaybe<Scalars['Int']['input']>;
  optimizationType?: InputMaybe<NexoyaOptimizationType>;
  portfolioDashboardUrls?: InputMaybe<Array<InputMaybe<NexoyaPortfolioDashboardUrlInput>>>;
  portfolioId: Scalars['Int']['input'];
  portfolioMonitorBudgetThreshold?: InputMaybe<Scalars['Int']['input']>;
  skipTrainingDays?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  teamId: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type NexoyaMutationUpdatePortfolioContentBudgetBoundariesArgs = {
  newBudget: NexoyaPortfolioContentBudgetInput;
  onlyContentIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationUpdatePortfolioContentTargetBoundariesArgs = {
  newTarget: NexoyaPortfolioContentTargetBoundariesInput;
  onlyContentIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationUpdatePortfolioContentsIncludedInOptimizationArgs = {
  isIncludedInOptimization: Scalars['Boolean']['input'];
  portfolioContentIds: Array<Scalars['Float']['input']>;
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationUpdatePortfolioEventArgs = {
  category?: InputMaybe<NexoyaEventCategory>;
  description?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['Date']['input']>;
  impact?: InputMaybe<NexoyaEventImpact>;
  name?: InputMaybe<Scalars['String']['input']>;
  portfolioEventId: Scalars['Float']['input'];
  portfolioId: Scalars['Float']['input'];
  start?: InputMaybe<Scalars['Date']['input']>;
  teamId: Scalars['Float']['input'];
};


export type NexoyaMutationUpdateReportArgs = {
  config?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<NexoyaReportDateRangeInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  report_id: Scalars['Int']['input'];
};


export type NexoyaMutationUpdateRuleBasedPorfolioContentsToManualArgs = {
  collectionIds: Array<Scalars['Float']['input']>;
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationUpdateSelectedKpIsArgs = {
  kpi_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  team_id: Scalars['Int']['input'];
};


export type NexoyaMutationUpdateSelectedMeasurementsArgs = {
  measurement_collection?: InputMaybe<Array<InputMaybe<NexoyaMeasurementCollectionInput>>>;
  team_id: Scalars['Int']['input'];
};


export type NexoyaMutationUpdateTeamArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dashboardUrls?: InputMaybe<Array<NexoyaDashboardUrlInput>>;
  featureFlags?: InputMaybe<Array<NexoyaFeatureFlagInput>>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberFormat?: InputMaybe<Scalars['String']['input']>;
  onboarding?: InputMaybe<NexoyaOnboardingInput>;
  plan?: InputMaybe<NexoyaTeamPlan>;
  team_id: Scalars['Int']['input'];
};


export type NexoyaMutationUpdateTeamFeatureFlagArgs = {
  name: Scalars['String']['input'];
  status: Scalars['Boolean']['input'];
  team_id: Scalars['Int']['input'];
};


export type NexoyaMutationUpdateTeamMemberRoleArgs = {
  new_role_def: Scalars['String']['input'];
  team_id: Scalars['Int']['input'];
  user_id: Scalars['Int']['input'];
};


export type NexoyaMutationUpsertPortfolioFunnelStepsArgs = {
  funnelSteps: Array<NexoyaUpsertPortfolioFunnelStepsMutationFunnelStepInput>;
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationUpsertPortfolioImpactGroupsArgs = {
  impactGroups: Array<NexoyaUpsertImpactGroupInput>;
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaMutationUpsertProviderKeyArgs = {
  item?: InputMaybe<NexoyaProviderKeyInput>;
};


export type NexoyaMutationUpsertTeamArgs = {
  org?: InputMaybe<NexoyaTeamWithOrgInput>;
  team?: InputMaybe<NexoyaTeamInput>;
};


export type NexoyaMutationUpsertTeamRoleArgs = {
  role_def: Scalars['String']['input'];
  team_id: Scalars['Int']['input'];
  user_email?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type NexoyaMutationWhitelistViewsArgs = {
  provider_id: Scalars['Int']['input'];
  team_id: Scalars['Int']['input'];
  viewIds: Array<Scalars['Int']['input']>;
};

export type NexoyaNewOptimizationSummary = {
  __typename?: 'NewOptimizationSummary';
  allContentsHaveImpactGroupAssigned: Scalars['Boolean']['output'];
  attribution: NexoyaNewOptimizationSummaryAttributionPrecheck;
  daysWithMissingBudget: Array<Scalars['Date']['output']>;
  ignoreWeekdays: Array<NexoyaWeekday>;
  isCustomImportDataFresh: Scalars['Boolean']['output'];
  isOptiPeriodSpanningMultipleTargetItems: Scalars['Boolean']['output'];
  missingCurrencyCoverage: Array<NexoyaMissingCurrencyCoverage>;
  previouslyUsedIgnoreWeekdays: Array<NexoyaWeekday>;
  targetItem?: Maybe<NexoyaPortfolioTargetItem>;
  totalBudget: Scalars['Float']['output'];
};

export type NexoyaNewOptimizationSummaryAttributionPrecheck = {
  __typename?: 'NewOptimizationSummaryAttributionPrecheck';
  attributionRuleWithNoFactors: Array<NexoyaAttributionRule>;
  contentWithNoAttributionRules: Array<NexoyaContentV2>;
  hasErrors: Scalars['Boolean']['output'];
};

export type NexoyaNewSimulationSummary = {
  __typename?: 'NewSimulationSummary';
  budgetPreviews: Array<NexoyaSimulationBudgetPreview>;
  hasContentsWithBudgetLimits: Scalars['Boolean']['output'];
  hasDisabledContents: Scalars['Boolean']['output'];
  missingCurrencyCoverage: Array<NexoyaMissingCurrencyCoverage>;
};

export type NexoyaOnboardingInput = {
  onboardingTasks?: InputMaybe<Array<NexoyaOnboardingTaskInput>>;
  videoSrc?: InputMaybe<Scalars['String']['input']>;
};

export type NexoyaOnboardingTaskInput = {
  deadline: Scalars['String']['input'];
  externalLink?: InputMaybe<NexoyaExternalLinkInput>;
  providerId?: InputMaybe<Scalars['Int']['input']>;
  responsible: Scalars['String']['input'];
  status: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type NexoyaOptimizationConnection = {
  __typename?: 'OptimizationConnection';
  edges: Array<NexoyaOptimizationEdge>;
  pageInfo: NexoyaPageInfo;
};

export type NexoyaOptimizationEdge = {
  __typename?: 'OptimizationEdge';
  cursor: Scalars['String']['output'];
  node: NexoyaOptimizationV2;
};

export type NexoyaOptimizationFeedbackRatingsInput = {
  budgetMovementReasonableness: Scalars['Int']['input'];
  overallConfidence: Scalars['Int']['input'];
  predictionRealism: Scalars['Int']['input'];
  targetChangeReasonableness?: InputMaybe<Scalars['Int']['input']>;
};

export enum NexoyaOptimizationFeedbackTriggerAction {
  Cancelled = 'CANCELLED',
  MadeVisible = 'MADE_VISIBLE'
}

export type NexoyaOptimizationLabelMetricTotal = {
  __typename?: 'OptimizationLabelMetricTotal';
  baselineTotal: Scalars['Float']['output'];
  expectedTotal: Scalars['Float']['output'];
  labelId: Scalars['Int']['output'];
};

export type NexoyaOptimizationMetricTotal = {
  __typename?: 'OptimizationMetricTotal';
  baselineTotal: Scalars['Float']['output'];
  expectedTotal: Scalars['Float']['output'];
  labels?: Maybe<Array<NexoyaOptimizationLabelMetricTotal>>;
  potentialPercentage?: Maybe<Scalars['Float']['output']>;
  providers?: Maybe<Array<NexoyaOptimizationProviderMetricTotal>>;
};

export type NexoyaOptimizationPerformance = {
  __typename?: 'OptimizationPerformance';
  attributionRules?: Maybe<Array<NexoyaOptimizedAttributionRule>>;
  channels: Array<NexoyaOptimizedChannel>;
  contentLabels: Array<NexoyaOptimizedContentLabel>;
  contents: Array<NexoyaOptimizedContent>;
  impactGroups: Array<NexoyaOptimizedImpactGroup>;
  labels: Array<NexoyaOptimizedLabel>;
  total: NexoyaOptimizedTotal;
};


export type NexoyaOptimizationPerformanceContentLabelsArgs = {
  contentLabelCategoryId: Scalars['String']['input'];
};

export type NexoyaOptimizationPreflight = {
  __typename?: 'OptimizationPreflight';
  createdAt: Scalars['DateTime']['output'];
  ignoreWeekdays: Array<NexoyaWeekday>;
  optimizationEnd: Scalars['Date']['output'];
  optimizationPreflightId: Scalars['String']['output'];
  status: NexoyaOptimizationPreflightStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type NexoyaOptimizationPreflightExcludedContent = {
  __typename?: 'OptimizationPreflightExcludedContent';
  content: NexoyaContentV2;
  excludedDailyBudget: Scalars['Float']['output'];
  status: NexoyaOptimizedContentStatusReason;
};

export type NexoyaOptimizationPreflightResult = {
  __typename?: 'OptimizationPreflightResult';
  dataSyncCheck: NexoyaOptimizationPreflightResultDataSyncCheck;
  excludedContents: Array<NexoyaOptimizationPreflightExcludedContent>;
  totalExcludedDailyBudget: Scalars['Float']['output'];
};

export type NexoyaOptimizationPreflightResultDataSyncCheck = {
  __typename?: 'OptimizationPreflightResultDataSyncCheck';
  isPortfolioDataSyncing: Scalars['Boolean']['output'];
  isTeamCustomImportDataSyncing: Scalars['Boolean']['output'];
  lastTeamCustomImportSyncDate?: Maybe<Scalars['DateTime']['output']>;
};

export type NexoyaOptimizationPreflightStatus = {
  __typename?: 'OptimizationPreflightStatus';
  errorMessage?: Maybe<Scalars['String']['output']>;
  result?: Maybe<NexoyaOptimizationPreflightResult>;
  type: NexoyaOptimizationPreflightStatusType;
};

export enum NexoyaOptimizationPreflightStatusType {
  Completed = 'COMPLETED',
  Error = 'ERROR',
  Pending = 'PENDING'
}

export type NexoyaOptimizationPreviewEligibility = {
  __typename?: 'OptimizationPreviewEligibility';
  canDisablePreview: Scalars['Boolean']['output'];
  currentRecentHighConfidenceFeedbackCount: Scalars['Int']['output'];
  reason: NexoyaOptimizationPreviewEligibilityReason;
  recentHighConfidenceFeedbacks: Array<NexoyaOptimizationPreviewEligibilityFeedback>;
  requiredRecentHighConfidenceFeedbackCount: Scalars['Int']['output'];
};

export type NexoyaOptimizationPreviewEligibilityFeedback = {
  __typename?: 'OptimizationPreviewEligibilityFeedback';
  optimizationId: Scalars['Int']['output'];
  overallConfidence: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum NexoyaOptimizationPreviewEligibilityReason {
  CurrentFeedbackMissing = 'CURRENT_FEEDBACK_MISSING',
  CurrentFeedbackOverallConfidenceTooLow = 'CURRENT_FEEDBACK_OVERALL_CONFIDENCE_TOO_LOW',
  Eligible = 'ELIGIBLE',
  NotEnoughRecentHighConfidenceFeedback = 'NOT_ENOUGH_RECENT_HIGH_CONFIDENCE_FEEDBACK',
  OptimizationNotSupportOnly = 'OPTIMIZATION_NOT_SUPPORT_ONLY',
  UserNotAuthorized = 'USER_NOT_AUTHORIZED'
}

export type NexoyaOptimizationProviderMetricTotal = {
  __typename?: 'OptimizationProviderMetricTotal';
  baselineTotal: Scalars['Float']['output'];
  expectedTotal: Scalars['Float']['output'];
  providerId: Scalars['Int']['output'];
};

export enum NexoyaOptimizationStatus {
  Applied = 'APPLIED',
  Cancelled = 'CANCELLED',
  Discarded = 'DISCARDED',
  Running = 'RUNNING'
}

export enum NexoyaOptimizationTaskStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING',
  Skipped = 'SKIPPED',
  Successful = 'SUCCESSFUL'
}

export enum NexoyaOptimizationTaskType {
  ApplyingBudgetProposal = 'APPLYING_BUDGET_PROPOSAL',
  GeneratingBudgetProposal = 'GENERATING_BUDGET_PROPOSAL',
  ProposalWaiting = 'PROPOSAL_WAITING',
  RunningOptimization = 'RUNNING_OPTIMIZATION'
}

export type NexoyaOptimizationTasks = {
  __typename?: 'OptimizationTasks';
  APPLYING_BUDGET_PROPOSAL: NexoyaOptimizationTaskStatus;
  GENERATING_BUDGET_PROPOSAL: NexoyaOptimizationTaskStatus;
  PROPOSAL_WAITING: NexoyaOptimizationTaskStatus;
  RUNNING_OPTIMIZATION: NexoyaOptimizationTaskStatus;
};

export enum NexoyaOptimizationType {
  Auto = 'AUTO',
  Manual = 'MANUAL',
  Skip = 'SKIP'
}

export type NexoyaOptimizationV2 = {
  __typename?: 'OptimizationV2';
  appliedAt?: Maybe<Scalars['Date']['output']>;
  appliedByUser?: Maybe<NexoyaUser>;
  appliesBiddingStrategyChanges: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  end: Scalars['Date']['output'];
  ignoreWeekdays?: Maybe<Array<NexoyaWeekday>>;
  isBaselinePredictionRescaled: Scalars['Boolean']['output'];
  isRunSettingsUpdatable: Scalars['Boolean']['output'];
  onlyVisibleToSupportUsers: Scalars['Boolean']['output'];
  optimizationId: Scalars['Int']['output'];
  performance?: Maybe<NexoyaOptimizationPerformance>;
  portfolioEvents: Array<Maybe<NexoyaPortfolioEventSnapshot>>;
  predictiveModelName?: Maybe<Scalars['String']['output']>;
  previewEligibility: NexoyaOptimizationPreviewEligibility;
  start: Scalars['Date']['output'];
  status: NexoyaOptimizationStatus;
  target?: Maybe<Scalars['Float']['output']>;
  tasks: NexoyaOptimizationTasks;
  title: Scalars['String']['output'];
  totalBudget?: Maybe<Scalars['Float']['output']>;
  usedBudgetProposalTargetBiddingApplyMode?: Maybe<NexoyaTargetBiddingApplyMode>;
  user: NexoyaUser;
};

export type NexoyaOptimizedAttributionRule = {
  __typename?: 'OptimizedAttributionRule';
  attributionRule?: Maybe<NexoyaAttributionRule>;
  budget: NexoyaOptimizedDailyBudget;
  funnelSteps: Array<Maybe<NexoyaOptimizedFunnelStep>>;
  target?: Maybe<NexoyaOptimizedTarget>;
};

export type NexoyaOptimizedChannel = {
  __typename?: 'OptimizedChannel';
  budget: NexoyaOptimizedDailyBudget;
  channelId: Scalars['Int']['output'];
  funnelSteps: Array<Maybe<NexoyaOptimizedFunnelStep>>;
  target?: Maybe<NexoyaOptimizedTarget>;
};

export type NexoyaOptimizedContent = {
  __typename?: 'OptimizedContent';
  budget?: Maybe<NexoyaOptimizedDailyBudget>;
  budgetProposalData?: Maybe<NexoyaBudgetProposalData>;
  content: NexoyaCollection;
  funnelSteps?: Maybe<Array<Maybe<NexoyaOptimizedFunnelStep>>>;
  impactGroup?: Maybe<NexoyaImpactGroup>;
  label?: Maybe<NexoyaPortfolioLabel>;
  status?: Maybe<NexoyaOptimizedContentStatus>;
  target?: Maybe<NexoyaOptimizedTarget>;
};

export type NexoyaOptimizedContentLabel = {
  __typename?: 'OptimizedContentLabel';
  budget: NexoyaOptimizedDailyBudget;
  /** Null for the contents without an assigned value in this category (unlabeled or still needing a decision). */
  contentLabelCategoryValue?: Maybe<NexoyaContentLabelCategoryValue>;
  funnelSteps: Array<Maybe<NexoyaOptimizedFunnelStep>>;
  target?: Maybe<NexoyaOptimizedTarget>;
};

export type NexoyaOptimizedContentStatus = {
  __typename?: 'OptimizedContentStatus';
  payload?: Maybe<Array<NexoyaOptimizedContentStatusPayload>>;
  reason: NexoyaOptimizedContentStatusReason;
  type: NexoyaOptimizedContentStatusType;
};

export type NexoyaOptimizedContentStatusPayload = {
  __typename?: 'OptimizedContentStatusPayload';
  appliedBudget?: Maybe<Scalars['Float']['output']>;
  budgetMax?: Maybe<Scalars['Float']['output']>;
  budgetMin?: Maybe<Scalars['Float']['output']>;
  budgetRevenueResponseCurve?: Maybe<Array<Array<Scalars['Float']['output']>>>;
  funnelStep?: Maybe<NexoyaFunnelStepV2>;
  impressionShare?: Maybe<Scalars['Float']['output']>;
  minTargetRoasPercent?: Maybe<Scalars['Float']['output']>;
  plannedBudget?: Maybe<Scalars['Float']['output']>;
  saturationPoint?: Maybe<Array<Scalars['Float']['output']>>;
  saturationProfitPerUnit?: Maybe<Scalars['Float']['output']>;
  saturationScore?: Maybe<Scalars['Float']['output']>;
  saturationTangent?: Maybe<Array<Array<Scalars['Float']['output']>>>;
  spentBudget?: Maybe<Scalars['Float']['output']>;
};

export enum NexoyaOptimizedContentStatusReason {
  BudgetBoundariesMaxBudget = 'BUDGET_BOUNDARIES_MAX_BUDGET',
  BudgetBoundariesMinBudget = 'BUDGET_BOUNDARIES_MIN_BUDGET',
  ContentNotServing = 'CONTENT_NOT_SERVING',
  DisabledOptimization = 'DISABLED_OPTIMIZATION',
  ImpressionShare = 'IMPRESSION_SHARE',
  IsEnding = 'IS_ENDING',
  Materiality = 'MATERIALITY',
  NoData = 'NO_DATA',
  PlannedVsSpent = 'PLANNED_VS_SPENT',
  Saturated = 'SATURATED',
  SpendBelowThreshold = 'SPEND_BELOW_THRESHOLD',
  TargetBoundariesMinRoas = 'TARGET_BOUNDARIES_MIN_ROAS'
}

export enum NexoyaOptimizedContentStatusType {
  Insight = 'INSIGHT',
  Limited = 'LIMITED',
  Skipped = 'SKIPPED'
}

export type NexoyaOptimizedDailyBudget = {
  __typename?: 'OptimizedDailyBudget';
  changePercent: Scalars['Float']['output'];
  proposed: Scalars['Float']['output'];
  spent: Scalars['Float']['output'];
};

export type NexoyaOptimizedFunnelStep = {
  __typename?: 'OptimizedFunnelStep';
  attribution?: Maybe<NexoyaAttributionOptimizedMetric>;
  costPer: NexoyaOptimizedMetric;
  funnelStep: NexoyaFunnelStepV2;
  lowDataVolume: Scalars['Boolean']['output'];
  metric: NexoyaOptimizedMetric;
  roas: NexoyaOptimizedMetric;
};

export type NexoyaOptimizedImpactGroup = {
  __typename?: 'OptimizedImpactGroup';
  budget: NexoyaOptimizedDailyBudget;
  funnelSteps: Array<Maybe<NexoyaOptimizedFunnelStep>>;
  impactGroup?: Maybe<NexoyaImpactGroup>;
  target?: Maybe<NexoyaOptimizedTarget>;
};

export type NexoyaOptimizedLabel = {
  __typename?: 'OptimizedLabel';
  budget: NexoyaOptimizedDailyBudget;
  funnelSteps: Array<Maybe<NexoyaOptimizedFunnelStep>>;
  label?: Maybe<NexoyaPortfolioLabel>;
  target?: Maybe<NexoyaOptimizedTarget>;
};

export type NexoyaOptimizedMetric = {
  __typename?: 'OptimizedMetric';
  baseline?: Maybe<Scalars['Float']['output']>;
  changePercent?: Maybe<Scalars['Float']['output']>;
  predicted?: Maybe<Scalars['Float']['output']>;
};

export type NexoyaOptimizedTarget = {
  __typename?: 'OptimizedTarget';
  changePercent?: Maybe<Scalars['Float']['output']>;
  lowerIsBetter: Scalars['Boolean']['output'];
  previous?: Maybe<Scalars['Float']['output']>;
  proposed?: Maybe<Scalars['Float']['output']>;
};

export type NexoyaOptimizedTotal = {
  __typename?: 'OptimizedTotal';
  budget: NexoyaOptimizedDailyBudget;
  funnelSteps: Array<Maybe<NexoyaOptimizedFunnelStep>>;
  target?: Maybe<NexoyaOptimizedTarget>;
};

export enum NexoyaOptionalFieldName {
  BudgetItemId = 'budgetItemId',
  CollectionId = 'collectionId',
  ContentRuleIds = 'contentRuleIds',
  FunnelStepId = 'funnelStepId',
  FunnelStepMappings = 'funnelStepMappings',
  ImpactGroupId = 'impactGroupId',
  ImpactGroupRuleIds = 'impactGroupRuleIds',
  LabelId = 'labelId',
  OptimizationId = 'optimizationId',
  PerformanceViewBookmarkId = 'performanceViewBookmarkId',
  PerformanceViewLayoutId = 'performanceViewLayoutId',
  PortfolioContentId = 'portfolioContentId',
  PortfolioId = 'portfolioId',
  ScenarioId = 'scenarioId',
  SimulationId = 'simulationId',
  TargetItemId = 'targetItemId'
}

export type NexoyaOrg = {
  __typename?: 'Org';
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  org_id: Scalars['Int']['output'];
  tenant?: Maybe<NexoyaTenant>;
};

export type NexoyaOtherFunnelStepMetrics = {
  __typename?: 'OtherFunnelStepMetrics';
  activeFunnelStepMetricId?: Maybe<Scalars['Int']['output']>;
  funnelStepTypeName: Scalars['String']['output'];
  otherMetrics?: Maybe<Array<Maybe<NexoyaMetricMeta>>>;
  providerId?: Maybe<Scalars['Int']['output']>;
};

export enum NexoyaPacingType {
  DataDriven = 'DATA_DRIVEN',
  Fixed = 'FIXED',
  RampUp = 'RAMP_UP',
  Smooth = 'SMOOTH'
}

export type NexoyaPageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type NexoyaParentContentFilters = {
  __typename?: 'ParentContentFilters';
  providers: Array<NexoyaParentContentProviderFilter>;
};

export type NexoyaParentContentProviderFilter = {
  __typename?: 'ParentContentProviderFilter';
  name?: Maybe<Scalars['String']['output']>;
  providerId: Scalars['Int']['output'];
};

export type NexoyaPerformanceMetric = {
  __typename?: 'PerformanceMetric';
  adSpend: Scalars['Float']['output'];
  costRatio: Scalars['Float']['output'];
  roas?: Maybe<Scalars['Float']['output']>;
  value: Scalars['Float']['output'];
};

export type NexoyaPerformanceViewBookmark = {
  __typename?: 'PerformanceViewBookmark';
  bookmark: NexoyaPortfolioContentBookmark;
  createdAt: Scalars['DateTime']['output'];
  createdByUserId?: Maybe<Scalars['Int']['output']>;
  defaultUserCount: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  isShared: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  performanceViewBookmarkId: Scalars['Int']['output'];
  portfolioId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedByUserId?: Maybe<Scalars['Int']['output']>;
};

export type NexoyaPerformanceViewBookmarkCreateInput = {
  bookmark: NexoyaPortfolioContentBookmarkInput;
  isShared: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type NexoyaPerformanceViewBookmarkUpdateInput = {
  bookmark?: InputMaybe<NexoyaPortfolioContentBookmarkInput>;
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type NexoyaPerformanceViewLayout = {
  __typename?: 'PerformanceViewLayout';
  columns: Array<NexoyaPerformanceViewLayoutColumn>;
  createdAt: Scalars['DateTime']['output'];
  createdByUserId?: Maybe<Scalars['Int']['output']>;
  defaultUserCount: Scalars['Int']['output'];
  groupingDimension: NexoyaGroupingDimension;
  isDefault: Scalars['Boolean']['output'];
  isShared: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  performanceViewLayoutId: Scalars['Int']['output'];
  portfolioId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedByUserId?: Maybe<Scalars['Int']['output']>;
};

export type NexoyaPerformanceViewLayoutColumn = {
  __typename?: 'PerformanceViewLayoutColumn';
  dimension?: Maybe<NexoyaDimensionColumn>;
  funnelStepId?: Maybe<Scalars['Int']['output']>;
  isVisible: Scalars['Boolean']['output'];
  performanceViewLayoutColumnId: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  type: NexoyaPerformanceViewLayoutColumnType;
};

export type NexoyaPerformanceViewLayoutColumnInput = {
  dimension?: InputMaybe<NexoyaDimensionColumn>;
  funnelStepId?: InputMaybe<Scalars['Int']['input']>;
  isVisible: Scalars['Boolean']['input'];
  position: Scalars['Int']['input'];
  type: NexoyaPerformanceViewLayoutColumnType;
};

export enum NexoyaPerformanceViewLayoutColumnType {
  CostPerFunnelStep = 'COST_PER_FUNNEL_STEP',
  Dimension = 'DIMENSION',
  FunnelStep = 'FUNNEL_STEP',
  RoasFunnelStep = 'ROAS_FUNNEL_STEP'
}

export type NexoyaPerformanceViewLayoutCreateInput = {
  columns: Array<NexoyaPerformanceViewLayoutColumnInput>;
  groupingDimension: NexoyaGroupingDimension;
  isShared: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type NexoyaPerformanceViewLayoutUpdateInput = {
  columns?: InputMaybe<Array<NexoyaPerformanceViewLayoutColumnInput>>;
  groupingDimension?: InputMaybe<NexoyaGroupingDimension>;
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type NexoyaPortfolio = {
  __typename?: 'Portfolio';
  budgetDeltaHandlingPolicy?: Maybe<NexoyaBudgetDeltaHandlingPolicy>;
  budgetProposalTargetBiddingApplyMode?: Maybe<NexoyaTargetBiddingApplyMode>;
  content: NexoyaPortfolioContent;
  createdByUserId?: Maybe<Scalars['Int']['output']>;
  defaultOptimizationTarget: NexoyaFunnelStep;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  funnelSteps?: Maybe<Array<NexoyaFunnelStep>>;
  moneyAllocatedTotal: Scalars['Float']['output'];
  optimizationRiskLevel?: Maybe<Scalars['Int']['output']>;
  optimizationType?: Maybe<NexoyaOptimizationType>;
  portfolioId: Scalars['Int']['output'];
  portfolioMonitorBudgetThreshold?: Maybe<Scalars['Int']['output']>;
  portfolioMonitorData: Array<NexoyaPortfolioMonitorDataEntry>;
  providers?: Maybe<Array<NexoyaProvider>>;
  skipTrainingDays?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  teamId: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  validation?: Maybe<NexoyaValidation>;
};


export type NexoyaPortfolioContentArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
};


export type NexoyaPortfolioPortfolioMonitorDataArgs = {
  groupBy: NexoyaPortfolioMonitorDataGroupingDimension;
};


export type NexoyaPortfolioProvidersArgs = {
  team_id: Scalars['Int']['input'];
};


export type NexoyaPortfolioValidationArgs = {
  avg?: InputMaybe<Scalars['String']['input']>;
  baselineWindow?: InputMaybe<Scalars['Int']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NexoyaPortfolioAttributionPerformance = {
  __typename?: 'PortfolioAttributionPerformance';
  attributedFunnelStep: NexoyaFunnelStepV2;
  attributionRulesMetrics: Array<NexoyaAttributionRulePerformanceTotal>;
  measuredFunnelStep?: Maybe<NexoyaFunnelStepV2>;
};

export type NexoyaPortfolioBudget = {
  __typename?: 'PortfolioBudget';
  appliedOptimizationDailyBudgets: Array<NexoyaAppliedOptimizationDailyBudget>;
  budgetItems: Array<NexoyaBudgetItem>;
  budgetReallocation: NexoyaBudgetReallocation;
  spent: NexoyaPortfolioBudgetSpending;
  total: Scalars['Float']['output'];
};


export type NexoyaPortfolioBudgetAppliedOptimizationDailyBudgetsArgs = {
  end: Scalars['Date']['input'];
  start: Scalars['Date']['input'];
};


export type NexoyaPortfolioBudgetBudgetItemsArgs = {
  end: Scalars['Date']['input'];
  start: Scalars['Date']['input'];
};

export type NexoyaPortfolioBudgetSpending = {
  __typename?: 'PortfolioBudgetSpending';
  dailySpendings: Array<NexoyaDailyMetric>;
  totalSpent: Scalars['Float']['output'];
};


export type NexoyaPortfolioBudgetSpendingDailySpendingsArgs = {
  end: Scalars['Date']['input'];
  start: Scalars['Date']['input'];
};

export type NexoyaPortfolioChildContent = {
  __typename?: 'PortfolioChildContent';
  content: NexoyaContentV2;
  funnelSteps: Array<NexoyaPortfolioChildContentFunnelStep>;
  portfolioContentId: Scalars['Int']['output'];
};

export type NexoyaPortfolioChildContentFunnelStep = {
  __typename?: 'PortfolioChildContentFunnelStep';
  funnelStep: NexoyaFunnelStepV2;
  metric?: Maybe<NexoyaMetricDefinitionV2>;
  metricOptions: Array<NexoyaMetricDefinitionV2>;
};

export type NexoyaPortfolioConnection = {
  __typename?: 'PortfolioConnection';
  edges: Array<NexoyaPortfolioEdges>;
  pageInfo: NexoyaPageInfo;
};

export type NexoyaPortfolioContent = {
  __typename?: 'PortfolioContent';
  contentDetails?: Maybe<Array<NexoyaPortfolioContentDetail>>;
};

export type NexoyaPortfolioContentBookmark = {
  __typename?: 'PortfolioContentBookmark';
  adSpendRange?: Maybe<NexoyaAdSpendRange>;
  attributionRuleIds: Array<Scalars['Int']['output']>;
  contentLabelFilters: Array<NexoyaContentLabelFilter>;
  contentRuleIds: Array<Scalars['Int']['output']>;
  contentTitleFilters: Array<NexoyaContentTitleFilter>;
  contentTypes: Array<Scalars['Int']['output']>;
  impactGroupIds: Array<Scalars['Int']['output']>;
  impactGroupRuleIds: Array<Scalars['Int']['output']>;
  isOptimized?: Maybe<Scalars['Boolean']['output']>;
  labelIds: Array<Scalars['Int']['output']>;
  providerIds: Array<Scalars['Int']['output']>;
};

export type NexoyaPortfolioContentBookmarkInput = {
  adSpendRange?: InputMaybe<NexoyaAdSpendRangeInput>;
  attributionRuleIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  contentLabelFilters?: InputMaybe<Array<NexoyaContentLabelFilterInput>>;
  contentRuleIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  contentTitleFilters?: InputMaybe<Array<NexoyaContentTitleFilterInput>>;
  contentTypes?: InputMaybe<Array<Scalars['Int']['input']>>;
  impactGroupIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  impactGroupRuleIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  isOptimized?: InputMaybe<Scalars['Boolean']['input']>;
  labelIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  providerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NexoyaPortfolioContentBudget = {
  __typename?: 'PortfolioContentBudget';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

export type NexoyaPortfolioContentBudgetInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type NexoyaPortfolioContentConnection = {
  __typename?: 'PortfolioContentConnection';
  edges: Array<NexoyaPortfolioContentEdges>;
  pageInfo: NexoyaPageInfo;
};

export type NexoyaPortfolioContentDetail = {
  __typename?: 'PortfolioContentDetail';
  budget: NexoyaPortfolioContentBudget;
  childContent?: Maybe<Array<NexoyaPortfolioContentDetail>>;
  content?: Maybe<NexoyaCollection>;
  contentId: Scalars['Float']['output'];
  costs?: Maybe<Scalars['Float']['output']>;
  discoveredContent?: Maybe<NexoyaDiscoveredContent>;
  impactGroup?: Maybe<NexoyaImpactGroup>;
  isIncludedInOptimization: Scalars['Boolean']['output'];
  label?: Maybe<NexoyaPortfolioLabel>;
  metadata?: Maybe<NexoyaPortfolioContentMetadata>;
  metrics?: Maybe<Array<NexoyaPortfolioContentMetric>>;
  optimizationTarget: NexoyaFunnelStep;
  portfolioContentId: Scalars['Int']['output'];
  proposalsAllocationDelta?: Maybe<NexoyaProposalsAllocationDelta>;
};

export type NexoyaPortfolioContentEdges = {
  __typename?: 'PortfolioContentEdges';
  cursor: Scalars['String']['output'];
  node: NexoyaPortfolioContent;
};

export type NexoyaPortfolioContentFilterInput = {
  adAccountIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  attributionRuleIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Content Labels v2 filters, AND-ed across entries. An entry with no values and neither include flag filters nothing. */
  contentLabelFilters?: InputMaybe<Array<NexoyaPortfolioContentLabelFilterInput>>;
  contentRuleIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  impactGroupIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  impactGroupRuleIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  includeNoLabel?: InputMaybe<Scalars['Boolean']['input']>;
  isIncludedInOptimization?: InputMaybe<Scalars['Boolean']['input']>;
  isRuleManaged?: InputMaybe<Scalars['Boolean']['input']>;
  labelIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  providerIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  titleContains?: InputMaybe<Scalars['String']['input']>;
};

export type NexoyaPortfolioContentFunnelStep = {
  __typename?: 'PortfolioContentFunnelStep';
  funnelStep: NexoyaFunnelStepV2;
  metric?: Maybe<NexoyaMetricDefinitionV2>;
  sourcePortfolioChildContent?: Maybe<NexoyaPortfolioChildContent>;
};

export type NexoyaPortfolioContentFunnelStepMetricInput = {
  contentId: Scalars['Float']['input'];
  funnelStepId: Scalars['Int']['input'];
  metricTypeId?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Content Labels v2 filter for the Content tab. Stricter than the bookmark's ContentLabelFilterInput, whose
 * includeUnlabeled also keeps contents that need a decision: here they match only through includeNeedsDecision.
 */
export type NexoyaPortfolioContentLabelFilterInput = {
  contentLabelCategoryId: Scalars['String']['input'];
  /** Keeps contents labelled (automatically or manually) with one of these values. */
  contentLabelCategoryValueIds: Array<Scalars['String']['input']>;
  /** Also keeps contents whose label in this category needs a decision. */
  includeNeedsDecision: Scalars['Boolean']['input'];
  /** Also keeps contents without a label in this category. A content that needs a decision is not unlabeled. */
  includeUnlabeled: Scalars['Boolean']['input'];
};

export type NexoyaPortfolioContentMetadata = {
  __typename?: 'PortfolioContentMetadata';
  biddingStrategy?: Maybe<Scalars['String']['output']>;
};

export type NexoyaPortfolioContentMetric = {
  __typename?: 'PortfolioContentMetric';
  coreMetricValues?: Maybe<NexoyaCoreMetricValues>;
  dateFrom: Scalars['DateTime']['output'];
  dateTo: Scalars['DateTime']['output'];
  funnelStep: NexoyaFunnelStep;
  isOptimizationTarget?: Maybe<Scalars['Boolean']['output']>;
  metricTypeId?: Maybe<Scalars['Int']['output']>;
  otherFunnelStepMetrics?: Maybe<NexoyaOtherFunnelStepMetrics>;
  team_id: Scalars['Int']['output'];
};

export type NexoyaPortfolioContentMetricTuple = {
  __typename?: 'PortfolioContentMetricTuple';
  contentId: Scalars['Float']['output'];
  funnelStep: NexoyaFunnelStep;
  metricTypeId: Scalars['Float']['output'];
};

export type NexoyaPortfolioContentRelationInput = {
  belongsToContentId: Scalars['Float']['input'];
  contentId: Scalars['Float']['input'];
};

export type NexoyaPortfolioContentTargetBoundariesInput = {
  minRoasPercent?: InputMaybe<Scalars['Float']['input']>;
};

export type NexoyaPortfolioDashboard = {
  __typename?: 'PortfolioDashboard';
  dateFrom: Scalars['Date']['output'];
  dateTo: Scalars['Date']['output'];
  elements: Array<NexoyaPortfolioDashboardElement>;
  notifications: Array<NexoyaPortfolioDashboardNotification>;
  teamId: Scalars['Int']['output'];
};

export type NexoyaPortfolioDashboardBudgetProposalNotification = NexoyaPortfolioDashboardNotification & {
  __typename?: 'PortfolioDashboardBudgetProposalNotification';
  date: Scalars['Date']['output'];
  payload: NexoyaPortfolioDashboardBudgetProposalNotificationPayload;
  title: Scalars['String']['output'];
  type: NexoyaPortfolioDashboardNotificationType;
};

export type NexoyaPortfolioDashboardBudgetProposalNotificationPayload = {
  __typename?: 'PortfolioDashboardBudgetProposalNotificationPayload';
  budgetProposalId: Scalars['Int']['output'];
  optimizationId: Scalars['Int']['output'];
  portfolioId: Scalars['Int']['output'];
};

export type NexoyaPortfolioDashboardElement = {
  __typename?: 'PortfolioDashboardElement';
  achieved?: Maybe<Scalars['Float']['output']>;
  adSpend?: Maybe<Scalars['Float']['output']>;
  costPer?: Maybe<Scalars['Float']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  goal: Scalars['String']['output'];
  portfolioId: Scalars['Int']['output'];
  roas?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  title: Scalars['String']['output'];
};

export type NexoyaPortfolioDashboardNotification = {
  date: Scalars['Date']['output'];
  title: Scalars['String']['output'];
  type: NexoyaPortfolioDashboardNotificationType;
};

export enum NexoyaPortfolioDashboardNotificationType {
  BudgetApplication = 'BUDGET_APPLICATION',
  OptimizationPotential = 'OPTIMIZATION_POTENTIAL'
}

export type NexoyaPortfolioDashboardOptimizationNotification = NexoyaPortfolioDashboardNotification & {
  __typename?: 'PortfolioDashboardOptimizationNotification';
  date: Scalars['Date']['output'];
  payload: NexoyaPortfolioDashboardOptimizationNotificationPayload;
  title: Scalars['String']['output'];
  type: NexoyaPortfolioDashboardNotificationType;
};

export type NexoyaPortfolioDashboardOptimizationNotificationPayload = {
  __typename?: 'PortfolioDashboardOptimizationNotificationPayload';
  optimizationId: Scalars['Int']['output'];
  portfolioId: Scalars['Int']['output'];
};

export type NexoyaPortfolioDashboardUrl = {
  __typename?: 'PortfolioDashboardUrl';
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type NexoyaPortfolioDashboardUrlInput = {
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type NexoyaPortfolioEdges = {
  __typename?: 'PortfolioEdges';
  cursor: Scalars['String']['output'];
  node: NexoyaPortfolio;
};

export type NexoyaPortfolioEvent = {
  __typename?: 'PortfolioEvent';
  assetUrl?: Maybe<Scalars['String']['output']>;
  assignedContents: Array<Maybe<NexoyaContentV2>>;
  category: NexoyaEventCategory;
  contentRules: Array<Maybe<NexoyaContentRule>>;
  created: Scalars['Date']['output'];
  createdByUserId?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end: Scalars['Date']['output'];
  impact: NexoyaEventImpact;
  includesAllContents: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  portfolioEventId: Scalars['Float']['output'];
  portfolioId: Scalars['Float']['output'];
  start: Scalars['Date']['output'];
  teamId: Scalars['Float']['output'];
};

export type NexoyaPortfolioEventConnection = {
  __typename?: 'PortfolioEventConnection';
  edges: Array<NexoyaPortfolioEventEdge>;
  pageInfo: NexoyaPageInfo;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type NexoyaPortfolioEventEdge = {
  __typename?: 'PortfolioEventEdge';
  cursor: Scalars['String']['output'];
  node: NexoyaPortfolioEvent;
};

export type NexoyaPortfolioEventSnapshot = {
  __typename?: 'PortfolioEventSnapshot';
  assetUrl?: Maybe<Scalars['String']['output']>;
  category: NexoyaEventCategory;
  contentIds: Array<Scalars['Float']['output']>;
  created: Scalars['Date']['output'];
  createdByUserId?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end: Scalars['Date']['output'];
  impact: NexoyaEventImpact;
  name: Scalars['String']['output'];
  portfolioEventId: Scalars['Float']['output'];
  portfolioId: Scalars['Float']['output'];
  start: Scalars['Date']['output'];
  teamId: Scalars['Float']['output'];
};

export enum NexoyaPortfolioFeatureFlag {
  Attribution = 'attribution',
  ContentEditV2 = 'content_edit_v2',
  NavigationV2 = 'navigation_v2',
  OptimizationsOnlyVisibleToSupportUsers = 'optimizationsOnlyVisibleToSupportUsers',
  SelfServicePortfolio = 'self_service_portfolio',
  SimulationPreviewSupport = 'simulation_preview_support',
  TargetModelOptimizationProposal = 'target_model_optimization_proposal',
  WhatIfValidation = 'what_if_validation'
}

export type NexoyaPortfolioFilter = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  completedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  plannedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NexoyaPortfolioFilterBy = {
  field: NexoyaPortfolioIndexField;
  stringValue?: InputMaybe<Scalars['String']['input']>;
};

export enum NexoyaPortfolioIndexField {
  Title = 'title'
}

export type NexoyaPortfolioLabel = {
  __typename?: 'PortfolioLabel';
  labelId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type NexoyaPortfolioMonitorDataEntry = {
  __typename?: 'PortfolioMonitorDataEntry';
  MAE: Scalars['Float']['output'];
  MAPE: Scalars['Float']['output'];
  SMAPE: Scalars['Float']['output'];
  SmAPE: Scalars['Float']['output'];
  funnelStepId: Scalars['Int']['output'];
  mAE: Scalars['Float']['output'];
  mAPE: Scalars['Float']['output'];
  optimizationId: Scalars['Int']['output'];
  timestamp: Scalars['DateTime']['output'];
  y_pred: Scalars['Float']['output'];
  y_pred_raw?: Maybe<Scalars['Float']['output']>;
  y_true: Scalars['Float']['output'];
};

export enum NexoyaPortfolioMonitorDataGroupingDimension {
  FunnelStep = 'FUNNEL_STEP',
  Portfolio = 'PORTFOLIO'
}

export type NexoyaPortfolioParentContent = {
  __typename?: 'PortfolioParentContent';
  budgetMax?: Maybe<Scalars['Float']['output']>;
  budgetMin?: Maybe<Scalars['Float']['output']>;
  childContents: Array<NexoyaPortfolioChildContent>;
  content: NexoyaContentV2;
  discoveredContent: NexoyaDiscoveredContent;
  funnelSteps: Array<NexoyaPortfolioContentFunnelStep>;
  impactGroup?: Maybe<NexoyaImpactGroup>;
  isIncludedInOptimization: Scalars['Boolean']['output'];
  label?: Maybe<NexoyaPortfolioLabel>;
  minTargetRoasPercent?: Maybe<Scalars['Float']['output']>;
  portfolioContentId: Scalars['Int']['output'];
};

export type NexoyaPortfolioParentContentConnection = {
  __typename?: 'PortfolioParentContentConnection';
  edges: Array<NexoyaPortfolioParentContentEdge>;
  pageInfo: NexoyaPageInfo;
  totalPages: Scalars['Int']['output'];
};

export type NexoyaPortfolioParentContentEdge = {
  __typename?: 'PortfolioParentContentEdge';
  cursor: Scalars['String']['output'];
  node: NexoyaPortfolioParentContent;
};

export enum NexoyaPortfolioParentContentsSortField {
  AttributionRuleName = 'attributionRuleName',
  ContentRuleName = 'contentRuleName',
  ContentTitle = 'contentTitle',
  ContentType = 'contentType',
  ImpactGroupName = 'impactGroupName',
  ImpactGroupRuleName = 'impactGroupRuleName',
  IsIncludedInOptimization = 'isIncludedInOptimization',
  IsRuleManaged = 'isRuleManaged',
  LabelName = 'labelName',
  ProviderId = 'providerId'
}

export type NexoyaPortfolioPerformance = {
  __typename?: 'PortfolioPerformance';
  funnelStep: NexoyaFunnelStepPerformance;
  funnelSteps: Array<NexoyaFunnelStepPerformance>;
  optimizations: Array<NexoyaOptimizationV2>;
};


export type NexoyaPortfolioPerformanceFunnelStepArgs = {
  funnelStepId: Scalars['Float']['input'];
};

export type NexoyaPortfolioSortBy = {
  field: NexoyaPortfolioIndexField;
  order: NexoyaSortOrder;
};

export type NexoyaPortfolioSummary = {
  __typename?: 'PortfolioSummary';
  portfolioId: Scalars['Int']['output'];
  teamId: Scalars['Int']['output'];
};

export enum NexoyaPortfolioSyncStatus {
  Error = 'ERROR',
  Synced = 'SYNCED',
  Syncing = 'SYNCING'
}

export type NexoyaPortfolioTargetItem = {
  __typename?: 'PortfolioTargetItem';
  achieved?: Maybe<Scalars['Float']['output']>;
  end: Scalars['Date']['output'];
  maxBudget: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  portfolioId: Scalars['Int']['output'];
  start: Scalars['Date']['output'];
  status: NexoyaTargetItemStatus;
  targetItemId: Scalars['Int']['output'];
  value: Scalars['Float']['output'];
};

export enum NexoyaPortfolioType {
  Budget = 'BUDGET',
  CostPer = 'COST_PER',
  Roas = 'ROAS'
}

export type NexoyaPortfolioV2 = {
  __typename?: 'PortfolioV2';
  activeOptimization?: Maybe<NexoyaOptimizationV2>;
  activeTargetItem?: Maybe<NexoyaPortfolioTargetItem>;
  attributionPerformance?: Maybe<NexoyaPortfolioAttributionPerformance>;
  attributionRule: NexoyaAttributionRule;
  attributionRules: Array<NexoyaAttributionRule>;
  budget: NexoyaPortfolioBudget;
  budgetDeltaHandlingPolicy?: Maybe<NexoyaBudgetDeltaHandlingPolicy>;
  budgetProposalTargetBiddingApplyMode?: Maybe<NexoyaTargetBiddingApplyMode>;
  contentRule: NexoyaContentRule;
  contentRules: Array<NexoyaContentRule>;
  createdByUserId?: Maybe<Scalars['Int']['output']>;
  defaultOptimizationTarget?: Maybe<NexoyaFunnelStepV2>;
  description?: Maybe<Scalars['String']['output']>;
  discoveredContents: Array<NexoyaDiscoveredContent>;
  end?: Maybe<Scalars['Date']['output']>;
  featureFlags?: Maybe<Array<Maybe<NexoyaFeatureFlag>>>;
  funnelSteps: Array<NexoyaFunnelStepV2>;
  impactGroupRule: NexoyaImpactGroupRule;
  impactGroupRules: Array<NexoyaImpactGroupRule>;
  impactGroups: Array<NexoyaImpactGroup>;
  isAttributed: Scalars['Boolean']['output'];
  labels: Array<NexoyaPortfolioLabel>;
  lastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  latestAchievedTargetItem?: Maybe<NexoyaPortfolioTargetItem>;
  optimization: NexoyaOptimizationV2;
  optimizationRiskLevel?: Maybe<Scalars['Int']['output']>;
  optimizationType?: Maybe<NexoyaOptimizationType>;
  optimizations: NexoyaOptimizationConnection;
  performance: NexoyaPortfolioPerformance;
  performanceViewBookmarks: Array<NexoyaPerformanceViewBookmark>;
  performanceViewLayouts: Array<NexoyaPerformanceViewLayout>;
  portfolioDashboardUrls?: Maybe<Array<Maybe<NexoyaPortfolioDashboardUrl>>>;
  portfolioEvent: NexoyaPortfolioEvent;
  portfolioEvents: NexoyaPortfolioEventConnection;
  portfolioId: Scalars['Int']['output'];
  portfolioMonitorData: Array<NexoyaPortfolioMonitorDataEntry>;
  portfolioParentContents: NexoyaPortfolioParentContentConnection;
  prediction: NexoyaPrediction;
  providerMetricOptions: Array<NexoyaProviderMetricOptions>;
  simulation: NexoyaSimulation;
  simulations: Array<NexoyaSimulation>;
  skipTrainingDays?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Date']['output']>;
  syncStatus: NexoyaPortfolioSyncStatus;
  targetItems: Array<NexoyaPortfolioTargetItem>;
  teamId: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  type: NexoyaPortfolioType;
};


export type NexoyaPortfolioV2AttributionPerformanceArgs = {
  bookmark?: InputMaybe<NexoyaPortfolioContentBookmarkInput>;
  period: NexoyaDateRangeInput;
};


export type NexoyaPortfolioV2AttributionRuleArgs = {
  attributionRuleId: Scalars['Float']['input'];
};


export type NexoyaPortfolioV2ContentRuleArgs = {
  contentRuleId: Scalars['Float']['input'];
};


export type NexoyaPortfolioV2DiscoveredContentsArgs = {
  status: NexoyaDiscoveredContentStatus;
};


export type NexoyaPortfolioV2ImpactGroupRuleArgs = {
  impactGroupRuleId: Scalars['Float']['input'];
};


export type NexoyaPortfolioV2OptimizationArgs = {
  optimizationId: Scalars['Int']['input'];
};


export type NexoyaPortfolioV2OptimizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<NexoyaOptimizationStatus>;
};


export type NexoyaPortfolioV2PerformanceArgs = {
  bookmark?: InputMaybe<NexoyaPortfolioContentBookmarkInput>;
  comparisonPeriod?: InputMaybe<NexoyaDateRangeInput>;
  period: NexoyaDateRangeInput;
};


export type NexoyaPortfolioV2PortfolioEventArgs = {
  portfolioEventId: Scalars['Float']['input'];
};


export type NexoyaPortfolioV2PortfolioEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};


export type NexoyaPortfolioV2PortfolioMonitorDataArgs = {
  groupBy: NexoyaPortfolioMonitorDataGroupingDimension;
};


export type NexoyaPortfolioV2PortfolioParentContentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  portfolioContentFilter?: InputMaybe<NexoyaPortfolioContentFilterInput>;
  sortField?: InputMaybe<NexoyaPortfolioParentContentsSortField>;
  sortOrder?: InputMaybe<NexoyaSortOrder>;
};


export type NexoyaPortfolioV2PredictionArgs = {
  end: Scalars['Date']['input'];
  start: Scalars['Date']['input'];
};


export type NexoyaPortfolioV2SimulationArgs = {
  simulationId: Scalars['Int']['input'];
};

export type NexoyaPortfolioV2Connection = {
  __typename?: 'PortfolioV2Connection';
  edges: Array<NexoyaPortfolioV2Edge>;
  pageInfo: NexoyaPageInfo;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type NexoyaPortfolioV2Edge = {
  __typename?: 'PortfolioV2Edge';
  cursor: Scalars['String']['output'];
  node: NexoyaPortfolioV2;
};

export type NexoyaPrediction = {
  __typename?: 'Prediction';
  funnelSteps: Array<NexoyaFunnelStepPredictionScore>;
  total: NexoyaPredictionTotal;
};

export type NexoyaPredictionTotal = {
  __typename?: 'PredictionTotal';
  accuracyBuckets: Array<NexoyaAccuracyBucket>;
  dailyPredictionTotal: Array<NexoyaDailyPredictionTotal>;
  score: Scalars['Float']['output'];
};

export type NexoyaPreviewEventDuplicatesQueryResponse = {
  __typename?: 'PreviewEventDuplicatesQueryResponse';
  duplicatePortfolioEvents: Array<Maybe<NexoyaPortfolioEvent>>;
};

export type NexoyaProposalsAllocationDelta = {
  __typename?: 'ProposalsAllocationDelta';
  actualAllocation?: Maybe<Scalars['Float']['output']>;
  allocationPctDelta?: Maybe<Scalars['Float']['output']>;
  proposedAllocation?: Maybe<Scalars['Float']['output']>;
};

export type NexoyaProposedBiddingStrategy = {
  __typename?: 'ProposedBiddingStrategy';
  applicationDelta?: Maybe<Scalars['Float']['output']>;
  currentTcpa?: Maybe<Scalars['Float']['output']>;
  currentTroas?: Maybe<Scalars['Float']['output']>;
  dailyBudgetChange?: Maybe<Scalars['Float']['output']>;
  realizedCpa?: Maybe<Scalars['Float']['output']>;
  realizedRoas?: Maybe<Scalars['Float']['output']>;
  tcpaDelta?: Maybe<Scalars['Float']['output']>;
  troasDelta?: Maybe<Scalars['Float']['output']>;
  type: NexoyaBiddingStrategyType;
  value?: Maybe<Scalars['Float']['output']>;
};

export type NexoyaProvider = {
  __typename?: 'Provider';
  category?: Maybe<Scalars['String']['output']>;
  connected?: Maybe<Scalars['Boolean']['output']>;
  delayed_days?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  filterable?: Maybe<Scalars['Boolean']['output']>;
  hasCollections?: Maybe<Scalars['Boolean']['output']>;
  isPortfolioPrimaryChannel?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  manualConnect?: Maybe<NexoyaProviderManualConnect>;
  name?: Maybe<Scalars['String']['output']>;
  no_initial?: Maybe<Scalars['Boolean']['output']>;
  provider_id: Scalars['Int']['output'];
  showInToplist?: Maybe<Scalars['Boolean']['output']>;
};

export type NexoyaProviderFilter = {
  __typename?: 'ProviderFilter';
  filterList?: Maybe<Array<NexoyaFilterListType>>;
  filterName: Scalars['String']['output'];
};

export type NexoyaProviderKey = {
  __typename?: 'ProviderKey';
  active?: Maybe<Scalars['Boolean']['output']>;
  api_key?: Maybe<Scalars['String']['output']>;
  api_secret?: Maybe<Scalars['String']['output']>;
  appKey?: Maybe<Scalars['String']['output']>;
  appSecret?: Maybe<Scalars['String']['output']>;
  enc_options?: Maybe<Scalars['String']['output']>;
  integOpts?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Scalars['String']['output']>;
  page_token?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  provider?: Maybe<NexoyaProvider>;
  provider_key_id?: Maybe<Scalars['Int']['output']>;
  refresh_token?: Maybe<Scalars['String']['output']>;
  team?: Maybe<NexoyaTeam>;
  team_id?: Maybe<Scalars['Int']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type NexoyaProviderKeyInput = {
  api_key?: InputMaybe<Scalars['String']['input']>;
  api_secret?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['String']['input']>;
  provider_id: Scalars['Int']['input'];
  provider_key_id?: InputMaybe<Scalars['Int']['input']>;
  team_id: Scalars['Int']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** Credentials a manual integration takes from the UI, declared in provider.json */
export type NexoyaProviderManualConnect = {
  __typename?: 'ProviderManualConnect';
  fields: Array<NexoyaProviderManualConnectField>;
};

export type NexoyaProviderManualConnectField = {
  __typename?: 'ProviderManualConnectField';
  label: Scalars['String']['output'];
  /** Key of the value in the submitted data */
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  /** Mask the input, e.g. for secrets and tokens */
  secret: Scalars['Boolean']['output'];
  /** Where the value is stored: api_key, api_secret, access_token, refresh_token (token table) or options.<key> */
  target: Scalars['String']['output'];
};

export type NexoyaProviderMetricOptions = {
  __typename?: 'ProviderMetricOptions';
  metricOptions: Array<NexoyaMetricDefinitionV2>;
  providerId: Scalars['Float']['output'];
};

export type NexoyaProviderMetricTotal = {
  __typename?: 'ProviderMetricTotal';
  comparisonChangePercent?: Maybe<NexoyaPerformanceMetric>;
  comparisonTotal?: Maybe<NexoyaPerformanceMetric>;
  contents: Array<NexoyaContentMetricTotal>;
  providerId: Scalars['Int']['output'];
  total: NexoyaPerformanceMetric;
};

export type NexoyaQuery = {
  __typename?: 'Query';
  KPIValues?: Maybe<NexoyaKpi>;
  attributionRuleUpdateFiltersPreview: NexoyaAttributionRuleUpdateFiltersPreviewQueryResponse;
  availableFieldOperations: Array<NexoyaFieldOperation>;
  budgetProposals: NexoyaBudgetProposalConnection;
  calculatedMetricFormulaPreview: NexoyaCalculatedMetricFormulaPreviewResponse;
  calculatedMetricOperandTimeseries: Array<NexoyaCalculatedMetricOperandTimeSeries>;
  childCollectionsPg: NexoyaCollectionConnection;
  collection?: Maybe<NexoyaCollection>;
  collectionTypes?: Maybe<Array<Maybe<NexoyaCollectionType>>>;
  collectionWithProvider?: Maybe<Array<Maybe<NexoyaCollection>>>;
  collections?: Maybe<Array<Maybe<NexoyaCollection>>>;
  collectionsPg: NexoyaCollectionConnection;
  content?: Maybe<NexoyaContent>;
  contentRuleUpdateFiltersPreview: NexoyaContentRuleUpdateFiltersPreviewMutationResponse;
  contentTypes?: Maybe<Array<Maybe<NexoyaContentType>>>;
  contentWithDataPg: NexoyaCollectionConnection;
  contents?: Maybe<Array<Maybe<NexoyaContent>>>;
  contentsPg: NexoyaContentConnection;
  countDiscoveredContents: NexoyaDiscoveredContentsCount;
  createBudgetItemPrecheck?: Maybe<NexoyaCreateBudgetItemPrecheckResult>;
  currencyExchangeTimeframes: Array<NexoyaCurrencyExchangeTimeframe>;
  customKpi?: Maybe<Array<Maybe<NexoyaCustomKpi>>>;
  /** `portfolioId` is used with `excludePortfolioContents` and `inPortfolioOnly` to filter contents that are in or out of a portfolio. `portfolioId` alone is a no-op. */
  filterContents: Array<NexoyaContentV2>;
  findAttributionModelById: NexoyaAttributionModel;
  flagStatus?: Maybe<Scalars['Boolean']['output']>;
  getDatatype?: Maybe<NexoyaDataType>;
  googleTrendsKeywordOptions: NexoyaGoogleTrendsKeywordOptions;
  impactGroupRuleUpdatePreview?: Maybe<NexoyaImpactGroupRuleUpdatePreviewMutationResponse>;
  integration?: Maybe<NexoyaIntegration>;
  integrations?: Maybe<Array<Maybe<NexoyaIntegration>>>;
  listAccountContents: Array<NexoyaContentV2>;
  listAttributionModels: NexoyaAttributionModelConnection;
  listCalculatedMetricParameters: Array<NexoyaCalculatedMetricParameter>;
  listContentBiddingStrategyValueHistory: Array<NexoyaContentBiddingStrategyValueHistory>;
  listContentLabelCategories: Array<NexoyaContentLabelCategory>;
  listContentStatusValueHistory: Array<NexoyaContentStatusValueHistory>;
  listContentsByIds: Array<NexoyaContentV2>;
  listConversions: Array<NexoyaConversion>;
  listCurrencyData?: Maybe<NexoyaCurrencyData>;
  listFunnelStepAnalyticsExpansionVariables: Array<Scalars['String']['output']>;
  listFunnelStepAnalyticsSearchDimensions: Array<NexoyaFunnelStepAnalyticsSearchDimension>;
  listFunnelStepCustomImportExpansionVariables: Array<Scalars['String']['output']>;
  listFunnelStepCustomMetricExpansionVariables: Array<Scalars['String']['output']>;
  listFunnelStepMappingPresets: Array<NexoyaFunnelStepMappingPreset>;
  listMetricDefinitions: Array<NexoyaMetricDefinitionV2>;
  listPortfolioDefaultFunnelStepMappings: Array<NexoyaFunnelStepDefaultMapping>;
  listTrendSignals: Array<NexoyaTrendSignal>;
  measurementAggregates?: Maybe<NexoyaMeasurementAggregate>;
  measurementGroups?: Maybe<Array<Maybe<NexoyaMeasurementGroup>>>;
  measurementRangeSearch?: Maybe<Array<Maybe<NexoyaMeasurement>>>;
  measurementRangeSearchPg: NexoyaMeasurementConnection;
  measurement_range?: Maybe<Array<Maybe<NexoyaMeasurement>>>;
  measurementdata_range_by_measurement_collection?: Maybe<Array<Maybe<NexoyaMeasurement>>>;
  measurements?: Maybe<Array<Maybe<NexoyaMeasurement>>>;
  measurementsPg: NexoyaMeasurementConnection;
  metadataTypes?: Maybe<Scalars['JSON']['output']>;
  metrics?: Maybe<Array<Maybe<NexoyaMetricDataCore>>>;
  newOptimizationSummary: NexoyaNewOptimizationSummary;
  newSimulationSummary: NexoyaNewSimulationSummary;
  optimization?: Maybe<NexoyaOptimizationV2>;
  optimizationBudgetProposal?: Maybe<NexoyaBudgetProposal>;
  optimizationConfig?: Maybe<Scalars['JSON']['output']>;
  optimizationPreflight: NexoyaOptimizationPreflight;
  portfolio?: Maybe<NexoyaPortfolio>;
  portfolioBudgetProposals?: Maybe<Array<Maybe<NexoyaBudgetProposal>>>;
  portfolioContent: NexoyaPortfolioContentConnection;
  portfolioContentMetricTuples?: Maybe<Array<NexoyaPortfolioContentMetricTuple>>;
  portfolioDashboard?: Maybe<NexoyaPortfolioDashboard>;
  portfolioParentContentFilters?: Maybe<NexoyaParentContentFilters>;
  portfolioV2?: Maybe<NexoyaPortfolioV2>;
  portfolios: NexoyaPortfolioConnection;
  portfoliosV2Paginated: NexoyaPortfolioV2Connection;
  predefinedContent?: Maybe<Array<Maybe<NexoyaPortfolioContent>>>;
  previewEventDuplicates?: Maybe<NexoyaPreviewEventDuplicatesQueryResponse>;
  provider?: Maybe<NexoyaProvider>;
  providerKeys?: Maybe<Array<Maybe<NexoyaProviderKey>>>;
  providers?: Maybe<Array<Maybe<NexoyaProvider>>>;
  report?: Maybe<NexoyaReport>;
  reportSummary?: Maybe<NexoyaReportWithSummary>;
  reports?: Maybe<Array<Maybe<NexoyaReport>>>;
  reportsSummary?: Maybe<Array<Maybe<NexoyaReportWithSummary>>>;
  roles?: Maybe<Array<NexoyaRoleDef>>;
  /** Places matching the query; the names include the region and country */
  searchWeatherLocations: Array<NexoyaTrendSignalOption>;
  team?: Maybe<NexoyaTeam>;
  teamFeatureFlags?: Maybe<Array<Maybe<NexoyaTeamFeatureFlag>>>;
  teams?: Maybe<Array<Maybe<NexoyaTeam>>>;
  translation?: Maybe<NexoyaTranslation>;
  translations?: Maybe<Array<Maybe<NexoyaTranslation>>>;
  trendSignal: NexoyaTrendSignal;
  user?: Maybe<NexoyaUser>;
  userByEmail?: Maybe<NexoyaUser>;
  users?: Maybe<Array<Maybe<NexoyaUser>>>;
  validationDetailedReport?: Maybe<Scalars['String']['output']>;
  weatherTrendSignalOptions: NexoyaWeatherTrendSignalOptions;
};


export type NexoyaQueryKpiValuesArgs = {
  id: Scalars['Int']['input'];
  team_id: Scalars['Int']['input'];
};


export type NexoyaQueryAttributionRuleUpdateFiltersPreviewArgs = {
  attributionRuleId: Scalars['Float']['input'];
  filters: NexoyaAttributionRuleFiltersInput;
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaQueryAvailableFieldOperationsArgs = {
  providerId: Scalars['Float']['input'];
};


export type NexoyaQueryBudgetProposalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<NexoyaBudgetProposalStatus>;
};


export type NexoyaQueryCalculatedMetricFormulaPreviewArgs = {
  contentId: Scalars['Float']['input'];
  end: Scalars['Date']['input'];
  formula: Scalars['JSON']['input'];
  start: Scalars['Date']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaQueryCalculatedMetricOperandTimeseriesArgs = {
  contentId: Scalars['Float']['input'];
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaQueryChildCollectionsPgArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  parent_collection_id: Scalars['Float']['input'];
  team_id: Scalars['Int']['input'];
  where?: InputMaybe<NexoyaSearchFilter>;
};


export type NexoyaQueryCollectionArgs = {
  collection_id: Scalars['Float']['input'];
  team_id: Scalars['Int']['input'];
};


export type NexoyaQueryCollectionWithProviderArgs = {
  provider_id: Scalars['Int']['input'];
  team_id: Scalars['Int']['input'];
};


export type NexoyaQueryCollectionsArgs = {
  first?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  team_id: Scalars['Int']['input'];
  where?: InputMaybe<NexoyaFilter>;
};


export type NexoyaQueryCollectionsPgArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  team_id: Scalars['Int']['input'];
  where?: InputMaybe<NexoyaFilter>;
};


export type NexoyaQueryContentArgs = {
  content_id: Scalars['Float']['input'];
  team_id: Scalars['Int']['input'];
};


export type NexoyaQueryContentRuleUpdateFiltersPreviewArgs = {
  contentRuleId: Scalars['Float']['input'];
  filters: NexoyaContentRuleFiltersInput;
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaQueryContentWithDataPgArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  team_id: Scalars['Int']['input'];
  where?: InputMaybe<NexoyaFilter>;
  withDataFor?: InputMaybe<NexoyaFunnelStepType>;
};


export type NexoyaQueryContentsArgs = {
  first?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  team_id: Scalars['Int']['input'];
  where?: InputMaybe<NexoyaFilter>;
};


export type NexoyaQueryContentsPgArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  team_id: Scalars['Int']['input'];
  where?: InputMaybe<NexoyaFilter>;
};


export type NexoyaQueryCountDiscoveredContentsArgs = {
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaQueryCreateBudgetItemPrecheckArgs = {
  endDate: Scalars['Date']['input'];
  portfolioId: Scalars['Int']['input'];
  startDate: Scalars['Date']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaQueryCurrencyExchangeTimeframesArgs = {
  teamId: Scalars['Int']['input'];
};


export type NexoyaQueryCustomKpiArgs = {
  custom_kpi_id?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  team_id: Scalars['Int']['input'];
};


export type NexoyaQueryFilterContentsArgs = {
  excludePortfolioContents: Scalars['Boolean']['input'];
  filters: Array<NexoyaContentFilterInput>;
  inPortfolioOnly?: InputMaybe<Scalars['Boolean']['input']>;
  portfolioId?: InputMaybe<Scalars['Float']['input']>;
  teamId: Scalars['Float']['input'];
};


export type NexoyaQueryFindAttributionModelByIdArgs = {
  attributionModelId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaQueryFlagStatusArgs = {
  name: Scalars['String']['input'];
  team_id: Scalars['Int']['input'];
};


export type NexoyaQueryGetDatatypeArgs = {
  id: Scalars['Int']['input'];
};


export type NexoyaQueryGoogleTrendsKeywordOptionsArgs = {
  teamId: Scalars['Int']['input'];
};


export type NexoyaQueryImpactGroupRuleUpdatePreviewArgs = {
  impactGroupRuleEdit: NexoyaImpactGroupRuleEditInput;
  impactGroupRuleId: Scalars['Float']['input'];
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaQueryIntegrationArgs = {
  integration_id: Scalars['Int']['input'];
  team_id: Scalars['Int']['input'];
};


export type NexoyaQueryIntegrationsArgs = {
  filter?: InputMaybe<NexoyaIntegrationFilter>;
  team_id: Scalars['Int']['input'];
};


export type NexoyaQueryListAccountContentsArgs = {
  providerId?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Float']['input'];
};


export type NexoyaQueryListAttributionModelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters: NexoyaListAttributionModelsFilters;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
};


export type NexoyaQueryListCalculatedMetricParametersArgs = {
  teamId: Scalars['Int']['input'];
};


export type NexoyaQueryListContentBiddingStrategyValueHistoryArgs = {
  biddingStrategyType: Scalars['String']['input'];
  contentIds: Array<Scalars['Float']['input']>;
  period: NexoyaDateRangeInput;
  teamId: Scalars['Float']['input'];
};


export type NexoyaQueryListContentLabelCategoriesArgs = {
  teamId: Scalars['Int']['input'];
};


export type NexoyaQueryListContentStatusValueHistoryArgs = {
  contentIds: Array<Scalars['Float']['input']>;
  period: NexoyaDateRangeInput;
  teamId: Scalars['Float']['input'];
};


export type NexoyaQueryListContentsByIdsArgs = {
  contentIds: Array<Scalars['Float']['input']>;
  teamId: Scalars['Float']['input'];
};


export type NexoyaQueryListConversionsArgs = {
  adAccountContentIds: Array<Scalars['Float']['input']>;
  teamId: Scalars['Float']['input'];
};


export type NexoyaQueryListFunnelStepAnalyticsExpansionVariablesArgs = {
  contentType?: InputMaybe<Scalars['Int']['input']>;
};


export type NexoyaQueryListFunnelStepAnalyticsSearchDimensionsArgs = {
  providerId: Scalars['Float']['input'];
};


export type NexoyaQueryListFunnelStepCustomImportExpansionVariablesArgs = {
  contentType?: InputMaybe<Scalars['Int']['input']>;
};


export type NexoyaQueryListFunnelStepCustomMetricExpansionVariablesArgs = {
  contentType?: InputMaybe<Scalars['Int']['input']>;
};


export type NexoyaQueryListFunnelStepMappingPresetsArgs = {
  teamId: Scalars['Float']['input'];
};


export type NexoyaQueryListPortfolioDefaultFunnelStepMappingsArgs = {
  portfolioId: Scalars['Float']['input'];
  providerId: Scalars['Int']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaQueryListTrendSignalsArgs = {
  teamId: Scalars['Int']['input'];
};


export type NexoyaQueryMeasurementAggregatesArgs = {
  dateFrom: Scalars['DateTime']['input'];
  dateTo: Scalars['DateTime']['input'];
  measurement_collection?: InputMaybe<Array<InputMaybe<NexoyaMeasurementCollectionPairInput>>>;
  team_id: Scalars['Int']['input'];
};


export type NexoyaQueryMeasurementGroupsArgs = {
  where?: InputMaybe<NexoyaFilter>;
};


export type NexoyaQueryMeasurementRangeSearchArgs = {
  collection_id?: InputMaybe<Scalars['Float']['input']>;
  collections?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  measurement_id?: InputMaybe<Scalars['Int']['input']>;
  measurements?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  parentOnly?: InputMaybe<Scalars['Boolean']['input']>;
  providers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  team_id: Scalars['Int']['input'];
  where?: InputMaybe<NexoyaFilter>;
};


export type NexoyaQueryMeasurementRangeSearchPgArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  collection_id?: InputMaybe<Scalars['Float']['input']>;
  collections?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  measurement_id?: InputMaybe<Scalars['Int']['input']>;
  measurements?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  parentOnly?: InputMaybe<Scalars['Boolean']['input']>;
  providers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  team_id: Scalars['Int']['input'];
  where?: InputMaybe<NexoyaFilter>;
};


export type NexoyaQueryMeasurement_RangeArgs = {
  collection_id?: InputMaybe<Scalars['Float']['input']>;
  collections?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  measurement_id?: InputMaybe<Scalars['Int']['input']>;
  measurements?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  parentOnly?: InputMaybe<Scalars['Boolean']['input']>;
  providers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  team_id: Scalars['Int']['input'];
  where?: InputMaybe<NexoyaFilter>;
};


export type NexoyaQueryMeasurementdata_Range_By_Measurement_CollectionArgs = {
  dateFrom: Scalars['DateTime']['input'];
  dateTo: Scalars['DateTime']['input'];
  measurement_collection?: InputMaybe<Array<InputMaybe<NexoyaMeasurementCollectionPairInput>>>;
  team_id: Scalars['Int']['input'];
};


export type NexoyaQueryMeasurementsArgs = {
  provider_id?: InputMaybe<Scalars['Int']['input']>;
};


export type NexoyaQueryMeasurementsPgArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<NexoyaFilter>;
};


export type NexoyaQueryMetricsArgs = {
  provider_id?: InputMaybe<Scalars['Int']['input']>;
};


export type NexoyaQueryNewOptimizationSummaryArgs = {
  end: Scalars['Date']['input'];
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaQueryNewSimulationSummaryArgs = {
  budgetMax: Scalars['Int']['input'];
  budgetMin: Scalars['Int']['input'];
  end: Scalars['Date']['input'];
  portfolioId: Scalars['Int']['input'];
  simulationId?: InputMaybe<Scalars['Float']['input']>;
  start: Scalars['Date']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaQueryOptimizationArgs = {
  optimizationId: Scalars['Int']['input'];
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaQueryOptimizationBudgetProposalArgs = {
  optimizationId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaQueryOptimizationConfigArgs = {
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaQueryOptimizationPreflightArgs = {
  optimizationPreflightId: Scalars['String']['input'];
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaQueryPortfolioArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaQueryPortfolioBudgetProposalsArgs = {
  portfolioId: Scalars['Int']['input'];
  status?: InputMaybe<NexoyaBudgetProposalStatus>;
  teamId: Scalars['Int']['input'];
};


export type NexoyaQueryPortfolioContentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<NexoyaSortBy>;
  teamId: Scalars['Int']['input'];
  where?: InputMaybe<NexoyaSearchFilter>;
};


export type NexoyaQueryPortfolioContentMetricTuplesArgs = {
  funnelStepId?: InputMaybe<Scalars['Int']['input']>;
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaQueryPortfolioDashboardArgs = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};


export type NexoyaQueryPortfolioParentContentFiltersArgs = {
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaQueryPortfolioV2Args = {
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaQueryPortfoliosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<NexoyaSortBy>;
  teamId?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NexoyaSearchFilter>;
};


export type NexoyaQueryPortfoliosV2PaginatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<NexoyaPortfolioSortBy>;
  teamId?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NexoyaPortfolioFilterBy>;
};


export type NexoyaQueryPredefinedContentArgs = {
  mainGoals?: InputMaybe<Array<NexoyaFunnelStepType>>;
  teamId: Scalars['Int']['input'];
};


export type NexoyaQueryPreviewEventDuplicatesArgs = {
  portfolioEventNames: Array<Scalars['String']['input']>;
  portfolioId: Scalars['Float']['input'];
  teamId: Scalars['Float']['input'];
};


export type NexoyaQueryProviderArgs = {
  provider_id: Scalars['Int']['input'];
};


export type NexoyaQueryProviderKeysArgs = {
  provider_id?: InputMaybe<Scalars['Int']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
};


export type NexoyaQueryProvidersArgs = {
  team_id?: InputMaybe<Scalars['Int']['input']>;
};


export type NexoyaQueryReportArgs = {
  report_id: Scalars['Int']['input'];
  team_id: Scalars['Int']['input'];
};


export type NexoyaQueryReportSummaryArgs = {
  report_id: Scalars['Int']['input'];
  team_id: Scalars['Int']['input'];
};


export type NexoyaQueryReportsArgs = {
  report_type?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<NexoyaSortBy>;
  team_id: Scalars['Int']['input'];
  where?: InputMaybe<NexoyaSearchFilter>;
};


export type NexoyaQueryReportsSummaryArgs = {
  report_type?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<NexoyaSortBy>;
  team_id: Scalars['Int']['input'];
};


export type NexoyaQuerySearchWeatherLocationsArgs = {
  query: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaQueryTeamArgs = {
  team_id: Scalars['Int']['input'];
};


export type NexoyaQueryTeamFeatureFlagsArgs = {
  team_id: Scalars['Int']['input'];
};


export type NexoyaQueryTeamsArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NexoyaQueryTranslationArgs = {
  key: Scalars['String']['input'];
  lang: Scalars['String']['input'];
};


export type NexoyaQueryTranslationsArgs = {
  lang: Scalars['String']['input'];
};


export type NexoyaQueryTrendSignalArgs = {
  teamId: Scalars['Int']['input'];
  trendSignalId: Scalars['String']['input'];
};


export type NexoyaQueryUserArgs = {
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type NexoyaQueryUserByEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type NexoyaQueryValidationDetailedReportArgs = {
  dateFrom: Scalars['DateTime']['input'];
  dateTo: Scalars['DateTime']['input'];
  portfolioId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type NexoyaQueryWeatherTrendSignalOptionsArgs = {
  teamId: Scalars['Int']['input'];
};

export type NexoyaRealizedMetricData = NexoyaMetricData & {
  __typename?: 'RealizedMetricData';
  timestamp: Scalars['DateTime']['output'];
  valueCumulative: Scalars['Float']['output'];
  valueRelative: Scalars['Float']['output'];
};

export type NexoyaRealizedMetricDataPast = {
  __typename?: 'RealizedMetricDataPast';
  timestamp: Scalars['DateTime']['output'];
  valueCumulative: Scalars['Float']['output'];
  valueRelative: Scalars['Float']['output'];
};

export type NexoyaRemoveContentLabelManualAssignmentsInput = {
  contentIds: Array<Scalars['Float']['input']>;
  contentLabelCategoryId: Scalars['String']['input'];
};

export type NexoyaReport = {
  __typename?: 'Report';
  archived?: Maybe<Scalars['Boolean']['output']>;
  config?: Maybe<Scalars['String']['output']>;
  contents?: Maybe<Array<Maybe<NexoyaChannelReportContent>>>;
  dateRange: NexoyaReportDateRange;
  description?: Maybe<Scalars['String']['output']>;
  kpis: Array<NexoyaMeasurement>;
  name: Scalars['String']['output'];
  report_id: Scalars['Int']['output'];
  report_type?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<NexoyaUser>;
  updated_at: Scalars['DateTime']['output'];
};

export type NexoyaReportDateRange = {
  __typename?: 'ReportDateRange';
  customRange?: Maybe<NexoyaDateRange>;
  rangeType: Scalars['String']['output'];
};

export type NexoyaReportDateRangeInput = {
  customRange?: InputMaybe<NexoyaDateRangeRequiredInput>;
  rangeType: Scalars['String']['input'];
};

export type NexoyaReportWithSummary = {
  __typename?: 'ReportWithSummary';
  data?: Maybe<NexoyaSumReport>;
  report_id?: Maybe<Scalars['Int']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
};

export type NexoyaRequiredDateRange = {
  __typename?: 'RequiredDateRange';
  from: Scalars['Date']['output'];
  to: Scalars['Date']['output'];
};

export type NexoyaRoleDef = {
  __typename?: 'RoleDef';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type: NexoyaTeamRoleType;
};

export type NexoyaScenarioBudget = {
  __typename?: 'ScenarioBudget';
  dailyMetrics: Array<NexoyaScenarioDailyBudget>;
  totals: NexoyaScenarioTotalBudget;
};

export type NexoyaScenarioDailyBudget = {
  __typename?: 'ScenarioDailyBudget';
  baseScenario?: Maybe<Scalars['Float']['output']>;
  changePercent?: Maybe<Scalars['Float']['output']>;
  currentScenario: Scalars['Float']['output'];
  day: Scalars['Date']['output'];
};

export type NexoyaScenarioDailyMetric = {
  __typename?: 'ScenarioDailyMetric';
  costPer?: Maybe<NexoyaScenarioMetric>;
  day: Scalars['Date']['output'];
  roas?: Maybe<NexoyaScenarioMetric>;
  value: NexoyaScenarioMetric;
};

export type NexoyaScenarioFunnelStep = {
  __typename?: 'ScenarioFunnelStep';
  costPer?: Maybe<NexoyaScenarioTotalMetric>;
  dailyMetrics: Array<NexoyaScenarioDailyMetric>;
  funnelStep: NexoyaFunnelStepV2;
  isTarget: Scalars['Boolean']['output'];
  roas?: Maybe<NexoyaScenarioTotalMetric>;
  total?: Maybe<NexoyaScenarioTotalMetric>;
};

export type NexoyaScenarioMetric = {
  __typename?: 'ScenarioMetric';
  baseScenario?: Maybe<Scalars['Float']['output']>;
  changePercent?: Maybe<Scalars['Float']['output']>;
  currentScenario: Scalars['Float']['output'];
  lowerIsBetter: Scalars['Boolean']['output'];
};

export enum NexoyaScenarioReliabilityLabel {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type NexoyaScenarioTotalBudget = {
  __typename?: 'ScenarioTotalBudget';
  baseScenarioNotOptimizedTotal?: Maybe<Scalars['Float']['output']>;
  baseScenarioTotal?: Maybe<Scalars['Float']['output']>;
  changePercentTotal?: Maybe<Scalars['Float']['output']>;
  currentScenarioNotOptimizedTotal: Scalars['Float']['output'];
  currentScenarioTotal: Scalars['Float']['output'];
};

export type NexoyaScenarioTotalMetric = {
  __typename?: 'ScenarioTotalMetric';
  baseScenario?: Maybe<Scalars['Float']['output']>;
  changePercent?: Maybe<Scalars['Float']['output']>;
  currentScenario: Scalars['Float']['output'];
  currentScenarioPredictionRange: NexoyaScenarioTotalMetricPedictionRange;
  lowerIsBetter: Scalars['Boolean']['output'];
};

export type NexoyaScenarioTotalMetricPedictionRange = {
  __typename?: 'ScenarioTotalMetricPedictionRange';
  high: Scalars['Float']['output'];
  highChangePercent: Scalars['Float']['output'];
  low: Scalars['Float']['output'];
  lowChangePercent: Scalars['Float']['output'];
};

export type NexoyaSearchFilter = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum NexoyaShareType {
  Member = 'member',
  Readonly = 'readonly'
}

export enum NexoyaSharingObjectName {
  Portfolio = 'portfolio',
  Report = 'report'
}

export type NexoyaSimulation = {
  __typename?: 'Simulation';
  budget: NexoyaSimulationBudget;
  createdAt: Scalars['DateTime']['output'];
  end: Scalars['Date']['output'];
  ignoreContentBudgetLimits: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  monitoringUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  onlyVisibleToSupportUsers: Scalars['Boolean']['output'];
  portfolioEvents: Array<Maybe<NexoyaPortfolioEventSnapshot>>;
  scenario: NexoyaSimulationScenario;
  scenarios: Array<NexoyaSimulationScenario>;
  simulationId: Scalars['Float']['output'];
  skipNonOptimizedContentBudgets: Scalars['Boolean']['output'];
  start: Scalars['Date']['output'];
  state: NexoyaSimulationState;
};


export type NexoyaSimulationScenarioArgs = {
  scenarioId: Scalars['Int']['input'];
};

export type NexoyaSimulationBudget = {
  __typename?: 'SimulationBudget';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  stepCount: Scalars['Int']['output'];
  stepSize: Scalars['Int']['output'];
  steps: Array<NexoyaSimulationBudgetStep>;
};

export type NexoyaSimulationBudgetPreview = {
  __typename?: 'SimulationBudgetPreview';
  budgets: Array<NexoyaSimulationBudgetStep>;
  isDefaultScenario: Scalars['Boolean']['output'];
  stepCount: Scalars['Int']['output'];
  stepSize: Scalars['Int']['output'];
};

export type NexoyaSimulationBudgetStep = {
  __typename?: 'SimulationBudgetStep';
  budget: Scalars['Float']['output'];
  isBaseScenario: Scalars['Boolean']['output'];
  isCustomScenario: Scalars['Boolean']['output'];
};

export type NexoyaSimulationBudgetStepInput = {
  budget: Scalars['Float']['input'];
  isBaseScenario: Scalars['Boolean']['input'];
  isCustomScenario: Scalars['Boolean']['input'];
};

export type NexoyaSimulationScenario = {
  __typename?: 'SimulationScenario';
  appliedAt?: Maybe<Scalars['DateTime']['output']>;
  budget: NexoyaScenarioBudget;
  funnelSteps: Array<NexoyaScenarioFunnelStep>;
  isApplied: Scalars['Boolean']['output'];
  isBaseScenario: Scalars['Boolean']['output'];
  isCustomScenario: Scalars['Boolean']['output'];
  reliabilityLabel: NexoyaScenarioReliabilityLabel;
  scenarioId: Scalars['Float']['output'];
  targetFunnelStep: NexoyaScenarioFunnelStep;
};

export enum NexoyaSimulationState {
  Applied = 'APPLIED',
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export type NexoyaSortBy = {
  field: NexoyaSortField;
  order: NexoyaSortOrder;
};

export enum NexoyaSortField {
  Name = 'name',
  Title = 'title'
}

export enum NexoyaSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type NexoyaSubmitOptimizationFeedbackPayload = {
  __typename?: 'SubmitOptimizationFeedbackPayload';
  optimization: NexoyaOptimizationV2;
  optimizationFeedbackEventId: Scalars['Int']['output'];
  previewEligibility: NexoyaOptimizationPreviewEligibility;
};

export enum NexoyaSumGroupOption {
  Measurement = 'measurement'
}

export type NexoyaSumReport = {
  __typename?: 'SumReport';
  archived?: Maybe<Scalars['Boolean']['output']>;
  config?: Maybe<Scalars['String']['output']>;
  contents?: Maybe<Array<Maybe<NexoyaChannelReportContent>>>;
  dateRange: NexoyaReportDateRange;
  description?: Maybe<Scalars['String']['output']>;
  kpis: Array<NexoyaMeasurement>;
  name: Scalars['String']['output'];
  report_id: Scalars['Int']['output'];
  report_type?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<NexoyaUser>;
  updated_at: Scalars['DateTime']['output'];
};


export type NexoyaSumReportContentsArgs = {
  groupBy?: InputMaybe<NexoyaSumGroupOption>;
};

export enum NexoyaTargetBiddingApplyMode {
  BiddingStrategyOnly = 'BIDDING_STRATEGY_ONLY',
  BudgetAndBiddingStrategy = 'BUDGET_AND_BIDDING_STRATEGY',
  BudgetOnly = 'BUDGET_ONLY'
}

export enum NexoyaTargetItemStatus {
  Active = 'ACTIVE',
  ActiveNoOptimization = 'ACTIVE_NO_OPTIMIZATION',
  Past = 'PAST',
  Planned = 'PLANNED'
}

export type NexoyaTeam = {
  __typename?: 'Team';
  active?: Maybe<Scalars['Boolean']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customization?: Maybe<Scalars['String']['output']>;
  dashboardUrls?: Maybe<Array<Maybe<NexoyaDashboardUrl>>>;
  featureFlags?: Maybe<Array<Maybe<NexoyaTeamFeatureFlag>>>;
  /**
   * currently active KPIs
   * @deprecated Use `measurement_range`.
   */
  kpi_range?: Maybe<Array<Maybe<NexoyaKpi>>>;
  /** @deprecated Use `measurement_selected`. */
  kpi_selected?: Maybe<Array<Maybe<NexoyaKpi>>>;
  logo?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `measurement_range` root query. */
  measurement_range?: Maybe<Array<Maybe<NexoyaMeasurement>>>;
  measurement_selected?: Maybe<Array<Maybe<NexoyaMeasurement>>>;
  members: Array<Maybe<NexoyaTeamMember>>;
  name?: Maybe<Scalars['String']['output']>;
  number_format?: Maybe<Scalars['String']['output']>;
  onboarding?: Maybe<Scalars['JSON']['output']>;
  organization?: Maybe<NexoyaOrg>;
  plan: NexoyaTeamPlan;
  team_id: Scalars['Int']['output'];
};


export type NexoyaTeamKpi_RangeArgs = {
  collections?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  team_id: Scalars['Int']['input'];
};


export type NexoyaTeamMeasurement_RangeArgs = {
  collection_id?: InputMaybe<Scalars['Float']['input']>;
  collections?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  measurement_id?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  parentOnly?: InputMaybe<Scalars['Boolean']['input']>;
  providers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  where?: InputMaybe<NexoyaFilter>;
};


export type NexoyaTeamMeasurement_SelectedArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NexoyaTeamFeatureFlag = {
  __typename?: 'TeamFeatureFlag';
  name?: Maybe<NexoyaTeamFeatureFlagName>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export enum NexoyaTeamFeatureFlagName {
  AppAssistantAi = 'app_assistant_ai',
  AttributionModel = 'attribution_model',
  CalculatedMetric = 'calculated_metric',
  ContentLabelsV2 = 'content_labels_v2',
  DetailedReportV1 = 'detailed_report_v1',
  ExperimentalChatbot = 'experimental_chatbot',
  GoogleAdsCampaignManagement = 'google_ads_campaign_management',
  KpiAllHistoricData = 'kpi_all_historic_data',
  NexoyaDemo = 'nexoya_demo',
  PortfolioDashboardDisabled = 'portfolio_dashboard_disabled',
  Simulations = 'simulations',
  TrendSignals = 'trend_signals'
}

export type NexoyaTeamInfoInput = {
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type NexoyaTeamInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  org_id?: InputMaybe<Scalars['Int']['input']>;
  plan?: InputMaybe<NexoyaTeamPlan>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

export type NexoyaTeamMember = {
  __typename?: 'TeamMember';
  active?: Maybe<Scalars['Boolean']['output']>;
  email: Scalars['String']['output'];
  firstname?: Maybe<Scalars['String']['output']>;
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  role: NexoyaRoleDef;
  user_id: Scalars['Int']['output'];
};

export enum NexoyaTeamPlan {
  Premium = 'PREMIUM',
  Starter = 'STARTER'
}

export enum NexoyaTeamRoleType {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  ReadOnly = 'READ_ONLY',
  Support = 'SUPPORT'
}

export type NexoyaTeamWithOrgInput = {
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type NexoyaTenant = {
  __typename?: 'Tenant';
  name?: Maybe<Scalars['String']['output']>;
  tenant_id: Scalars['Int']['output'];
  uiCustomization?: Maybe<NexoyaTenantUiCustomization>;
};

export type NexoyaTenantUiCustomization = {
  __typename?: 'TenantUICustomization';
  faviconUrl?: Maybe<Scalars['String']['output']>;
  helpPageUrl?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  onboardingMail?: Maybe<Scalars['String']['output']>;
  pageTitlePrefix?: Maybe<Scalars['String']['output']>;
  supportMail?: Maybe<Scalars['String']['output']>;
};

export type NexoyaTranslation = {
  __typename?: 'Translation';
  key: Scalars['String']['output'];
  lang: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type NexoyaTrendSignal = {
  __typename?: 'TrendSignal';
  createdAt: Scalars['DateTime']['output'];
  /** Set for CUSTOM signals once their CSV file is uploaded */
  csvFile?: Maybe<NexoyaTrendSignalCsvFile>;
  /** Set for GOOGLE_TRENDS_KEYWORD signals only */
  keyword?: Maybe<Scalars['String']['output']>;
  /** Set for WEATHER signals only, the code and name of the location option it was created with */
  location?: Maybe<NexoyaTrendSignalOption>;
  /** Set for WEATHER signals only, a code of weatherTrendSignalOptions.measures */
  measure?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** IDs of the portfolios whose optimizations use the signal */
  portfolioIds: Array<Scalars['Int']['output']>;
  /** Set for GOOGLE_TRENDS_KEYWORD signals only, a code of googleTrendsKeywordOptions.regions */
  region?: Maybe<Scalars['String']['output']>;
  /** Set for GOOGLE_TRENDS_KEYWORD signals only, a code of googleTrendsKeywordOptions.sources */
  source?: Maybe<Scalars['String']['output']>;
  teamId: Scalars['Int']['output'];
  /** Set for GOOGLE_TRENDS_KEYWORD signals only, a code of googleTrendsKeywordOptions.timePeriods */
  timePeriod?: Maybe<Scalars['String']['output']>;
  timeSeries: NexoyaTrendSignalTimeSeries;
  trendSignalId: Scalars['String']['output'];
  type: NexoyaTrendSignalType;
  updatedAt: Scalars['DateTime']['output'];
};

export type NexoyaTrendSignalCsvFile = {
  __typename?: 'TrendSignalCsvFile';
  dataType: NexoyaTrendSignalTimeSeriesDataType;
  dateColumn: Scalars['String']['output'];
  fileBlob: NexoyaFile;
  valueColumn: Scalars['String']['output'];
};

/** A selectable value: the code is sent back to the API, the name is shown to users */
export type NexoyaTrendSignalOption = {
  __typename?: 'TrendSignalOption';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type NexoyaTrendSignalTimeSeries = {
  __typename?: 'TrendSignalTimeSeries';
  dataPoints: Array<NexoyaTrendSignalTimeSeriesDataPoint>;
  /** Set while the status is INGESTED or STALE */
  dataType?: Maybe<NexoyaTrendSignalTimeSeriesDataType>;
  /** Set while the status is ERROR */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Set while the status is INGESTED or STALE */
  firstDate?: Maybe<Scalars['Date']['output']>;
  /** Set while the status is INGESTED or STALE */
  ingestedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Set while the status is INGESTED or STALE */
  lastDate?: Maybe<Scalars['Date']['output']>;
  /** Set while the status is STALE: when the data was found to be older than the signal's type allows */
  staleSince?: Maybe<Scalars['DateTime']['output']>;
  status: NexoyaTrendSignalTimeSeriesStatus;
};


export type NexoyaTrendSignalTimeSeriesDataPointsArgs = {
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
};

export type NexoyaTrendSignalTimeSeriesDataPoint = {
  __typename?: 'TrendSignalTimeSeriesDataPoint';
  date: Scalars['Date']['output'];
  value: Scalars['Float']['output'];
};

export enum NexoyaTrendSignalTimeSeriesDataType {
  Celsius = 'CELSIUS',
  Currency = 'CURRENCY',
  Fahrenheit = 'FAHRENHEIT',
  Number = 'NUMBER',
  Percent = 'PERCENT'
}

export enum NexoyaTrendSignalTimeSeriesStatus {
  Error = 'ERROR',
  Ingested = 'INGESTED',
  None = 'NONE',
  Pending = 'PENDING',
  /** The data is older than the signal's type allows and needs an update, but is still used */
  Stale = 'STALE'
}

export enum NexoyaTrendSignalType {
  Custom = 'CUSTOM',
  GoogleTrendsKeyword = 'GOOGLE_TRENDS_KEYWORD',
  Weather = 'WEATHER'
}

export type NexoyaUpdateAttributionModelInput = {
  channelFilters?: InputMaybe<Array<NexoyaAttributionModelChannelFilterInput>>;
  customization?: InputMaybe<NexoyaAttributionModelCustomizationInput>;
  exportStart?: InputMaybe<Scalars['Date']['input']>;
  ga4Filters?: InputMaybe<NexoyaAttributionModelGa4FiltersInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  targetMetric?: InputMaybe<Scalars['String']['input']>;
  targetMetricType?: InputMaybe<NexoyaAttributionModelTargetMetricType>;
};

export type NexoyaUpdateAttributionRuleFiltersContentActionInput = {
  applyAttributionRuleId?: InputMaybe<Scalars['Float']['input']>;
  contentId: Scalars['Float']['input'];
};

export type NexoyaUpdateAttributionRuleFiltersMutationResponse = {
  __typename?: 'UpdateAttributionRuleFiltersMutationResponse';
  updatedAttributionRule: NexoyaAttributionRule;
};

export type NexoyaUpdateContentRuleAndContentsMutationResponse = {
  __typename?: 'UpdateContentRuleAndContentsMutationResponse';
  updatedContentRule: NexoyaContentRule;
};

export type NexoyaUpdateContentRuleFiltersContentActionInput = {
  applyContentRuleId?: InputMaybe<Scalars['Float']['input']>;
  contentId: Scalars['Float']['input'];
  removeFromPortfolio: Scalars['Boolean']['input'];
};

export type NexoyaUpdateContentRuleFunnelStepMappingsMutationResponse = {
  __typename?: 'UpdateContentRuleFunnelStepMappingsMutationResponse';
  clashingDiscoveredContents: Array<NexoyaDiscoveredContent>;
  contentRule: NexoyaContentRule;
};

export type NexoyaUpdateImpactGroupRuleAndContentsMutationResponse = {
  __typename?: 'UpdateImpactGroupRuleAndContentsMutationResponse';
  updatedImpactGroupRule: NexoyaImpactGroupRule;
};

export type NexoyaUpdateImpactGroupRuleFiltersContentActionInput = {
  applyImpactGroupRuleId?: InputMaybe<Scalars['Float']['input']>;
  contentId: Scalars['Float']['input'];
  removeImpactGroupAssignment: Scalars['Boolean']['input'];
};

export type NexoyaUpdatePortfolioEventMutationResponse = {
  __typename?: 'UpdatePortfolioEventMutationResponse';
  updatedPortfolioEvent?: Maybe<NexoyaPortfolioEvent>;
};

export type NexoyaUpsertImpactGroupInput = {
  funnelStepIds: Array<Scalars['Int']['input']>;
  impactGroupId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type NexoyaUpsertPortfolioFunnelStepsMutationFunnelStepInput = {
  funnelStepId?: InputMaybe<Scalars['Int']['input']>;
  resetMetrics?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type: NexoyaFunnelStepType;
};

export type NexoyaUser = {
  __typename?: 'User';
  active?: Maybe<Scalars['Boolean']['output']>;
  activeRole?: Maybe<NexoyaRoleDef>;
  email: Scalars['String']['output'];
  firstname?: Maybe<Scalars['String']['output']>;
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  slackUserId?: Maybe<Scalars['String']['output']>;
  state?: Maybe<NexoyaUserStateEnum>;
  teams?: Maybe<Array<Maybe<NexoyaTeam>>>;
  user_id: Scalars['Int']['output'];
};


export type NexoyaUserActiveRoleArgs = {
  team_id: Scalars['Int']['input'];
};

export type NexoyaUserInfo = {
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
};

export enum NexoyaUserStateEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Onboarding = 'ONBOARDING'
}

export type NexoyaValidation = {
  __typename?: 'Validation';
  tooltip?: Maybe<NexoyaValidationTooltip>;
  validationPerformance?: Maybe<Array<Maybe<NexoyaValidationPerformance>>>;
  validationReport?: Maybe<Array<Maybe<NexoyaValidationReportRows>>>;
};


export type NexoyaValidationTooltipArgs = {
  funnelStepId: Scalars['Int']['input'];
};

export type NexoyaValidationData = {
  __typename?: 'ValidationData';
  achieved: Scalars['Float']['output'];
  nonOptimized: Scalars['Float']['output'];
  optimized: Scalars['Float']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type NexoyaValidationDataTotal = {
  __typename?: 'ValidationDataTotal';
  costPerAchieved: Scalars['Float']['output'];
  costPerNonOptimized: Scalars['Float']['output'];
  costPerOptimized: Scalars['Float']['output'];
  gainLossCostPer: Scalars['Float']['output'];
  gainLossTotal: Scalars['Float']['output'];
  totalAchieved: Scalars['Float']['output'];
  totalNonOptimized: Scalars['Float']['output'];
  totalOptimized: Scalars['Float']['output'];
};

export type NexoyaValidationPerfomanceTooltip = {
  __typename?: 'ValidationPerfomanceTooltip';
  achieved: Scalars['Float']['output'];
  nonOptimized: Scalars['Float']['output'];
  optimized: Scalars['Float']['output'];
};

export type NexoyaValidationPerformance = {
  __typename?: 'ValidationPerformance';
  funnelStep: NexoyaFunnelStep;
  validationData?: Maybe<Array<NexoyaValidationData>>;
  validationDataTotal?: Maybe<NexoyaValidationDataTotal>;
  validationTooltip?: Maybe<NexoyaValidationPerfomanceTooltip>;
};

export type NexoyaValidationReportRows = {
  __typename?: 'ValidationReportRows';
  budgetChanges?: Maybe<NexoyaValidationReportBudgetChanges>;
  channelTitle?: Maybe<Scalars['String']['output']>;
  contentTitle?: Maybe<Scalars['String']['output']>;
  parentContentTitle?: Maybe<Scalars['String']['output']>;
  spendings?: Maybe<NexoyaValidationReportSpendings>;
  valuesPerFunnel?: Maybe<Array<Maybe<NexoyaValidationReportValuesPerFunnel>>>;
};

export type NexoyaValidationTooltip = {
  __typename?: 'ValidationTooltip';
  funnelStep: NexoyaFunnelStep;
  validationData?: Maybe<Array<NexoyaValidationData>>;
  validationDataTotal?: Maybe<NexoyaValidationDataTotal>;
};

export type NexoyaWeatherTrendSignalCreateInput = {
  /** A code of weatherTrendSignalOptions.predefinedLocations or of a searchWeatherLocations result */
  location: Scalars['String']['input'];
  /** A code of weatherTrendSignalOptions.measures */
  measure: Scalars['String']['input'];
};

export type NexoyaWeatherTrendSignalOptions = {
  __typename?: 'WeatherTrendSignalOptions';
  measures: Array<NexoyaTrendSignalOption>;
  /** Locations offered before the user searches with searchWeatherLocations */
  predefinedLocations: Array<NexoyaTrendSignalOption>;
};

export enum NexoyaWeekday {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type NexoyaFilterListType = {
  __typename?: 'filterListType';
  id?: Maybe<Scalars['String']['output']>;
  itemInfo?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  selected?: Maybe<Scalars['Boolean']['output']>;
};

export type NexoyaUpdateContentRelationPayload = {
  __typename?: 'updateContentRelationPayload';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  warning?: Maybe<Scalars['String']['output']>;
};

export type NexoyaValidationReportBudgetChanges = {
  __typename?: 'validationReportBudgetChanges';
  applicationDelta?: Maybe<Scalars['Float']['output']>;
  appliedPctChange?: Maybe<Scalars['Float']['output']>;
  suggestedPctChange?: Maybe<Scalars['Float']['output']>;
};

export type NexoyaValidationReportSpendings = {
  __typename?: 'validationReportSpendings';
  baseline?: Maybe<Scalars['Float']['output']>;
  proposed?: Maybe<Scalars['Float']['output']>;
  spent?: Maybe<Scalars['Float']['output']>;
};

export type NexoyaValidationReportValuesPerFunnel = {
  __typename?: 'validationReportValuesPerFunnel';
  achieved?: Maybe<Scalars['Float']['output']>;
  costPer?: Maybe<Scalars['Float']['output']>;
  funnelStepId?: Maybe<Scalars['Int']['output']>;
  funnelStepTitle?: Maybe<Scalars['String']['output']>;
  nonOptimized?: Maybe<Scalars['Float']['output']>;
  optimized?: Maybe<Scalars['Float']['output']>;
};

export type NexoyaRemoveUserMutationVariables = Exact<{
  team_id: Scalars['Int']['input'];
  user_to_remove_id: Scalars['Int']['input'];
}>;


export type NexoyaRemoveUserMutation = { __typename?: 'Mutation', removeUser?: boolean | null };


export const RemoveUserDocument = gql`
    mutation RemoveUser($team_id: Int!, $user_to_remove_id: Int!) {
  removeUser(team_id: $team_id, user_to_remove_id: $user_to_remove_id)
}
    `;
export type NexoyaRemoveUserMutationFn = Apollo.MutationFunction<NexoyaRemoveUserMutation, NexoyaRemoveUserMutationVariables>;

/**
 * __useRemoveUserMutation__
 *
 * To run a mutation, you first call `useRemoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserMutation, { data, loading, error }] = useRemoveUserMutation({
 *   variables: {
 *      team_id: // value for 'team_id'
 *      user_to_remove_id: // value for 'user_to_remove_id'
 *   },
 * });
 */
export function useRemoveUserMutation(baseOptions?: Apollo.MutationHookOptions<NexoyaRemoveUserMutation, NexoyaRemoveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NexoyaRemoveUserMutation, NexoyaRemoveUserMutationVariables>(RemoveUserDocument, options);
      }
export type RemoveUserMutationHookResult = ReturnType<typeof useRemoveUserMutation>;
export type RemoveUserMutationResult = Apollo.MutationResult<NexoyaRemoveUserMutation>;
export type RemoveUserMutationOptions = Apollo.BaseMutationOptions<NexoyaRemoveUserMutation, NexoyaRemoveUserMutationVariables>;